// // // // "use client";

// // // // import { useState, useEffect } from "react";
// // // // import {
// // // //   Grid,
// // // //   Card,
// // // //   Typography,
// // // //   Button,
// // // //   Box,
// // // //   Chip,
// // // //   LinearProgress,
// // // //   List,
// // // //   ListItem,
// // // //   ListItemText,
// // // //   ListItemIcon,
// // // //   Avatar,
// // // //   Stack,
// // // //   Skeleton,
// // // //   alpha,
// // // //   Container,
// // // //   CircularProgress,
// // // //   Dialog,
// // // //   DialogTitle,
// // // //   DialogContent,
// // // //   DialogActions,
// // // //   IconButton,
// // // //   darken,
// // // // } from "@mui/material";
// // // // import {
// // // //   TrendingUp,
// // // //   LocationOn,
// // // //   ArrowForward,
// // // //   CheckCircle,
// // // //   Close as CloseIcon,
// // // //   AttachMoney,
// // // //   Event,
// // // //   Beenhere,
// // // //   WorkOutline,
// // // //   BookmarkBorder,
// // // //   AccessTime,
// // // // } from "@mui/icons-material";
// // // // import Layout from "../components/common/Layout";
// // // // import { useNavigate } from "react-router-dom";
// // // // import { useTheme } from "@mui/material/styles";
// // // // import apiClient from "../context/apiClient";

// // // // const JobDetailsModal = ({ open, onClose, job }) => {
// // // //   const theme = useTheme();
// // // //   if (!job) return null;
// // // //   return (
// // // //     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
// // // //       <DialogTitle sx={{ m: 0, p: 2, pr: 8, bgcolor: "#F1FFFA" }}>
// // // //         <Stack direction="row" spacing={2} alignItems="center">
// // // //           <Avatar
// // // //             src={job.company_details?.logo}
// // // //             variant="rounded"
// // // //             sx={{ width: 56, height: 56 }}
// // // //           />
// // // //           <Box>
// // // //             <Typography variant="h5" component="div" fontWeight={700}>
// // // //               {job.title}
// // // //             </Typography>
// // // //             <Typography variant="body1" color="text.secondary">
// // // //               {job.company_details?.company_name}
// // // //             </Typography>
// // // //           </Box>
// // // //         </Stack>
// // // //         <IconButton
// // // //           aria-label="close"
// // // //           onClick={onClose}
// // // //           sx={{
// // // //             position: "absolute",
// // // //             right: 8,
// // // //             top: 8,
// // // //             color: "text.secondary",
// // // //           }}
// // // //         >
// // // //           <CloseIcon />
// // // //         </IconButton>
// // // //       </DialogTitle>
// // // //       <DialogContent dividers sx={{ bgcolor: "#F1FFFA" }}>
// // // //         <Stack
// // // //           direction="row"
// // // //           spacing={1}
// // // //           useFlexGap
// // // //           flexWrap="wrap"
// // // //           sx={{ mb: 3 }}
// // // //         >
// // // //           <Chip icon={<LocationOn />} label={job.location} variant="outlined" />
// // // //           <Chip
// // // //             icon={<WorkOutline />}
// // // //             label={job.job_type_display}
// // // //             variant="outlined"
// // // //           />
// // // //           <Chip
// // // //             icon={<TrendingUp />}
// // // //             label={job.experience_level_display}
// // // //             variant="outlined"
// // // //           />
// // // //           {job.remote_work && (
// // // //             <Chip label="Remote Available" color="success" variant="outlined" />
// // // //           )}
// // // //           {job.visa_sponsorship && (
// // // //             <Chip
// // // //               label="Visa Sponsorship"
// // // //               sx={{
// // // //                 backgroundColor: "primary.main",
// // // //                 color: "primary.contrastText",
// // // //                 fontWeight: 500,
// // // //               }}
// // // //             />
// // // //           )}
// // // //         </Stack>
// // // //         {job.salary_min && job.salary_max && (
// // // //           <Box
// // // //             display="flex"
// // // //             alignItems="center"
// // // //             mb={3}
// // // //             p={2}
// // // //             bgcolor={alpha(theme.palette.success.main, 0.1)}
// // // //             borderRadius={2}
// // // //           >
// // // //             <AttachMoney sx={{ mr: 1, color: "success.main" }} />
// // // //             <Typography
// // // //               variant="h6"
// // // //               component="p"
// // // //               fontWeight={600}
// // // //               color="success.dark"
// // // //             >
// // // //               {`${new Intl.NumberFormat("en-US", {
// // // //                 style: "currency",
// // // //                 currency: job.salary_currency || "USD",
// // // //               }).format(job.salary_min)} - ${new Intl.NumberFormat("en-US", {
// // // //                 style: "currency",
// // // //                 currency: job.salary_currency || "USD",
// // // //               }).format(job.salary_max)}`}
// // // //             </Typography>
// // // //           </Box>
// // // //         )}
// // // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // // //           Job Description
// // // //         </Typography>
// // // //         <Typography
// // // //           variant="body2"
// // // //           sx={{
// // // //             whiteSpace: "pre-wrap",
// // // //             mb: 3,
// // // //             color: "text.secondary",
// // // //             lineHeight: 1.7,
// // // //           }}
// // // //         >
// // // //           {job.description}
// // // //         </Typography>
// // // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // // //           Responsibilities
// // // //         </Typography>
// // // //         <Typography
// // // //           variant="body2"
// // // //           sx={{
// // // //             whiteSpace: "pre-wrap",
// // // //             mb: 3,
// // // //             color: "text.secondary",
// // // //             lineHeight: 1.7,
// // // //           }}
// // // //         >
// // // //           {job.responsibilities}
// // // //         </Typography>
// // // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // // //           Requirements
// // // //         </Typography>
// // // //         <List dense sx={{ mb: 2 }}>
// // // //           {job.requirements?.map((req, i) => (
// // // //             <ListItem key={i} disableGutters>
// // // //               <ListItemIcon sx={{ minWidth: 32 }}>
// // // //                 <CheckCircle color="primary" fontSize="small" />
// // // //               </ListItemIcon>
// // // //               <ListItemText primary={req} />
// // // //             </ListItem>
// // // //           ))}
// // // //         </List>
// // // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // // //           Required Skills
// // // //         </Typography>
// // // //         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
// // // //           {job.required_skills?.map((skill, i) => (
// // // //             <Chip key={i} label={skill} variant="outlined" />
// // // //           ))}
// // // //         </Box>
// // // //         {job.benefits?.length > 0 && (
// // // //           <>
// // // //             <Typography variant="h6" gutterBottom fontWeight={700}>
// // // //               Benefits
// // // //             </Typography>
// // // //             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
// // // //               {job.benefits.map((benefit, i) => (
// // // //                 <Chip
// // // //                   key={i}
// // // //                   icon={<Beenhere />}
// // // //                   label={benefit}
// // // //                   variant="outlined"
// // // //                   color="success"
// // // //                 />
// // // //               ))}
// // // //             </Box>
// // // //           </>
// // // //         )}
// // // //         {job.application_deadline && (
// // // //           <Box
// // // //             display="flex"
// // // //             alignItems="center"
// // // //             mt={2}
// // // //             p={1.5}
// // // //             bgcolor={alpha(theme.palette.warning.main, 0.1)}
// // // //             borderRadius={2}
// // // //           >
// // // //             <Event sx={{ mr: 1, color: "warning.main" }} />
// // // //             <Typography
// // // //               variant="body2"
// // // //               component="p"
// // // //               fontWeight={600}
// // // //               color="warning.dark"
// // // //             >
// // // //               Application Deadline:{" "}
// // // //               {new Date(job.application_deadline).toLocaleDateString()}
// // // //             </Typography>
// // // //           </Box>
// // // //         )}
// // // //       </DialogContent>
// // // //       <DialogActions sx={{ p: { xs: 2, sm: 3 }, bgcolor: "#F1FFFA" }}>
// // // //         <Button onClick={onClose} color="inherit">
// // // //           Close
// // // //         </Button>
// // // //       </DialogActions>
// // // //     </Dialog>
// // // //   );
// // // // };

// // // // const WelcomeCardSkeleton = () => (
// // // //   <Card
// // // //     elevation={0}
// // // //     sx={{
// // // //       p: { xs: 2, md: 3 },
// // // //       borderRadius: "16px",
// // // //       bgcolor: "mint.main",
// // // //       boxShadow: "none",
// // // //     }}
// // // //   >
// // // //     <Stack
// // // //       direction={{ xs: "column", sm: "row" }}
// // // //       spacing={2}
// // // //       alignItems="center"
// // // //     >
// // // //       <Skeleton variant="circular" width={60} height={60} />
// // // //       <Box flexGrow={1} sx={{ width: "100%" }}>
// // // //         <Skeleton variant="text" width="40%" height={32} />
// // // //         <Skeleton variant="text" width="60%" height={24} />
// // // //         <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 1 }}>
// // // //           <Skeleton
// // // //             variant="rectangular"
// // // //             height={8}
// // // //             sx={{ flexGrow: 1, borderRadius: "4px" }}
// // // //           />
// // // //           <Skeleton variant="text" width="25%" height={24} />
// // // //         </Stack>
// // // //       </Box>
// // // //       <Skeleton
// // // //         variant="rectangular"
// // // //         height={44}
// // // //         width={180}
// // // //         sx={{ borderRadius: "20px" }}
// // // //       />
// // // //     </Stack>
// // // //   </Card>
// // // // );

// // // // const StatCardSkeleton = () => (
// // // //   <Skeleton
// // // //     variant="rectangular"
// // // //     sx={{ borderRadius: "20px", height: { xs: 100, sm: 120 } }}
// // // //   />
// // // // );

// // // // const SectionSkeleton = ({
// // // //   titleWidth = 200,
// // // //   items = 3,
// // // //   CardSkeletonComponent,
// // // // }) => (
// // // //   <Card
// // // //     elevation={0}
// // // //     sx={{
// // // //       p: { xs: 2, md: 4 },
// // // //       borderRadius: "20px",
// // // //       bgcolor: "mint.main",
// // // //       height: "100%",
// // // //     }}
// // // //   >
// // // //     <Skeleton variant="text" width={titleWidth} height={40} sx={{ mb: 3 }} />
// // // //     <Grid container spacing={2.5}>
// // // //       {[...Array(items)].map((_, index) =>
// // // //         CardSkeletonComponent ? <CardSkeletonComponent key={index} /> : null
// // // //       )}
// // // //     </Grid>
// // // //     <Box sx={{ textAlign: "center", pt: 3 }}>
// // // //       <Skeleton
// // // //         variant="rectangular"
// // // //         width={250}
// // // //         height={40}
// // // //         sx={{ borderRadius: "30px", mx: "auto" }}
// // // //       />
// // // //     </Box>
// // // //   </Card>
// // // // );

// // // // const RecentApplicationSkeletonCard = () => (
// // // //   <Grid item xs={12}>
// // // //     <Card
// // // //       elevation={0}
// // // //       sx={{
// // // //         p: 2,
// // // //         borderRadius: "20px",
// // // //         bgcolor: "#F1FFFA",
// // // //         border: (theme) => `1px solid ${theme.palette.divider}`,
// // // //       }}
// // // //     >
// // // //       <Stack spacing={2} justifyContent="space-between" height="100%">
// // // //         <Stack direction="row" spacing={1.5} alignItems="center">
// // // //           <Skeleton variant="circular" width={48} height={48} />
// // // //           <Box>
// // // //             <Skeleton variant="text" width={120} height={28} />
// // // //             <Skeleton variant="text" width={100} height={20} />
// // // //           </Box>
// // // //         </Stack>
// // // //         <Skeleton
// // // //           variant="rectangular"
// // // //           width={100}
// // // //           height={32}
// // // //           sx={{ borderRadius: "16px", alignSelf: "flex-end" }}
// // // //         />
// // // //       </Stack>
// // // //     </Card>
// // // //   </Grid>
// // // // );

// // // // const JobRecommendationSkeletonCard = () => (
// // // //   <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
// // // //     <Card
// // // //       elevation={0}
// // // //       sx={{
// // // //         p: 3,
// // // //         borderRadius: "20px",
// // // //         border: (theme) => `1px solid ${theme.palette.divider}`,
// // // //         bgcolor: "background.paper",
// // // //         height: "100%",
// // // //         width: "100%",
// // // //         display: "flex",
// // // //         flexDirection: "column",
// // // //         gap: 1.5,
// // // //       }}
// // // //     >
// // // //       <Stack
// // // //         direction="row"
// // // //         justifyContent="space-between"
// // // //         alignItems="flex-start"
// // // //       >
// // // //         <Box>
// // // //           <Skeleton variant="text" width={150} height={28} />
// // // //           <Skeleton variant="text" width={100} height={20} />
// // // //         </Box>
// // // //         <Skeleton variant="circular" width={24} height={24} />
// // // //       </Stack>
// // // //       <Stack spacing={0.5}>
// // // //         <Skeleton variant="text" width="50%" />
// // // //         <Skeleton variant="text" width="70%" />
// // // //         <Skeleton variant="text" width="40%" />
// // // //       </Stack>
// // // //       <Box>
// // // //         <Stack
// // // //           direction="row"
// // // //           justifyContent="space-between"
// // // //           alignItems="center"
// // // //         >
// // // //           <Skeleton variant="text" width="30%" />
// // // //           <Skeleton variant="text" width="20%" />
// // // //         </Stack>
// // // //         <Skeleton
// // // //           variant="rectangular"
// // // //           height={6}
// // // //           sx={{ mt: 1, borderRadius: 3 }}
// // // //         />
// // // //       </Box>
// // // //       <Box>
// // // //         <Skeleton variant="text" width="40%" sx={{ mb: 1 }} />
// // // //         <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1}>
// // // //           <Skeleton
// // // //             variant="rectangular"
// // // //             width={80}
// // // //             height={24}
// // // //             sx={{ borderRadius: "16px" }}
// // // //           />
// // // //           <Skeleton
// // // //             variant="rectangular"
// // // //             width={90}
// // // //             height={24}
// // // //             sx={{ borderRadius: "16px" }}
// // // //           />
// // // //         </Stack>
// // // //       </Box>
// // // //       <Stack direction="row" spacing={1.5} sx={{ mt: "auto", pt: 2 }}>
// // // //         <Skeleton
// // // //           variant="rectangular"
// // // //           width="100%"
// // // //           height={40}
// // // //           sx={{ borderRadius: "30px" }}
// // // //         />
// // // //         <Skeleton
// // // //           variant="rectangular"
// // // //           width="100%"
// // // //           height={40}
// // // //           sx={{ borderRadius: "30px" }}
// // // //         />
// // // //       </Stack>
// // // //     </Card>
// // // //   </Grid>
// // // // );

// // // // const SkillsAndLanguagesSkeleton = () => (
// // // //   <Grid container spacing={3}>
// // // //     <Grid item xs={12} md={8}>
// // // //       <Card
// // // //         elevation={0}
// // // //         sx={{
// // // //           p: 3,
// // // //           borderRadius: "12px",
// // // //           bgcolor: "mint.main",
// // // //           boxShadow: (theme) =>
// // // //             `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// // // //           height: "100%",
// // // //         }}
// // // //       >
// // // //         <Skeleton variant="text" width="40%" height={32} />
// // // //         <Skeleton
// // // //           variant="text"
// // // //           width="30%"
// // // //           height={24}
// // // //           sx={{ mt: 1, mb: 2 }}
// // // //         />
// // // //         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 3 }}>
// // // //           {[...Array(8)].map((_, i) => (
// // // //             <Skeleton
// // // //               key={i}
// // // //               variant="rectangular"
// // // //               width={100}
// // // //               height={36}
// // // //               sx={{ borderRadius: "20px" }}
// // // //             />
// // // //           ))}
// // // //         </Box>
// // // //       </Card>
// // // //     </Grid>
// // // //     <Grid item xs={12} md={4}>
// // // //       <Card
// // // //         elevation={0}
// // // //         sx={{
// // // //           p: 3,
// // // //           borderRadius: "12px",
// // // //           bgcolor: "mint.main",
// // // //           boxShadow: (theme) =>
// // // //             `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// // // //           height: "100%",
// // // //         }}
// // // //       >
// // // //         <Skeleton variant="text" width="50%" height={32} sx={{ mb: 3 }} />
// // // //         <Grid container spacing={1.5} sx={{ mb: 3 }}>
// // // //           {[...Array(6)].map((_, i) => (
// // // //             <Grid item xs={6} key={i}>
// // // //               <Skeleton
// // // //                 variant="rectangular"
// // // //                 width="100%"
// // // //                 height={36}
// // // //                 sx={{ borderRadius: "20px" }}
// // // //               />
// // // //             </Grid>
// // // //           ))}
// // // //         </Grid>
// // // //       </Card>
// // // //     </Grid>
// // // //   </Grid>
// // // // );

// // // // const mapApplicationStatus = (apiStatus) => {
// // // //   switch (apiStatus) {
// // // //     case "SCHEDULED":
// // // //       return "Interview Scheduled";
// // // //     case "UNDER_REVIEW":
// // // //     case "REVIEW":
// // // //       return "Under Review";
// // // //     case "APPLIED":
// // // //       return "Applied";
// // // //     case "SHORTLISTED":
// // // //       return "Shortlisted";
// // // //     default:
// // // //       return apiStatus;
// // // //   }
// // // // };

// // // // // const StatCard = ({ value, label, blobColor }) => {
// // // // //   const theme = useTheme();
// // // // //   const primaryBlobColor =
// // // // //     blobColor || theme.palette.secondary.light || theme.palette.secondary.main;
// // // // //   const darkerBlobColor = darken(primaryBlobColor, 0.1);

// // // // //   return (
// // // // //     <Card
// // // // //       elevation={0}
// // // // //       sx={{
// // // // //         bgcolor: "primary.main",
// // // // //         borderRadius: "20px",
// // // // //         boxShadow: (theme) =>
// // // // //           `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
// // // // //         p: { xs: 2, sm: 3 },
// // // // //         position: "relative",
// // // // //         overflow: "hidden",
// // // // //         color: "primary.contrastText",
// // // // //         height: "160px",
// // // // //         width: "280px",
// // // // //         minWidth: "280px",
// // // // //         maxWidth: "280px",
// // // // //         margin: "0 auto",
// // // // //         display: "flex",
// // // // //         flexDirection: "column",
// // // // //         justifyContent: "center",
// // // // //         flexShrink: 0,
// // // // //       }}
// // // // //     >
// // // // //       <Box
// // // // //         sx={{
// // // // //           position: "absolute",
// // // // //           top: 0,
// // // // //           right: 0,
// // // // //           bottom: 0,
// // // // //           width: "50%",
// // // // //           zIndex: 0,
// // // // //         }}
// // // // //       >
// // // // //         <svg
// // // // //           width="100%"
// // // // //           height="100%"
// // // // //           viewBox="0 0 80 120"
// // // // //           preserveAspectRatio="none"
// // // // //           style={{
// // // // //             filter: `drop-shadow(-4px 4px 8px ${alpha(
// // // // //               theme.palette.common.black,
// // // // //               0.2
// // // // //             )})`,
// // // // //           }}
// // // // //         >
// // // // //           <path
// // // // //             d="M 20,0 C 80,30 0,90 20,120 L 80,120 L 80,0 Z"
// // // // //             fill={darkerBlobColor}
// // // // //           />
// // // // //           <path
// // // // //             d="M 30,0 C 90,30 10,90 30,120 L 80,120 L 80,0 Z"
// // // // //             fill={primaryBlobColor}
// // // // //           />
// // // // //         </svg>
// // // // //       </Box>
// // // // //       <Stack sx={{ position: "relative", zIndex: 1 }}>
// // // // //         <Typography
// // // // //           sx={{
// // // // //             textTransform: "uppercase",
// // // // //             fontFamily: "'Poppins', sans-serif",
// // // // //             fontSize: "14px",
// // // // //             fontWeight: 500,
// // // // //             color: alpha(theme.palette.primary.contrastText, 0.7),
// // // // //             mb: 0.5,
// // // // //           }}
// // // // //         >
// // // // //           {label}
// // // // //         </Typography>
// // // // //         <Typography
// // // // //           sx={{
// // // // //             fontFamily: "'Poppins', sans-serif",
// // // // //             fontSize: "36px",
// // // // //             fontWeight: 700,
// // // // //             color: "primary.contrastText",
// // // // //             lineHeight: 1.2,
// // // // //           }}
// // // // //         >
// // // // //           {value}
// // // // //         </Typography>
// // // // //       </Stack>
// // // // //     </Card>
// // // // //   );
// // // // // };

// // // // const StatCard = ({ value, label, blobColor }) => {
// // // //   const theme = useTheme();
// // // //   const primaryBlobColor =
// // // //     blobColor || theme.palette.secondary.light || theme.palette.secondary.main;
// // // //   const darkerBlobColor = darken(primaryBlobColor, 0.1);

// // // //   return (
// // // //     <Card
// // // //       elevation={0}
// // // //       sx={{
// // // //         bgcolor: "primary.main",
// // // //         borderRadius: "20px",
// // // //         boxShadow: (theme) =>
// // // //           `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
// // // //         p: { xs: 1.5, sm: 3 }, // Slightly reduced padding on mobile
// // // //         position: "relative",
// // // //         overflow: "hidden",
// // // //         color: "primary.contrastText",
// // // //         display: "flex",
// // // //         flexDirection: "column",
// // // //         justifyContent: "center",

// // // //         // --- THE CRITICAL FIX ---
// // // //         flex: { xs: 1, sm: "none" }, // On mobile, be a flexible item (take 1/3 space).
// // // //         width: { xs: "auto", sm: 280 }, // On desktop, use a fixed width.
// // // //         minWidth: { xs: 0, sm: 280 }, // On mobile, allow shrinking to prevent overflow.
// // // //         height: { xs: 120, sm: 160 }, // Responsive height.
// // // //         // --- END OF FIX ---
// // // //       }}
// // // //     >
// // // //       <Box
// // // //         sx={{
// // // //           position: "absolute",
// // // //           top: 0,
// // // //           right: 0,
// // // //           bottom: 0,
// // // //           width: "50%",
// // // //           zIndex: 0,
// // // //         }}
// // // //       >
// // // //         <svg
// // // //           width="100%"
// // // //           height="100%"
// // // //           viewBox="0 0 80 120"
// // // //           preserveAspectRatio="none"
// // // //           style={{
// // // //             filter: `drop-shadow(-4px 4px 8px ${alpha(
// // // //               theme.palette.common.black,
// // // //               0.2
// // // //             )})`,
// // // //           }}
// // // //         >
// // // //           <path
// // // //             d="M 20,0 C 80,30 0,90 20,120 L 80,120 L 80,0 Z"
// // // //             fill={darkerBlobColor}
// // // //           />
// // // //           <path
// // // //             d="M 30,0 C 90,30 10,90 30,120 L 80,120 L 80,0 Z"
// // // //             fill={primaryBlobColor}
// // // //           />
// // // //         </svg>
// // // //       </Box>
// // // //       <Stack sx={{ position: "relative", zIndex: 1 }}>
// // // //         <Typography
// // // //           sx={{
// // // //             textTransform: "uppercase",
// // // //             fontFamily: "'Poppins', sans-serif",
// // // //             fontSize: { xs: "11px", sm: "14px" }, // Responsive font
// // // //             fontWeight: 500,
// // // //             color: alpha(theme.palette.primary.contrastText, 0.7),
// // // //             mb: 0.5,
// // // //           }}
// // // //         >
// // // //           {label}
// // // //         </Typography>
// // // //         <Typography
// // // //           sx={{
// // // //             fontFamily: "'Poppins', sans-serif",
// // // //             fontSize: { xs: "28px", sm: "36px" }, // Responsive font
// // // //             fontWeight: 700,
// // // //             color: "primary.contrastText",
// // // //             lineHeight: 1.1,
// // // //           }}
// // // //         >
// // // //           {value}
// // // //         </Typography>
// // // //       </Stack>
// // // //     </Card>
// // // //   );
// // // // };

// // // // const TalentDashboard = () => {
// // // //   const navigate = useNavigate();
// // // //   const theme = useTheme();
// // // //   const [applications, setApplications] = useState([]);
// // // //   const [recommendations, setRecommendations] = useState([]);
// // // //   const [technicalSkills, setTechnicalSkills] = useState([]);
// // // //   const [languages, setLanguages] = useState([]);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [applyingJobId, setApplyingJobId] = useState(null);
// // // //   const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
// // // //   const [selectedJobDetails, setSelectedJobDetails] = useState(null);
// // // //   const [profileProgress, setProfileProgress] = useState({
// // // //     progress_percentage: 0,
// // // //     message: "Loading your profile progress...",
// // // //     missing_sections: [],
// // // //   });

// // // //   useEffect(() => {
// // // //     const fetchDashboardData = async () => {
// // // //       setLoading(true);
// // // //       const token = localStorage.getItem("access_token");
// // // //       if (!token) {
// // // //         setLoading(false);
// // // //         navigate("/gatep/login");
// // // //         return;
// // // //       }
// // // //       try {
// // // //         const [
// // // //           applicationsResponse,
// // // //           aiScoresResponse,
// // // //           resumeResponse,
// // // //           progressResponse,
// // // //         ] = await Promise.all([
// // // //           apiClient.get("/applications/"),
// // // //           apiClient.get("/job-postings/ai-score/"),
// // // //           apiClient.get("/resume-builder/"),
// // // //           apiClient.get("/resume-progress/"),
// // // //         ]);

// // // //         if (
// // // //           applicationsResponse.data &&
// // // //           Array.isArray(applicationsResponse.data)
// // // //         ) {
// // // //           const mappedApplications = applicationsResponse.data.map((app) => ({
// // // //             id: app.id,
// // // //             job_posting: app.job_posting,
// // // //             company:
// // // //               app.job_posting_details?.company_details?.company_name || "N/A",
// // // //             position: app.job_posting_details?.title || "N/A",
// // // //             location: app.job_posting_details?.location || "N/A",
// // // //             status: mapApplicationStatus(app.status),
// // // //           }));
// // // //           setApplications(mappedApplications);
// // // //         }

// // // //         const aiScoresData = aiScoresResponse.data;
// // // //         if (
// // // //           aiScoresData &&
// // // //           Array.isArray(aiScoresData) &&
// // // //           aiScoresData.length > 0
// // // //         ) {
// // // //           const recommendationDetailPromises = aiScoresData.map((scoreItem) =>
// // // //             apiClient.get(`/job-postings/${scoreItem.id}/`)
// // // //           );
// // // //           const recommendationDetailResponses = await Promise.all(
// // // //             recommendationDetailPromises
// // // //           );
// // // //           const jobDetailsList = recommendationDetailResponses.map(
// // // //             (res) => res.data
// // // //           );
// // // //           const mappedRecommendations = aiScoresData
// // // //             .map((scoreItem) => {
// // // //               const jobDetail = jobDetailsList.find(
// // // //                 (detail) => detail.id === scoreItem.id
// // // //               );
// // // //               if (!jobDetail) return null;
// // // //               return {
// // // //                 id: jobDetail.id,
// // // //                 company: jobDetail.company_details?.company_name || "N/A",
// // // //                 position: jobDetail.title || "N/A",
// // // //                 match: scoreItem.matching_percentage || 0,
// // // //                 location: jobDetail.location || "N/A",
// // // //                 salary_min: jobDetail.salary_min,
// // // //                 salary_max: jobDetail.salary_max,
// // // //                 salary_currency: jobDetail.salary_currency,
// // // //                 posted_at: jobDetail.posted_at,
// // // //                 application_deadline: jobDetail.application_deadline,
// // // //                 visa_sponsorship: jobDetail.visa_sponsorship,
// // // //                 required_skills: jobDetail.required_skills || [],
// // // //                 urgent: jobDetail.urgent || false,
// // // //                 details: jobDetail,
// // // //               };
// // // //             })
// // // //             .filter((item) => item !== null)
// // // //             .sort((a, b) => b.match - a.match);
// // // //           setRecommendations(mappedRecommendations);
// // // //         } else {
// // // //           setRecommendations([]);
// // // //         }

// // // //         if (resumeResponse.data) {
// // // //           const resumeData = Array.isArray(resumeResponse.data)
// // // //             ? resumeResponse.data[0]
// // // //             : resumeResponse.data;
// // // //           if (resumeData) {
// // // //             if (resumeData.skills && Array.isArray(resumeData.skills)) {
// // // //               setTechnicalSkills(resumeData.skills);
// // // //             }
// // // //             if (
// // // //               resumeData.languages &&
// // // //               typeof resumeData.languages === "object" &&
// // // //               !Array.isArray(resumeData.languages)
// // // //             ) {
// // // //               const formattedLangs = Object.entries(resumeData.languages).map(
// // // //                 ([name, proficiency]) => ({
// // // //                   name,
// // // //                   proficiency,
// // // //                 })
// // // //               );
// // // //               setLanguages(formattedLangs);
// // // //             }
// // // //           }
// // // //         }

// // // //         if (progressResponse.data) {
// // // //           setProfileProgress(progressResponse.data);
// // // //         }
// // // //       } catch (error) {
// // // //         console.error("Failed to fetch dashboard data:", error);
// // // //       } finally {
// // // //         setTimeout(() => setLoading(false), 1200);
// // // //       }
// // // //     };
// // // //     fetchDashboardData();
// // // //   }, [navigate]);

// // // //   const handleViewDetails = (jobDetails) => {
// // // //     setSelectedJobDetails(jobDetails);
// // // //     setIsDetailsModalOpen(true);
// // // //   };

// // // //   const handleCloseDetailsModal = () => {
// // // //     setIsDetailsModalOpen(false);
// // // //     setSelectedJobDetails(null);
// // // //   };

// // // //   const handleQuickApply = async (jobId) => {
// // // //     setApplyingJobId(jobId);
// // // //     try {
// // // //       const response = await apiClient.post("/applications/", {
// // // //         job_posting: jobId,
// // // //       });
// // // //       const newApplication = response.data;
// // // //       const mappedNewApplication = {
// // // //         id: newApplication.id,
// // // //         job_posting: newApplication.job_posting,
// // // //         company:
// // // //           newApplication.job_posting_details?.company_details?.company_name ||
// // // //           "N/A",
// // // //         position: newApplication.job_posting_details?.title || "N/A",
// // // //         location: newApplication.job_posting_details?.location || "N/A",
// // // //         status: mapApplicationStatus(newApplication.status),
// // // //       };
// // // //       setApplications((prev) => [mappedNewApplication, ...prev]);
// // // //     } catch (error) {
// // // //       console.error("Failed to quick apply:", error);
// // // //     } finally {
// // // //       setApplyingJobId(null);
// // // //     }
// // // //   };

// // // //   const statsData = [
// // // //     {
// // // //       label: "Active Applications",
// // // //       value: applications.length,
// // // //       blobColor: theme.palette.warning.light,
// // // //     },
// // // //     {
// // // //       label: "Job Matches",
// // // //       value: recommendations.length,
// // // //       blobColor: theme.palette.error.light,
// // // //     },
// // // //     {
// // // //       label: "Job Notification",
// // // //       value: 120,
// // // //       blobColor: theme.palette.info.light,
// // // //     },
// // // //   ];

// // // //   if (loading) {
// // // //     return (
// // // //       <Layout title="Talent Dashboard">
// // // //         <Container maxWidth={false} sx={{ py: { xs: 2, md: 4 } }}>
// // // //           <Stack spacing={{ xs: 3, md: 4 }}>
// // // //             <WelcomeCardSkeleton />
// // // //             <Grid container spacing={2.5}>
// // // //               {[...Array(3)].map((_, index) => (
// // // //                 <Grid item xs={12} sm={4} key={index}>
// // // //                   <StatCardSkeleton />
// // // //                 </Grid>
// // // //               ))}
// // // //             </Grid>
// // // //             {/* Skeletons re-ordered to match new layout */}
// // // //             <SectionSkeleton
// // // //               titleWidth={250}
// // // //               items={4}
// // // //               CardSkeletonComponent={RecentApplicationSkeletonCard}
// // // //             />
// // // //             <SectionSkeleton
// // // //               titleWidth={280}
// // // //               items={4}
// // // //               CardSkeletonComponent={JobRecommendationSkeletonCard}
// // // //             />
// // // //             <SkillsAndLanguagesSkeleton />
// // // //           </Stack>
// // // //         </Container>
// // // //       </Layout>
// // // //     );
// // // //   }

// // // //   return (
// // // //     <Layout title="Talent Dashboard">
// // // //       <Container
// // // //         maxWidth={false}
// // // //         sx={{ py: { xs: 2, md: 4 }, fontFamily: "'Poppins', sans-serif" }}
// // // //       >
// // // //         <Stack spacing={{ xs: 3, md: 4 }}>
// // // //           <Card
// // // //             elevation={0}
// // // //             sx={{
// // // //               p: { xs: 2, md: 3 },
// // // //               borderRadius: "16px",
// // // //               bgcolor: "mint.main",
// // // //               boxShadow: "none",
// // // //             }}
// // // //           >
// // // //             <Stack
// // // //               direction={{ xs: "column", sm: "row" }}
// // // //               spacing={2}
// // // //               alignItems="center"
// // // //             >
// // // //               <Avatar
// // // //                 src="/placeholder.svg?height=60&width=60"
// // // //                 sx={{ width: 60, height: 60 }}
// // // //               />
// // // //               <Box
// // // //                 flexGrow={1}
// // // //                 sx={{ width: "100%", textAlign: { xs: "center", sm: "left" } }}
// // // //               >
// // // //                 <Typography
// // // //                   variant="h5"
// // // //                   sx={{ fontWeight: "bold", color: "text.primary" }}
// // // //                 >
// // // //                   Welcome Back!
// // // //                 </Typography>
// // // //                 <Typography sx={{ color: "text.primary", fontSize: "0.9rem" }}>
// // // //                   {profileProgress.message}
// // // //                 </Typography>
// // // //                 <Stack
// // // //                   direction="row"
// // // //                   spacing={2}
// // // //                   alignItems="center"
// // // //                   sx={{ mt: 1 }}
// // // //                 >
// // // //                   <LinearProgress
// // // //                     variant="determinate"
// // // //                     value={profileProgress.progress_percentage || 0}
// // // //                     sx={{
// // // //                       flexGrow: 1,
// // // //                       height: 8,
// // // //                       borderRadius: "4px",
// // // //                       bgcolor: alpha(theme.palette.primary.main, 0.2),
// // // //                       "& .MuiLinearProgress-bar": { bgcolor: "primary.main" },
// // // //                     }}
// // // //                   />
// // // //                   <Typography
// // // //                     sx={{
// // // //                       fontWeight: "bold",
// // // //                       color: "primary.main",
// // // //                       fontSize: "0.9rem",
// // // //                     }}
// // // //                   >
// // // //                     {profileProgress.progress_percentage || 0}% Profile
// // // //                     Completed
// // // //                   </Typography>
// // // //                 </Stack>
// // // //               </Box>
// // // //               <Button
// // // //                 variant="contained"
// // // //                 color="primary"
// // // //                 onClick={() => navigate("/gatep/talent/profile")}
// // // //                 sx={{
// // // //                   borderRadius: "20px",
// // // //                   textTransform: "none",
// // // //                   fontWeight: 600,
// // // //                   px: 3,
// // // //                   py: 1,
// // // //                 }}
// // // //               >
// // // //                 Complete Profile
// // // //               </Button>
// // // //             </Stack>
// // // //           </Card>

// // // //           {/* <Grid
// // // //             container
// // // //             spacing={2.5}
// // // //             sx={{ alignItems: "stretch", width: "100%" }}
// // // //           >
// // // //             {statsData.map((stat, index) => (
// // // //               <Grid
// // // //                 item
// // // //                 key={index}
// // // //                 sx={{ display: "flex", justifyContent: "center" }}
// // // //               >
// // // //                 <StatCard {...stat} />
// // // //               </Grid>
// // // //             ))}
// // // //           </Grid> */}

// // // //           {/* Section: Stat Cards (Now in a single row on mobile) */}
// // // //           <Stack
// // // //             direction="row"
// // // //             spacing={{ xs: 1.5, sm: 2.5 }} // Use responsive spacing
// // // //             justifyContent="center"
// // // //             alignItems="stretch"
// // // //             sx={{ width: "100%" }}
// // // //           >
// // // //             {statsData.map((stat, index) => (
// // // //               <StatCard key={index} {...stat} />
// // // //             ))}
// // // //           </Stack>

// // // //           {/* Section: Recent Applications (Horizontal Row) */}
// // // //           <Card
// // // //             elevation={0}
// // // //             sx={{
// // // //               p: { xs: 2, md: 3 },
// // // //               borderRadius: "20px",
// // // //               bgcolor: "mint.main",
// // // //               boxShadow: (theme) =>
// // // //                 `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// // // //             }}
// // // //           >
// // // //             <Typography
// // // //               variant="h5"
// // // //               sx={{
// // // //                 fontWeight: "bold",
// // // //                 color: "text.primary",
// // // //                 mb: 2,
// // // //               }}
// // // //             >
// // // //               Recent Application
// // // //             </Typography>
// // // //             <Stack
// // // //               direction="row"
// // // //               spacing={2.5}
// // // //               sx={{
// // // //                 overflowX: "auto",
// // // //                 pb: 1,
// // // //                 "&::-webkit-scrollbar": {
// // // //                   display: "none",
// // // //                 },
// // // //                 "-ms-overflow-style": "none",
// // // //                 "scrollbar-width": "none",
// // // //               }}
// // // //             >
// // // //               {applications.slice(0, 8).map((app) => (
// // // //                 <Card
// // // //                   key={app.id}
// // // //                   elevation={0}
// // // //                   sx={{
// // // //                     p: 2,
// // // //                     borderRadius: "20px",
// // // //                     bgcolor: "background.paper",
// // // //                     border: (theme) => `1px solid ${theme.palette.divider}`,
// // // //                     position: "relative",
// // // //                     overflow: "hidden",
// // // //                     minWidth: { xs: 280, sm: 320 },
// // // //                     flexShrink: 0,
// // // //                   }}
// // // //                 >
// // // //                   <Box
// // // //                     sx={{
// // // //                       position: "absolute",
// // // //                       width: 90,
// // // //                       height: 90,
// // // //                       borderRadius: "50%",
// // // //                       bgcolor: alpha(theme.palette.warning.main, 0.1),
// // // //                       top: -25,
// // // //                       right: 25,
// // // //                       zIndex: 0,
// // // //                     }}
// // // //                   />
// // // //                   <Box
// // // //                     sx={{
// // // //                       position: "absolute",
// // // //                       width: 70,
// // // //                       height: 70,
// // // //                       borderRadius: "50%",
// // // //                       bgcolor: alpha(theme.palette.warning.main, 0.1),
// // // //                       top: 15,
// // // //                       right: -25,
// // // //                       zIndex: 0,
// // // //                     }}
// // // //                   />
// // // //                   <Stack
// // // //                     spacing={2}
// // // //                     justifyContent="space-between"
// // // //                     sx={{ position: "relative", zIndex: 1 }}
// // // //                   >
// // // //                     <Stack direction="row" spacing={1.5} alignItems="center">
// // // //                       <Avatar
// // // //                         sx={{ bgcolor: "warning.light", width: 48, height: 48 }}
// // // //                       >
// // // //                         <WorkOutline sx={{ color: "primary.main" }} />
// // // //                       </Avatar>
// // // //                       <Box>
// // // //                         <Typography
// // // //                           sx={{
// // // //                             fontWeight: "bold",
// // // //                             fontSize: "18px",
// // // //                             color: "text.primary",
// // // //                             lineHeight: 1.2,
// // // //                           }}
// // // //                         >
// // // //                           {app.position}
// // // //                         </Typography>
// // // //                         <Typography
// // // //                           sx={{
// // // //                             fontSize: "14px",
// // // //                             color: "text.secondary",
// // // //                             display: "flex",
// // // //                             alignItems: "center",
// // // //                             mt: 0.5,
// // // //                           }}
// // // //                         >
// // // //                           <LocationOn sx={{ fontSize: "16px", mr: 0.5 }} />
// // // //                           {app.company}
// // // //                         </Typography>
// // // //                       </Box>
// // // //                     </Stack>
// // // //                     <Box sx={{ alignSelf: "flex-end" }}>
// // // //                       <Chip
// // // //                         label={app.status}
// // // //                         sx={{
// // // //                           bgcolor:
// // // //                             app.status === "Applied"
// // // //                               ? "success.main"
// // // //                               : "primary.main",
// // // //                           color: "primary.contrastText",
// // // //                           borderRadius: "16px",
// // // //                           fontWeight: 500,
// // // //                           fontSize: "13px",
// // // //                           height: "32px",
// // // //                           ".MuiChip-label": { px: 2 },
// // // //                         }}
// // // //                       />
// // // //                     </Box>
// // // //                   </Stack>
// // // //                 </Card>
// // // //               ))}
// // // //             </Stack>
// // // //             <Box sx={{ textAlign: "center", pt: 3 }}>
// // // //               <Button
// // // //                 endIcon={<ArrowForward />}
// // // //                 color="primary"
// // // //                 variant="contained"
// // // //                 onClick={() => navigate("/gatep/talent/jobs")}
// // // //                 sx={{
// // // //                   borderRadius: "30px",
// // // //                   textTransform: "none",
// // // //                   fontWeight: "bold",
// // // //                   fontSize: "14px",
// // // //                   height: "40px",
// // // //                   px: 4,
// // // //                   width: "100%",
// // // //                   maxWidth: "350px",
// // // //                   mx: "auto",
// // // //                 }}
// // // //               >
// // // //                 View All Recent Application
// // // //               </Button>
// // // //             </Box>
// // // //           </Card>

// // // //           {/* Section: AI Job Recommendations */}
// // // //           <Card
// // // //             elevation={0}
// // // //             sx={{
// // // //               p: { xs: 2, md: 3 },
// // // //               borderRadius: "20px",
// // // //               bgcolor: "mint.main",
// // // //               boxShadow: (theme) =>
// // // //                 `0px 4px 12px ${alpha(theme.palette.common.black, 0.05)}`,
// // // //               display: "flex",
// // // //               flexDirection: "column",
// // // //               height: "100%",
// // // //             }}
// // // //           >
// // // //             <Typography
// // // //               variant="h5"
// // // //               sx={{ fontWeight: "bold", color: "text.primary", mb: 3 }}
// // // //             >
// // // //               AI Job Recommendations
// // // //             </Typography>
// // // //             <Stack
// // // //               direction="row"
// // // //               spacing={2.5}
// // // //               sx={{
// // // //                 overflowX: "auto",
// // // //                 pb: 2,
// // // //                 "&::-webkit-scrollbar": {
// // // //                   display: "none",
// // // //                 },
// // // //                 "-ms-overflow-style": "none",
// // // //                 "scrollbar-width": "none",
// // // //               }}
// // // //             >
// // // //               {recommendations.slice(0, 6).map((rec) => {
// // // //                 const isApplying = applyingJobId === rec.id;
// // // //                 const isAlreadyApplied = applications.some(
// // // //                   (app) => String(app.job_posting) === String(rec.id)
// // // //                 );
// // // //                 const displaySkills = rec.required_skills.slice(0, 3);
// // // //                 const remainingSkills =
// // // //                   rec.required_skills.length - displaySkills.length;
// // // //                 return (
// // // //                   <Card
// // // //                     key={rec.id}
// // // //                     elevation={0}
// // // //                     sx={{
// // // //                       p: 2.5,
// // // //                       borderRadius: "20px",
// // // //                       border: (theme) => `1px solid ${theme.palette.divider}`,
// // // //                       bgcolor: "background.paper",
// // // //                       display: "flex",
// // // //                       flexDirection: "column",
// // // //                       gap: 1.5,
// // // //                       width: { xs: 300, sm: 360 },
// // // //                       flexShrink: 0,
// // // //                     }}
// // // //                   >
// // // //                     <Stack
// // // //                       direction="row"
// // // //                       justifyContent="space-between"
// // // //                       alignItems="flex-start"
// // // //                     >
// // // //                       <Stack direction="row" spacing={1.5} alignItems="center">
// // // //                         <Avatar
// // // //                           variant="circular"
// // // //                           sx={{
// // // //                             bgcolor: "warning.light",
// // // //                             width: 48,
// // // //                             height: 48,
// // // //                           }}
// // // //                         >
// // // //                           <WorkOutline sx={{ color: "primary.main" }} />
// // // //                         </Avatar>
// // // //                         <Box sx={{ minHeight: "54px" }}>
// // // //                           <Typography
// // // //                             sx={{
// // // //                               fontWeight: "bold",
// // // //                               fontSize: "18px",
// // // //                               color: "text.primary",
// // // //                               overflow: "hidden",
// // // //                               textOverflow: "ellipsis",
// // // //                               display: "-webkit-box",
// // // //                               WebkitLineClamp: "2",
// // // //                               WebkitBoxOrient: "vertical",
// // // //                             }}
// // // //                           >
// // // //                             {rec.position}
// // // //                           </Typography>
// // // //                           <Typography
// // // //                             sx={{
// // // //                               fontSize: "14px",
// // // //                               color: "text.secondary",
// // // //                             }}
// // // //                           >
// // // //                             {rec.company}
// // // //                           </Typography>
// // // //                         </Box>
// // // //                       </Stack>
// // // //                       <Stack alignItems="flex-end" spacing={1}>
// // // //                         {rec.urgent && (
// // // //                           <Chip
// // // //                             label="Urgent Hiring"
// // // //                             size="small"
// // // //                             sx={{
// // // //                               bgcolor: alpha(theme.palette.warning.main, 0.2),
// // // //                               color: "warning.dark",
// // // //                               fontWeight: 500,
// // // //                               borderRadius: "16px",
// // // //                               height: "auto",
// // // //                               ".MuiChip-label": { py: "2px", px: "8px" },
// // // //                             }}
// // // //                           />
// // // //                         )}
// // // //                         <IconButton size="small">
// // // //                           <BookmarkBorder />
// // // //                         </IconButton>
// // // //                       </Stack>
// // // //                     </Stack>
// // // //                     <Stack spacing={0.5}>
// // // //                       <Stack direction="row" spacing={1}>
// // // //                         <LocationOn
// // // //                           sx={{
// // // //                             fontSize: "16px",
// // // //                             color: "text.secondary",
// // // //                             mt: "2px",
// // // //                           }}
// // // //                         />
// // // //                         <Typography
// // // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // // //                         >
// // // //                           {rec.location}
// // // //                         </Typography>
// // // //                         {rec.visa_sponsorship && (
// // // //                           <Chip
// // // //                             label="Visa Sponsored"
// // // //                             size="small"
// // // //                             sx={{
// // // //                               bgcolor: alpha(theme.palette.primary.main, 0.15),
// // // //                               color: "primary.main",
// // // //                               fontWeight: 500,
// // // //                               borderRadius: "8px",
// // // //                               height: "auto",
// // // //                               ".MuiChip-label": { py: "1px" },
// // // //                             }}
// // // //                           />
// // // //                         )}
// // // //                       </Stack>
// // // //                       <Stack direction="row" spacing={1}>
// // // //                         <AttachMoney
// // // //                           sx={{
// // // //                             fontSize: "16px",
// // // //                             color: "text.secondary",
// // // //                             mt: "2px",
// // // //                           }}
// // // //                         />
// // // //                         <Typography
// // // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // // //                         >{`$${(rec.salary_min / 1000).toFixed(0)}k-$${(
// // // //                           rec.salary_max / 1000
// // // //                         ).toFixed(0)}k`}</Typography>
// // // //                         <WorkOutline
// // // //                           sx={{
// // // //                             fontSize: "16px",
// // // //                             color: "text.secondary",
// // // //                             mt: "2px",
// // // //                             ml: 1,
// // // //                           }}
// // // //                         />
// // // //                         <Typography
// // // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // // //                         >
// // // //                           {rec.details.job_type_display}
// // // //                         </Typography>
// // // //                       </Stack>
// // // //                       <Stack direction="row" spacing={1}>
// // // //                         <AccessTime
// // // //                           sx={{
// // // //                             fontSize: "16px",
// // // //                             color: "text.secondary",
// // // //                             mt: "2px",
// // // //                           }}
// // // //                         />
// // // //                         <Typography
// // // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // // //                         >
// // // //                           {new Date(
// // // //                             rec.application_deadline || rec.posted_at
// // // //                           ).toLocaleDateString()}
// // // //                         </Typography>
// // // //                       </Stack>
// // // //                     </Stack>

// // // //                     <Box>
// // // //                       <Stack
// // // //                         direction="row"
// // // //                         justifyContent="space-between"
// // // //                         alignItems="center"
// // // //                       >
// // // //                         <Typography
// // // //                           sx={{
// // // //                             fontSize: "14px",
// // // //                             fontWeight: 600,
// // // //                             color: "text.primary",
// // // //                           }}
// // // //                         >
// // // //                           AI Match Score
// // // //                         </Typography>
// // // //                         <Typography
// // // //                           sx={{
// // // //                             fontSize: "14px",
// // // //                             fontWeight: "bold",
// // // //                             color: "success.main",
// // // //                           }}
// // // //                         >
// // // //                           {rec.match}%
// // // //                         </Typography>
// // // //                       </Stack>
// // // //                       <LinearProgress
// // // //                         variant="determinate"
// // // //                         value={rec.match}
// // // //                         sx={{
// // // //                           mt: 0.5,
// // // //                           height: 6,
// // // //                           borderRadius: 3,
// // // //                           bgcolor: "divider",
// // // //                           "& .MuiLinearProgress-bar": {
// // // //                             bgcolor: "success.main",
// // // //                           },
// // // //                         }}
// // // //                       />
// // // //                     </Box>
// // // //                     <Box sx={{ minHeight: "68px" }}>
// // // //                       <Typography
// // // //                         sx={{
// // // //                           fontSize: "14px",
// // // //                           color: "text.secondary",
// // // //                           mb: 1,
// // // //                         }}
// // // //                       >
// // // //                         Required Skills
// // // //                       </Typography>
// // // //                       <Stack
// // // //                         direction="row"
// // // //                         useFlexGap
// // // //                         flexWrap="wrap"
// // // //                         spacing={1}
// // // //                       >
// // // //                         {displaySkills.map((skill, index) => (
// // // //                           <Chip
// // // //                             key={`${skill}-${index}`}
// // // //                             label={skill}
// // // //                             variant="outlined"
// // // //                             size="small"
// // // //                           />
// // // //                         ))}
// // // //                         {remainingSkills > 0 && (
// // // //                           <Chip
// // // //                             label={`+${remainingSkills}`}
// // // //                             size="small"
// // // //                             sx={{
// // // //                               bgcolor: "primary.light",
// // // //                               color: "primary.main",
// // // //                               borderRadius: "50%",
// // // //                               fontWeight: "bold",
// // // //                             }}
// // // //                           />
// // // //                         )}
// // // //                       </Stack>
// // // //                     </Box>
// // // //                     <Stack
// // // //                       direction="row"
// // // //                       spacing={1.5}
// // // //                       sx={{ mt: "auto", pt: 2 }}
// // // //                     >
// // // //                       <Button
// // // //                         fullWidth
// // // //                         variant="outlined"
// // // //                         color="primary"
// // // //                         onClick={() => handleViewDetails(rec.details)}
// // // //                         sx={{
// // // //                           borderRadius: "30px",
// // // //                           textTransform: "none",
// // // //                           fontWeight: 600,
// // // //                         }}
// // // //                       >
// // // //                         View Details
// // // //                       </Button>
// // // //                       <Button
// // // //                         fullWidth
// // // //                         variant="contained"
// // // //                         color="primary"
// // // //                         onClick={() => handleQuickApply(rec.id)}
// // // //                         disabled={isApplying || isAlreadyApplied}
// // // //                         sx={{
// // // //                           borderRadius: "30px",
// // // //                           boxShadow: "none",
// // // //                           textTransform: "none",
// // // //                           fontWeight: 600,
// // // //                         }}
// // // //                       >
// // // //                         {isApplying ? (
// // // //                           <CircularProgress size={24} color="inherit" />
// // // //                         ) : isAlreadyApplied ? (
// // // //                           "Applied"
// // // //                         ) : (
// // // //                           "Quick Apply"
// // // //                         )}
// // // //                       </Button>
// // // //                     </Stack>
// // // //                   </Card>
// // // //                 );
// // // //               })}
// // // //             </Stack>
// // // //             <Box sx={{ textAlign: "center", pt: 3, mt: "auto" }}>
// // // //               <Button
// // // //                 endIcon={<ArrowForward />}
// // // //                 color="primary"
// // // //                 variant="contained"
// // // //                 onClick={() => navigate("/gatep/talent/jobs")}
// // // //                 sx={{
// // // //                   borderRadius: "30px",
// // // //                   textTransform: "none",
// // // //                   fontWeight: "bold",
// // // //                   fontSize: "14px",
// // // //                   height: "40px",
// // // //                   px: 4,
// // // //                   width: "100%",
// // // //                   maxWidth: "350px",
// // // //                   mx: "auto",
// // // //                 }}
// // // //               >
// // // //                 View All AI JOB Recomendation
// // // //               </Button>
// // // //             </Box>
// // // //           </Card>
// // // //         </Stack>
// // // //         <JobDetailsModal
// // // //           open={isDetailsModalOpen}
// // // //           onClose={handleCloseDetailsModal}
// // // //           job={selectedJobDetails}
// // // //         />
// // // //       </Container>
// // // //     </Layout>
// // // //   );
// // // // };

// // // // export default TalentDashboard;

// // // // "use client";

// // // // import { useState, useEffect } from "react";
// // // // import {
// // // //   Grid,
// // // //   Card,
// // // //   Typography,
// // // //   Button,
// // // //   Box,
// // // //   Chip,
// // // //   LinearProgress,
// // // //   List,
// // // //   ListItem,
// // // //   ListItemText,
// // // //   ListItemIcon,
// // // //   Avatar,
// // // //   Stack,
// // // //   Skeleton,
// // // //   alpha,
// // // //   Container,
// // // //   CardContent,
// // // //   CircularProgress,
// // // //   Dialog,
// // // //   DialogTitle,
// // // //   DialogContent,
// // // //   DialogActions,
// // // //   IconButton,
// // // //   darken,
// // // // } from "@mui/material";
// // // // import {
// // // //   TrendingUp,
// // // //   LocationOn,
// // // //   ArrowForward,
// // // //   CheckCircle,
// // // //   Close as CloseIcon,
// // // //   AttachMoney,
// // // //   Event,
// // // //   Beenhere,
// // // //   WorkOutline,
// // // //   BookmarkBorder,
// // // //   AccessTime,
// // // // } from "@mui/icons-material";
// // // // import Layout from "../components/common/Layout";
// // // // import { useNavigate } from "react-router-dom";
// // // // import { useTheme } from "@mui/material/styles";
// // // // import apiClient from "../context/apiClient";

// // // // const JobDetailsModal = ({ open, onClose, job }) => {
// // // //   const theme = useTheme();
// // // //   if (!job) return null;
// // // //   return (
// // // //     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
// // // //       <DialogTitle sx={{ m: 0, p: 2, pr: 8, bgcolor: "#F1FFFA" }}>
// // // //         <Stack direction="row" spacing={2} alignItems="center">
// // // //           <Avatar
// // // //             src={job.company_details?.logo}
// // // //             variant="rounded"
// // // //             sx={{ width: 56, height: 56 }}
// // // //           />
// // // //           <Box>
// // // //             <Typography variant="h5" component="div" fontWeight={700}>
// // // //               {job.title}
// // // //             </Typography>
// // // //             <Typography variant="body1" color="text.secondary">
// // // //               {job.company_details?.company_name}
// // // //             </Typography>
// // // //           </Box>
// // // //         </Stack>
// // // //         <IconButton
// // // //           aria-label="close"
// // // //           onClick={onClose}
// // // //           sx={{
// // // //             position: "absolute",
// // // //             right: 8,
// // // //             top: 8,
// // // //             color: "text.secondary",
// // // //           }}
// // // //         >
// // // //           <CloseIcon />
// // // //         </IconButton>
// // // //       </DialogTitle>
// // // //       <DialogContent dividers sx={{ bgcolor: "#F1FFFA" }}>
// // // //         <Stack
// // // //           direction="row"
// // // //           spacing={1}
// // // //           useFlexGap
// // // //           flexWrap="wrap"
// // // //           sx={{ mb: 3 }}
// // // //         >
// // // //           <Chip icon={<LocationOn />} label={job.location} variant="outlined" />
// // // //           <Chip
// // // //             icon={<WorkOutline />}
// // // //             label={job.job_type_display}
// // // //             variant="outlined"
// // // //           />
// // // //           <Chip
// // // //             icon={<TrendingUp />}
// // // //             label={job.experience_level_display}
// // // //             variant="outlined"
// // // //           />
// // // //           {job.remote_work && (
// // // //             <Chip label="Remote Available" color="success" variant="outlined" />
// // // //           )}
// // // //           {job.visa_sponsorship && (
// // // //             <Chip
// // // //               label="Visa Sponsorship"
// // // //               sx={{
// // // //                 backgroundColor: "primary.main",
// // // //                 color: "primary.contrastText",
// // // //                 fontWeight: 500,
// // // //               }}
// // // //             />
// // // //           )}
// // // //         </Stack>
// // // //         {job.salary_min && job.salary_max && (
// // // //           <Box
// // // //             display="flex"
// // // //             alignItems="center"
// // // //             mb={3}
// // // //             p={2}
// // // //             bgcolor={alpha(theme.palette.success.main, 0.1)}
// // // //             borderRadius={2}
// // // //           >
// // // //             <AttachMoney sx={{ mr: 1, color: "success.main" }} />
// // // //             <Typography
// // // //               variant="h6"
// // // //               component="p"
// // // //               fontWeight={600}
// // // //               color="success.dark"
// // // //             >
// // // //               {`${new Intl.NumberFormat("en-US", {
// // // //                 style: "currency",
// // // //                 currency: job.salary_currency || "USD",
// // // //               }).format(job.salary_min)} - ${new Intl.NumberFormat("en-US", {
// // // //                 style: "currency",
// // // //                 currency: job.salary_currency || "USD",
// // // //               }).format(job.salary_max)}`}
// // // //             </Typography>
// // // //           </Box>
// // // //         )}
// // // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // // //           Job Description
// // // //         </Typography>
// // // //         <Typography
// // // //           variant="body2"
// // // //           sx={{
// // // //             whiteSpace: "pre-wrap",
// // // //             mb: 3,
// // // //             color: "text.secondary",
// // // //             lineHeight: 1.7,
// // // //           }}
// // // //         >
// // // //           {job.description}
// // // //         </Typography>
// // // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // // //           Responsibilities
// // // //         </Typography>
// // // //         <Typography
// // // //           variant="body2"
// // // //           sx={{
// // // //             whiteSpace: "pre-wrap",
// // // //             mb: 3,
// // // //             color: "text.secondary",
// // // //             lineHeight: 1.7,
// // // //           }}
// // // //         >
// // // //           {job.responsibilities}
// // // //         </Typography>
// // // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // // //           Requirements
// // // //         </Typography>
// // // //         <List dense sx={{ mb: 2 }}>
// // // //           {job.requirements?.map((req, i) => (
// // // //             <ListItem key={i} disableGutters>
// // // //               <ListItemIcon sx={{ minWidth: 32 }}>
// // // //                 <CheckCircle color="primary" fontSize="small" />
// // // //               </ListItemIcon>
// // // //               <ListItemText primary={req} />
// // // //             </ListItem>
// // // //           ))}
// // // //         </List>
// // // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // // //           Required Skills
// // // //         </Typography>
// // // //         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
// // // //           {job.required_skills?.map((skill, i) => (
// // // //             <Chip key={i} label={skill} variant="outlined" />
// // // //           ))}
// // // //         </Box>
// // // //         {job.benefits?.length > 0 && (
// // // //           <>
// // // //             <Typography variant="h6" gutterBottom fontWeight={700}>
// // // //               Benefits
// // // //             </Typography>
// // // //             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
// // // //               {job.benefits.map((benefit, i) => (
// // // //                 <Chip
// // // //                   key={i}
// // // //                   icon={<Beenhere />}
// // // //                   label={benefit}
// // // //                   variant="outlined"
// // // //                   color="success"
// // // //                 />
// // // //               ))}
// // // //             </Box>
// // // //           </>
// // // //         )}
// // // //         {job.application_deadline && (
// // // //           <Box
// // // //             display="flex"
// // // //             alignItems="center"
// // // //             mt={2}
// // // //             p={1.5}
// // // //             bgcolor={alpha(theme.palette.warning.main, 0.1)}
// // // //             borderRadius={2}
// // // //           >
// // // //             <Event sx={{ mr: 1, color: "warning.main" }} />
// // // //             <Typography
// // // //               variant="body2"
// // // //               component="p"
// // // //               fontWeight={600}
// // // //               color="warning.dark"
// // // //             >
// // // //               Application Deadline:{" "}
// // // //               {new Date(job.application_deadline).toLocaleDateString()}
// // // //             </Typography>
// // // //           </Box>
// // // //         )}
// // // //       </DialogContent>
// // // //       <DialogActions sx={{ p: { xs: 2, sm: 3 }, bgcolor: "#F1FFFA" }}>
// // // //         <Button onClick={onClose} color="inherit">
// // // //           Close
// // // //         </Button>
// // // //       </DialogActions>
// // // //     </Dialog>
// // // //   );
// // // // };

// // // // const WelcomeCardSkeleton = () => (
// // // //   <Card
// // // //     elevation={0}
// // // //     sx={{
// // // //       p: { xs: 2, md: 3 },
// // // //       borderRadius: "16px",
// // // //       bgcolor: "mint.main",
// // // //       boxShadow: "none",
// // // //     }}
// // // //   >
// // // //     <Stack
// // // //       direction={{ xs: "column", sm: "row" }}
// // // //       spacing={2}
// // // //       alignItems="center"
// // // //     >
// // // //       <Skeleton variant="circular" width={60} height={60} />
// // // //       <Box flexGrow={1} sx={{ width: "100%" }}>
// // // //         <Skeleton variant="text" width="40%" height={32} />
// // // //         <Skeleton variant="text" width="60%" height={24} />
// // // //         <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 1 }}>
// // // //           <Skeleton
// // // //             variant="rectangular"
// // // //             height={8}
// // // //             sx={{ flexGrow: 1, borderRadius: "4px" }}
// // // //           />
// // // //           <Skeleton variant="text" width="25%" height={24} />
// // // //         </Stack>
// // // //       </Box>
// // // //       <Skeleton
// // // //         variant="rectangular"
// // // //         height={44}
// // // //         width={180}
// // // //         sx={{ borderRadius: "20px" }}
// // // //       />
// // // //     </Stack>
// // // //   </Card>
// // // // );

// // // // const StatCardSkeleton = () => (
// // // //   <Skeleton
// // // //     variant="rectangular"
// // // //     height={{ xs: 100, sm: 120 }}
// // // //     sx={{ borderRadius: "14px", flex: 1, minWidth: 0 }}
// // // //   />
// // // // );

// // // // const SectionSkeleton = ({
// // // //   titleWidth = 200,
// // // //   items = 3,
// // // //   CardSkeletonComponent,
// // // // }) => (
// // // //   <Card
// // // //     elevation={0}
// // // //     sx={{
// // // //       p: { xs: 2, md: 4 },
// // // //       borderRadius: "20px",
// // // //       bgcolor: "mint.main",
// // // //       height: "100%",
// // // //     }}
// // // //   >
// // // //     <Skeleton variant="text" width={titleWidth} height={40} sx={{ mb: 3 }} />
// // // //     <Grid container spacing={2.5}>
// // // //       {[...Array(items)].map((_, index) =>
// // // //         CardSkeletonComponent ? <CardSkeletonComponent key={index} /> : null
// // // //       )}
// // // //     </Grid>
// // // //     <Box sx={{ textAlign: "center", pt: 3 }}>
// // // //       <Skeleton
// // // //         variant="rectangular"
// // // //         width={250}
// // // //         height={40}
// // // //         sx={{ borderRadius: "30px", mx: "auto" }}
// // // //       />
// // // //     </Box>
// // // //   </Card>
// // // // );

// // // // const RecentApplicationSkeletonCard = () => (
// // // //   <Grid item xs={12}>
// // // //     <Card
// // // //       elevation={0}
// // // //       sx={{
// // // //         p: 2,
// // // //         borderRadius: "20px",
// // // //         bgcolor: "#F1FFFA",
// // // //         border: (theme) => `1px solid ${theme.palette.divider}`,
// // // //       }}
// // // //     >
// // // //       <Stack spacing={2} justifyContent="space-between" height="100%">
// // // //         <Stack direction="row" spacing={1.5} alignItems="center">
// // // //           <Skeleton variant="circular" width={48} height={48} />
// // // //           <Box>
// // // //             <Skeleton variant="text" width={120} height={28} />
// // // //             <Skeleton variant="text" width={100} height={20} />
// // // //           </Box>
// // // //         </Stack>
// // // //         <Skeleton
// // // //           variant="rectangular"
// // // //           width={100}
// // // //           height={32}
// // // //           sx={{ borderRadius: "16px", alignSelf: "flex-end" }}
// // // //         />
// // // //       </Stack>
// // // //     </Card>
// // // //   </Grid>
// // // // );

// // // // const JobRecommendationSkeletonCard = () => (
// // // //   <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
// // // //     <Card
// // // //       elevation={0}
// // // //       sx={{
// // // //         p: 3,
// // // //         borderRadius: "20px",
// // // //         border: (theme) => `1px solid ${theme.palette.divider}`,
// // // //         bgcolor: "background.paper",
// // // //         height: "100%",
// // // //         width: "100%",
// // // //         display: "flex",
// // // //         flexDirection: "column",
// // // //         gap: 1.5,
// // // //       }}
// // // //     >
// // // //       <Stack
// // // //         direction="row"
// // // //         justifyContent="space-between"
// // // //         alignItems="flex-start"
// // // //       >
// // // //         <Box>
// // // //           <Skeleton variant="text" width={150} height={28} />
// // // //           <Skeleton variant="text" width={100} height={20} />
// // // //         </Box>
// // // //         <Skeleton variant="circular" width={24} height={24} />
// // // //       </Stack>
// // // //       <Stack spacing={0.5}>
// // // //         <Skeleton variant="text" width="50%" />
// // // //         <Skeleton variant="text" width="70%" />
// // // //         <Skeleton variant="text" width="40%" />
// // // //       </Stack>
// // // //       <Box>
// // // //         <Stack
// // // //           direction="row"
// // // //           justifyContent="space-between"
// // // //           alignItems="center"
// // // //         >
// // // //           <Skeleton variant="text" width="30%" />
// // // //           <Skeleton variant="text" width="20%" />
// // // //         </Stack>
// // // //         <Skeleton
// // // //           variant="rectangular"
// // // //           height={6}
// // // //           sx={{ mt: 1, borderRadius: 3 }}
// // // //         />
// // // //       </Box>
// // // //       <Box>
// // // //         <Skeleton variant="text" width="40%" sx={{ mb: 1 }} />
// // // //         <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1}>
// // // //           <Skeleton
// // // //             variant="rectangular"
// // // //             width={80}
// // // //             height={24}
// // // //             sx={{ borderRadius: "16px" }}
// // // //           />
// // // //           <Skeleton
// // // //             variant="rectangular"
// // // //             width={90}
// // // //             height={24}
// // // //             sx={{ borderRadius: "16px" }}
// // // //           />
// // // //         </Stack>
// // // //       </Box>
// // // //       <Stack direction="row" spacing={1.5} sx={{ mt: "auto", pt: 2 }}>
// // // //         <Skeleton
// // // //           variant="rectangular"
// // // //           width="100%"
// // // //           height={40}
// // // //           sx={{ borderRadius: "30px" }}
// // // //         />
// // // //         <Skeleton
// // // //           variant="rectangular"
// // // //           width="100%"
// // // //           height={40}
// // // //           sx={{ borderRadius: "30px" }}
// // // //         />
// // // //       </Stack>
// // // //     </Card>
// // // //   </Grid>
// // // // );

// // // // const SkillsAndLanguagesSkeleton = () => (
// // // //   <Grid container spacing={3}>
// // // //     <Grid item xs={12} md={8}>
// // // //       <Card
// // // //         elevation={0}
// // // //         sx={{
// // // //           p: 3,
// // // //           borderRadius: "12px",
// // // //           bgcolor: "mint.main",
// // // //           boxShadow: (theme) =>
// // // //             `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// // // //           height: "100%",
// // // //         }}
// // // //       >
// // // //         <Skeleton variant="text" width="40%" height={32} />
// // // //         <Skeleton
// // // //           variant="text"
// // // //           width="30%"
// // // //           height={24}
// // // //           sx={{ mt: 1, mb: 2 }}
// // // //         />
// // // //         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 3 }}>
// // // //           {[...Array(8)].map((_, i) => (
// // // //             <Skeleton
// // // //               key={i}
// // // //               variant="rectangular"
// // // //               width={100}
// // // //               height={36}
// // // //               sx={{ borderRadius: "20px" }}
// // // //             />
// // // //           ))}
// // // //         </Box>
// // // //       </Card>
// // // //     </Grid>
// // // //     <Grid item xs={12} md={4}>
// // // //       <Card
// // // //         elevation={0}
// // // //         sx={{
// // // //           p: 3,
// // // //           borderRadius: "12px",
// // // //           bgcolor: "mint.main",
// // // //           boxShadow: (theme) =>
// // // //             `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// // // //           height: "100%",
// // // //         }}
// // // //       >
// // // //         <Skeleton variant="text" width="50%" height={32} sx={{ mb: 3 }} />
// // // //         <Grid container spacing={1.5} sx={{ mb: 3 }}>
// // // //           {[...Array(6)].map((_, i) => (
// // // //             <Grid item xs={6} key={i}>
// // // //               <Skeleton
// // // //                 variant="rectangular"
// // // //                 width="100%"
// // // //                 height={36}
// // // //                 sx={{ borderRadius: "20px" }}
// // // //               />
// // // //             </Grid>
// // // //           ))}
// // // //         </Grid>
// // // //       </Card>
// // // //     </Grid>
// // // //   </Grid>
// // // // );

// // // // const mapApplicationStatus = (apiStatus) => {
// // // //   switch (apiStatus) {
// // // //     case "SCHEDULED":
// // // //       return "Interview Scheduled";
// // // //     case "UNDER_REVIEW":
// // // //     case "REVIEW":
// // // //       return "Under Review";
// // // //     case "APPLIED":
// // // //       return "Applied";
// // // //     case "SHORTLISTED":
// // // //       return "Shortlisted";
// // // //     default:
// // // //       return apiStatus;
// // // //   }
// // // // };
// // // // const StatCard = ({ value, label, blobColor }) => {
// // // //   const theme = useTheme();
// // // //   // Use the provided blobColor or default to the theme's accent color
// // // //   const primaryBlobColor = blobColor || theme.palette.accent.main;
// // // //   // Create a slightly darker version for the background blob
// // // //   const darkerBlobColor = darken(primaryBlobColor, 0.1);

// // // //   return (
// // // //     <Card
// // // //       elevation={0}
// // // //       sx={{
// // // //         backgroundColor: theme.palette.primary.main,
// // // //         borderRadius: "20px",
// // // //         boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
// // // //         p: { xs: 1.5, sm: 2.5 },
// // // //         position: "relative",
// // // //         overflow: "hidden",
// // // //         color: theme.palette.primary.contrastText,
// // // //         display: "flex",
// // // //         flexDirection: "column",
// // // //         justifyContent: "center",
// // // //         flex: 1, // Essential for responsive row
// // // //         minWidth: 0, // Essential for responsive row
// // // //         height: { xs: 100, sm: 120 },
// // // //       }}
// // // //     >
// // // //       <Box
// // // //         sx={{
// // // //           position: "absolute",
// // // //           top: 0,
// // // //           right: 0,
// // // //           bottom: 0,
// // // //           width: "60%",
// // // //           zIndex: 0, // SVG is in the back
// // // //         }}
// // // //       >
// // // //         <svg
// // // //           width="100%"
// // // //           height="100%"
// // // //           viewBox="0 0 80 120"
// // // //           preserveAspectRatio="none"
// // // //           style={{
// // // //             filter: `drop-shadow(-4px 4px 8px ${alpha(
// // // //               theme.palette.common.black,
// // // //               0.2
// // // //             )})`,
// // // //           }}
// // // //         >
// // // //           <path
// // // //             d="M 40,0 C 80,30 0,90 20,120 L 80,120 L 80,0 Z"
// // // //             fill={darkerBlobColor}
// // // //           />
// // // //           <path
// // // //             d="M 50,0 C 90,30 10,90 30,120 L 80,120 L 80,0 Z"
// // // //             fill={primaryBlobColor}
// // // //           />
// // // //         </svg>
// // // //       </Box>
// // // //       <Stack sx={{ position: "relative", zIndex: 1 }}>
// // // //         <Typography
// // // //           sx={{
// // // //             textTransform: "uppercase",
// // // //             fontSize: { xs: "11px", sm: "13px" },
// // // //             fontWeight: 500,
// // // //             color: alpha(theme.palette.primary.contrastText, 0.7),
// // // //             mb: 0.5,
// // // //           }}
// // // //         >
// // // //           {label}
// // // //         </Typography>
// // // //         <Typography
// // // //           sx={{
// // // //             fontSize: { xs: "28px", sm: "34px" },
// // // //             fontWeight: 700,
// // // //             color: "primary.contrastText",
// // // //             lineHeight: 1.1,
// // // //           }}
// // // //         >
// // // //           {value}
// // // //         </Typography>
// // // //       </Stack>
// // // //     </Card>
// // // //   );
// // // // };

// // // // const TalentDashboard = () => {
// // // //   const navigate = useNavigate();
// // // //   const theme = useTheme();
// // // //   const [applications, setApplications] = useState([]);
// // // //   const [recommendations, setRecommendations] = useState([]);
// // // //   const [technicalSkills, setTechnicalSkills] = useState([]);
// // // //   const [languages, setLanguages] = useState([]);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [applyingJobId, setApplyingJobId] = useState(null);
// // // //   const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
// // // //   const [selectedJobDetails, setSelectedJobDetails] = useState(null);
// // // //   const [profileProgress, setProfileProgress] = useState({
// // // //     progress_percentage: 0,
// // // //     message: "Loading your profile progress...",
// // // //     // missing_sections: [],
// // // //   });

// // // //   useEffect(() => {
// // // //     const fetchDashboardData = async () => {
// // // //       setLoading(true);
// // // //       const token = localStorage.getItem("access_token");
// // // //       if (!token) {
// // // //         setLoading(false);
// // // //         navigate("/gatep/login");
// // // //         return;
// // // //       }
// // // //       try {
// // // //         const [
// // // //           applicationsResponse,
// // // //           aiScoresResponse,
// // // //           resumeResponse,
// // // //           progressResponse,
// // // //         ] = await Promise.all([
// // // //           apiClient.get("/applications/"),
// // // //           apiClient.get("/job-postings/ai-score/"),
// // // //           apiClient.get("/resume-builder/"),
// // // //           apiClient.get("/resume-progress/"),
// // // //         ]);

// // // //         if (
// // // //           applicationsResponse.data &&
// // // //           Array.isArray(applicationsResponse.data)
// // // //         ) {
// // // //           const mappedApplications = applicationsResponse.data.map((app) => ({
// // // //             id: app.id,
// // // //             job_posting: app.job_posting,
// // // //             company:
// // // //               app.job_posting_details?.company_details?.company_name || "N/A",
// // // //             position: app.job_posting_details?.title || "N/A",
// // // //             location: app.job_posting_details?.location || "N/A",
// // // //             status: mapApplicationStatus(app.status),
// // // //           }));
// // // //           setApplications(mappedApplications);
// // // //         }

// // // //         const aiScoresData = aiScoresResponse.data;
// // // //         if (
// // // //           aiScoresData &&
// // // //           Array.isArray(aiScoresData) &&
// // // //           aiScoresData.length > 0
// // // //         ) {
// // // //           const recommendationDetailPromises = aiScoresData.map((scoreItem) =>
// // // //             apiClient.get(`/job-postings/${scoreItem.id}/`)
// // // //           );
// // // //           const recommendationDetailResponses = await Promise.all(
// // // //             recommendationDetailPromises
// // // //           );
// // // //           const jobDetailsList = recommendationDetailResponses.map(
// // // //             (res) => res.data
// // // //           );
// // // //           const mappedRecommendations = aiScoresData
// // // //             .map((scoreItem) => {
// // // //               const jobDetail = jobDetailsList.find(
// // // //                 (detail) => detail.id === scoreItem.id
// // // //               );
// // // //               if (!jobDetail) return null;
// // // //               return {
// // // //                 id: jobDetail.id,
// // // //                 company: jobDetail.company_details?.company_name || "N/A",
// // // //                 position: jobDetail.title || "N/A",
// // // //                 match: scoreItem.matching_percentage || 0,
// // // //                 location: jobDetail.location || "N/A",
// // // //                 salary_min: jobDetail.salary_min,
// // // //                 salary_max: jobDetail.salary_max,
// // // //                 salary_currency: jobDetail.salary_currency,
// // // //                 posted_at: jobDetail.posted_at,
// // // //                 application_deadline: jobDetail.application_deadline,
// // // //                 visa_sponsorship: jobDetail.visa_sponsorship,
// // // //                 required_skills: jobDetail.required_skills || [],
// // // //                 urgent: jobDetail.urgent || false,
// // // //                 details: jobDetail,
// // // //               };
// // // //             })
// // // //             .filter((item) => item !== null)
// // // //             .sort((a, b) => b.match - a.match);
// // // //           setRecommendations(mappedRecommendations);
// // // //         } else {
// // // //           setRecommendations([]);
// // // //         }

// // // //         if (resumeResponse.data) {
// // // //           const resumeData = Array.isArray(resumeResponse.data)
// // // //             ? resumeResponse.data[0]
// // // //             : resumeResponse.data;
// // // //           if (resumeData) {
// // // //             if (resumeData.skills && Array.isArray(resumeData.skills)) {
// // // //               setTechnicalSkills(resumeData.skills);
// // // //             }
// // // //             if (
// // // //               resumeData.languages &&
// // // //               typeof resumeData.languages === "object" &&
// // // //               !Array.isArray(resumeData.languages)
// // // //             ) {
// // // //               const formattedLangs = Object.entries(resumeData.languages).map(
// // // //                 ([name, proficiency]) => ({
// // // //                   name,
// // // //                   proficiency,
// // // //                 })
// // // //               );
// // // //               setLanguages(formattedLangs);
// // // //             }
// // // //           }
// // // //         }

// // // //         if (progressResponse.data) {
// // // //           setProfileProgress(progressResponse.data);
// // // //         }
// // // //       } catch (error) {
// // // //         console.error("Failed to fetch dashboard data:", error);
// // // //       } finally {
// // // //         setTimeout(() => setLoading(false), 1200);
// // // //       }
// // // //     };
// // // //     fetchDashboardData();
// // // //   }, [navigate]);

// // // //   const handleViewDetails = (jobDetails) => {
// // // //     setSelectedJobDetails(jobDetails);
// // // //     setIsDetailsModalOpen(true);
// // // //   };

// // // //   const handleCloseDetailsModal = () => {
// // // //     setIsDetailsModalOpen(false);
// // // //     setSelectedJobDetails(null);
// // // //   };

// // // //   const handleQuickApply = async (jobId) => {
// // // //     setApplyingJobId(jobId);
// // // //     try {
// // // //       const response = await apiClient.post("/applications/", {
// // // //         job_posting: jobId,
// // // //       });
// // // //       const newApplication = response.data;
// // // //       const mappedNewApplication = {
// // // //         id: newApplication.id,
// // // //         job_posting: newApplication.job_posting,
// // // //         company:
// // // //           newApplication.job_posting_details?.company_details?.company_name ||
// // // //           "N/A",
// // // //         position: newApplication.job_posting_details?.title || "N/A",
// // // //         location: newApplication.job_posting_details?.location || "N/A",
// // // //         status: mapApplicationStatus(newApplication.status),
// // // //       };
// // // //       setApplications((prev) => [mappedNewApplication, ...prev]);
// // // //     } catch (error) {
// // // //       console.error("Failed to quick apply:", error);
// // // //     } finally {
// // // //       setApplyingJobId(null);
// // // //     }
// // // //   };

// // // //   const statsData = [
// // // //     {
// // // //       label: "Active Applications",
// // // //       value: applications.length,
// // // //       blobColor: theme.palette.warning.light,
// // // //     },
// // // //     {
// // // //       label: "Job Matches",
// // // //       value: recommendations.length,
// // // //       blobColor: theme.palette.error.light,
// // // //     },
// // // //     {
// // // //       label: "Job Notification",
// // // //       value: 120,
// // // //       blobColor: theme.palette.info.light,
// // // //     },
// // // //   ];

// // // //   if (loading) {
// // // //     return (
// // // //       <Layout title="Talent Dashboard">
// // // //         <Container maxWidth={false} sx={{ py: { xs: 2, md: 4 } }}>
// // // //           <Stack spacing={{ xs: 3, md: 4 }}>
// // // //             <WelcomeCardSkeleton />
// // // //             <Grid container spacing={2.5}>
// // // //               {[...Array(3)].map((_, index) => (
// // // //                 <Grid item xs={12} sm={4} key={index}>
// // // //                   <StatCardSkeleton />
// // // //                 </Grid>
// // // //               ))}
// // // //             </Grid>
// // // //             {/* Skeletons re-ordered to match new layout */}
// // // //             <SectionSkeleton
// // // //               titleWidth={250}
// // // //               items={4}
// // // //               CardSkeletonComponent={RecentApplicationSkeletonCard}
// // // //             />
// // // //             <SectionSkeleton
// // // //               titleWidth={280}
// // // //               items={4}
// // // //               CardSkeletonComponent={JobRecommendationSkeletonCard}
// // // //             />
// // // //             <SkillsAndLanguagesSkeleton />
// // // //           </Stack>
// // // //         </Container>
// // // //       </Layout>
// // // //     );
// // // //   }

// // // //   return (
// // // //     <Layout title="Talent Dashboard">
// // // //       <Container
// // // //         maxWidth={false}
// // // //         sx={{ py: { xs: 2, md: 4 }, fontFamily: "'Poppins', sans-serif" }}
// // // //       >
// // // //         <Stack spacing={{ xs: 3, md: 4 }}>
// // // //           <Card
// // // //             elevation={0}
// // // //             sx={{
// // // //               p: { xs: 2, md: 3 },
// // // //               borderRadius: "16px",
// // // //               bgcolor: "mint.main",
// // // //               boxShadow: "none",
// // // //             }}
// // // //           >
// // // //             <Stack
// // // //               direction={{ xs: "column", sm: "row" }}
// // // //               spacing={2}
// // // //               alignItems="center"
// // // //             >
// // // //               <Avatar
// // // //                 src="/placeholder.svg?height=60&width=60"
// // // //                 sx={{ width: 60, height: 60 }}
// // // //               />
// // // //               {profileProgress.progress_percentage === 100 ? (
// // // //                 <>
// // // //                   <Box
// // // //                     flexGrow={1}
// // // //                     sx={{
// // // //                       width: "100%",
// // // //                       textAlign: { xs: "center", sm: "left" },
// // // //                     }}
// // // //                   >
// // // //                     <Typography
// // // //                       variant="h5"
// // // //                       sx={{ fontWeight: "bold", color: "text.primary" }}
// // // //                     >
// // // //                       Your Profile is Complete! What's Next?
// // // //                     </Typography>
// // // //                     <Typography
// // // //                       sx={{
// // // //                         color: "text.primary",
// // // //                         fontSize: "0.9rem",
// // // //                         mt: 0.5,
// // // //                       }}
// // // //                     >
// // // //                       Take a mock interview to verify your skills and earn your
// // // //                       official Skillspassport.
// // // //                     </Typography>
// // // //                   </Box>
// // // //                   <Button
// // // //                     variant="contained"
// // // //                     color="primary"
// // // //                     onClick={() => navigate("/gatep/talent/exam-intro")}
// // // //                     sx={{
// // // //                       borderRadius: "20px",
// // // //                       textTransform: "none",
// // // //                       fontWeight: 600,
// // // //                       px: 3,
// // // //                       py: 1,
// // // //                       flexShrink: 0, // Prevents button from shrinking
// // // //                     }}
// // // //                   >
// // // //                     Start Mock Interview
// // // //                   </Button>
// // // //                 </>
// // // //               ) : (
// // // //                 <>
// // // //                   <Box
// // // //                     flexGrow={1}
// // // //                     sx={{
// // // //                       width: "100%",
// // // //                       textAlign: { xs: "center", sm: "left" },
// // // //                     }}
// // // //                   >
// // // //                     <Typography
// // // //                       variant="h5"
// // // //                       sx={{ fontWeight: "bold", color: "text.primary" }}
// // // //                     >
// // // //                       Welcome Back!
// // // //                     </Typography>
// // // //                     <Typography
// // // //                       sx={{ color: "text.primary", fontSize: "0.9rem" }}
// // // //                     >
// // // //                       {profileProgress.message}
// // // //                     </Typography>
// // // //                     <Stack
// // // //                       direction="row"
// // // //                       spacing={2}
// // // //                       alignItems="center"
// // // //                       sx={{ mt: 1 }}
// // // //                     >
// // // //                       <LinearProgress
// // // //                         variant="determinate"
// // // //                         value={profileProgress.progress_percentage || 0}
// // // //                         sx={{
// // // //                           flexGrow: 1,
// // // //                           height: 8,
// // // //                           borderRadius: "4px",
// // // //                           bgcolor: alpha(theme.palette.primary.main, 0.2),
// // // //                           "& .MuiLinearProgress-bar": {
// // // //                             bgcolor: "primary.main",
// // // //                           },
// // // //                         }}
// // // //                       />
// // // //                       <Typography
// // // //                         sx={{
// // // //                           fontWeight: "bold",
// // // //                           color: "primary.main",
// // // //                           fontSize: "0.9rem",
// // // //                         }}
// // // //                       >
// // // //                         {profileProgress.progress_percentage || 0}% Profile
// // // //                         Completed
// // // //                       </Typography>
// // // //                     </Stack>
// // // //                   </Box>
// // // //                   <Button
// // // //                     variant="contained"
// // // //                     color="primary"
// // // //                     onClick={() => navigate("/gatep/talent/profile")}
// // // //                     sx={{
// // // //                       borderRadius: "20px",
// // // //                       textTransform: "none",
// // // //                       fontWeight: 600,
// // // //                       px: 3,
// // // //                       py: 1,
// // // //                     }}
// // // //                   >
// // // //                     Complete Profile
// // // //                   </Button>
// // // //                 </>
// // // //               )}
// // // //             </Stack>
// // // //           </Card>

// // // //           <Box
// // // //             sx={{
// // // //               display: "flex",
// // // //               flexDirection: "row",
// // // //               gap: { xs: 1.5, sm: 2, md: 3 }, // Responsive gap between cards
// // // //             }}
// // // //           >
// // // //             {statsData.map((stat, index) => (
// // // //               <StatCard key={index} {...stat} />
// // // //             ))}
// // // //           </Box>

// // // //           {/* Section: Recent Applications (Horizontal Row) */}
// // // //           <Card
// // // //             elevation={0}
// // // //             sx={{
// // // //               p: { xs: 2, md: 3 },
// // // //               borderRadius: "20px",
// // // //               bgcolor: "mint.main",
// // // //               boxShadow: (theme) =>
// // // //                 `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// // // //             }}
// // // //           >
// // // //             <Typography
// // // //               variant="h5"
// // // //               sx={{
// // // //                 fontWeight: "bold",
// // // //                 color: "text.primary",
// // // //                 mb: 2,
// // // //               }}
// // // //             >
// // // //               Recent Application
// // // //             </Typography>
// // // //             <Stack
// // // //               direction="row"
// // // //               spacing={2.5}
// // // //               sx={{
// // // //                 overflowX: "auto",
// // // //                 pb: 1,
// // // //                 "&::-webkit-scrollbar": {
// // // //                   display: "none",
// // // //                 },
// // // //                 "-ms-overflow-style": "none",
// // // //                 "scrollbar-width": "none",
// // // //               }}
// // // //             >
// // // //               {applications.slice(0, 8).map((app) => (
// // // //                 <Card
// // // //                   key={app.id}
// // // //                   elevation={0}
// // // //                   sx={{
// // // //                     p: 2,
// // // //                     borderRadius: "20px",
// // // //                     bgcolor: "background.paper",
// // // //                     border: (theme) => `1px solid ${theme.palette.divider}`,
// // // //                     position: "relative",
// // // //                     overflow: "hidden",
// // // //                     minWidth: { xs: 280, sm: 320 },
// // // //                     flexShrink: 0,
// // // //                   }}
// // // //                 >
// // // //                   <Box
// // // //                     sx={{
// // // //                       position: "absolute",
// // // //                       width: 90,
// // // //                       height: 90,
// // // //                       borderRadius: "50%",
// // // //                       bgcolor: alpha(theme.palette.warning.main, 0.1),
// // // //                       top: -25,
// // // //                       right: 25,
// // // //                       zIndex: 0,
// // // //                     }}
// // // //                   />
// // // //                   <Box
// // // //                     sx={{
// // // //                       position: "absolute",
// // // //                       width: 70,
// // // //                       height: 70,
// // // //                       borderRadius: "50%",
// // // //                       bgcolor: alpha(theme.palette.warning.main, 0.1),
// // // //                       top: 15,
// // // //                       right: -25,
// // // //                       zIndex: 0,
// // // //                     }}
// // // //                   />
// // // //                   <Stack
// // // //                     spacing={2}
// // // //                     justifyContent="space-between"
// // // //                     sx={{ position: "relative", zIndex: 1 }}
// // // //                   >
// // // //                     <Stack direction="row" spacing={1.5} alignItems="center">
// // // //                       <Avatar
// // // //                         sx={{ bgcolor: "warning.light", width: 48, height: 48 }}
// // // //                       >
// // // //                         <WorkOutline sx={{ color: "primary.main" }} />
// // // //                       </Avatar>
// // // //                       <Box>
// // // //                         <Typography
// // // //                           sx={{
// // // //                             fontWeight: "bold",
// // // //                             fontSize: "18px",
// // // //                             color: "text.primary",
// // // //                             lineHeight: 1.2,
// // // //                           }}
// // // //                         >
// // // //                           {app.position}
// // // //                         </Typography>
// // // //                         <Typography
// // // //                           sx={{
// // // //                             fontSize: "14px",
// // // //                             color: "text.secondary",
// // // //                             display: "flex",
// // // //                             alignItems: "center",
// // // //                             mt: 0.5,
// // // //                           }}
// // // //                         >
// // // //                           <LocationOn sx={{ fontSize: "16px", mr: 0.5 }} />
// // // //                           {app.company}
// // // //                         </Typography>
// // // //                       </Box>
// // // //                     </Stack>
// // // //                     <Box sx={{ alignSelf: "flex-end" }}>
// // // //                       <Chip
// // // //                         label={app.status}
// // // //                         sx={{
// // // //                           bgcolor:
// // // //                             app.status === "Applied"
// // // //                               ? "success.main"
// // // //                               : "primary.main",
// // // //                           color: "primary.contrastText",
// // // //                           borderRadius: "16px",
// // // //                           fontWeight: 500,
// // // //                           fontSize: "13px",
// // // //                           height: "32px",
// // // //                           ".MuiChip-label": { px: 2 },
// // // //                         }}
// // // //                       />
// // // //                     </Box>
// // // //                   </Stack>
// // // //                 </Card>
// // // //               ))}
// // // //             </Stack>
// // // //             <Box sx={{ textAlign: "center", pt: 3 }}>
// // // //               <Button
// // // //                 endIcon={<ArrowForward />}
// // // //                 color="primary"
// // // //                 variant="contained"
// // // //                 onClick={() => navigate("/gatep/talent/jobs")}
// // // //                 sx={{
// // // //                   borderRadius: "30px",
// // // //                   textTransform: "none",
// // // //                   fontWeight: "bold",
// // // //                   fontSize: "14px",
// // // //                   height: "40px",
// // // //                   px: 4,
// // // //                   width: "100%",
// // // //                   maxWidth: "350px",
// // // //                   mx: "auto",
// // // //                 }}
// // // //               >
// // // //                 View All Recent Application
// // // //               </Button>
// // // //             </Box>
// // // //           </Card>

// // // //           {/* Section: AI Job Recommendations */}
// // // //           <Card
// // // //             elevation={0}
// // // //             sx={{
// // // //               p: { xs: 2, md: 3 },
// // // //               borderRadius: "20px",
// // // //               bgcolor: "mint.main",
// // // //               boxShadow: (theme) =>
// // // //                 `0px 4px 12px ${alpha(theme.palette.common.black, 0.05)}`,
// // // //               display: "flex",
// // // //               flexDirection: "column",
// // // //               height: "100%",
// // // //             }}
// // // //           >
// // // //             <Typography
// // // //               variant="h5"
// // // //               sx={{ fontWeight: "bold", color: "text.primary", mb: 3 }}
// // // //             >
// // // //               AI Job Recommendations
// // // //             </Typography>
// // // //             <Stack
// // // //               direction="row"
// // // //               spacing={2.5}
// // // //               sx={{
// // // //                 overflowX: "auto",
// // // //                 pb: 2,
// // // //                 "&::-webkit-scrollbar": {
// // // //                   display: "none",
// // // //                 },
// // // //                 "-ms-overflow-style": "none",
// // // //                 "scrollbar-width": "none",
// // // //               }}
// // // //             >
// // // //               {recommendations.slice(0, 6).map((rec) => {
// // // //                 const isApplying = applyingJobId === rec.id;
// // // //                 const isAlreadyApplied = applications.some(
// // // //                   (app) => String(app.job_posting) === String(rec.id)
// // // //                 );
// // // //                 const displaySkills = rec.required_skills.slice(0, 3);
// // // //                 const remainingSkills =
// // // //                   rec.required_skills.length - displaySkills.length;
// // // //                 return (
// // // //                   <Card
// // // //                     key={rec.id}
// // // //                     elevation={0}
// // // //                     sx={{
// // // //                       p: 2.5,
// // // //                       borderRadius: "20px",
// // // //                       border: (theme) => `1px solid ${theme.palette.divider}`,
// // // //                       bgcolor: "background.paper",
// // // //                       display: "flex",
// // // //                       flexDirection: "column",
// // // //                       gap: 1.5,
// // // //                       width: { xs: 300, sm: 360 },
// // // //                       flexShrink: 0,
// // // //                     }}
// // // //                   >
// // // //                     <Stack
// // // //                       direction="row"
// // // //                       justifyContent="space-between"
// // // //                       alignItems="flex-start"
// // // //                     >
// // // //                       <Stack direction="row" spacing={1.5} alignItems="center">
// // // //                         <Avatar
// // // //                           variant="circular"
// // // //                           sx={{
// // // //                             bgcolor: "warning.light",
// // // //                             width: 48,
// // // //                             height: 48,
// // // //                           }}
// // // //                         >
// // // //                           <WorkOutline sx={{ color: "primary.main" }} />
// // // //                         </Avatar>
// // // //                         <Box sx={{ minHeight: "54px" }}>
// // // //                           <Typography
// // // //                             sx={{
// // // //                               fontWeight: "bold",
// // // //                               fontSize: "18px",
// // // //                               color: "text.primary",
// // // //                               overflow: "hidden",
// // // //                               textOverflow: "ellipsis",
// // // //                               display: "-webkit-box",
// // // //                               WebkitLineClamp: "2",
// // // //                               WebkitBoxOrient: "vertical",
// // // //                             }}
// // // //                           >
// // // //                             {rec.position}
// // // //                           </Typography>
// // // //                           <Typography
// // // //                             sx={{
// // // //                               fontSize: "14px",
// // // //                               color: "text.secondary",
// // // //                             }}
// // // //                           >
// // // //                             {rec.company}
// // // //                           </Typography>
// // // //                         </Box>
// // // //                       </Stack>
// // // //                       <Stack alignItems="flex-end" spacing={1}>
// // // //                         {rec.urgent && (
// // // //                           <Chip
// // // //                             label="Urgent Hiring"
// // // //                             size="small"
// // // //                             sx={{
// // // //                               bgcolor: alpha(theme.palette.warning.main, 0.2),
// // // //                               color: "warning.dark",
// // // //                               fontWeight: 500,
// // // //                               borderRadius: "16px",
// // // //                               height: "auto",
// // // //                               ".MuiChip-label": { py: "2px", px: "8px" },
// // // //                             }}
// // // //                           />
// // // //                         )}
// // // //                         <IconButton size="small">
// // // //                           <BookmarkBorder />
// // // //                         </IconButton>
// // // //                       </Stack>
// // // //                     </Stack>
// // // //                     <Stack spacing={0.5}>
// // // //                       <Stack direction="row" spacing={1}>
// // // //                         <LocationOn
// // // //                           sx={{
// // // //                             fontSize: "16px",
// // // //                             color: "text.secondary",
// // // //                             mt: "2px",
// // // //                           }}
// // // //                         />
// // // //                         <Typography
// // // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // // //                         >
// // // //                           {rec.location}
// // // //                         </Typography>
// // // //                         {rec.visa_sponsorship && (
// // // //                           <Chip
// // // //                             label="Visa Sponsored"
// // // //                             size="small"
// // // //                             sx={{
// // // //                               bgcolor: alpha(theme.palette.primary.main, 0.15),
// // // //                               color: "primary.main",
// // // //                               fontWeight: 500,
// // // //                               borderRadius: "8px",
// // // //                               height: "auto",
// // // //                               ".MuiChip-label": { py: "1px" },
// // // //                             }}
// // // //                           />
// // // //                         )}
// // // //                       </Stack>
// // // //                       <Stack direction="row" spacing={1}>
// // // //                         <AttachMoney
// // // //                           sx={{
// // // //                             fontSize: "16px",
// // // //                             color: "text.secondary",
// // // //                             mt: "2px",
// // // //                           }}
// // // //                         />
// // // //                         <Typography
// // // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // // //                         >{`$${(rec.salary_min / 1000).toFixed(0)}k-$${(
// // // //                           rec.salary_max / 1000
// // // //                         ).toFixed(0)}k`}</Typography>
// // // //                         <WorkOutline
// // // //                           sx={{
// // // //                             fontSize: "16px",
// // // //                             color: "text.secondary",
// // // //                             mt: "2px",
// // // //                             ml: 1,
// // // //                           }}
// // // //                         />
// // // //                         <Typography
// // // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // // //                         >
// // // //                           {rec.details.job_type_display}
// // // //                         </Typography>
// // // //                       </Stack>
// // // //                       <Stack direction="row" spacing={1}>
// // // //                         <AccessTime
// // // //                           sx={{
// // // //                             fontSize: "16px",
// // // //                             color: "text.secondary",
// // // //                             mt: "2px",
// // // //                           }}
// // // //                         />
// // // //                         <Typography
// // // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // // //                         >
// // // //                           {new Date(
// // // //                             rec.application_deadline || rec.posted_at
// // // //                           ).toLocaleDateString()}
// // // //                         </Typography>
// // // //                       </Stack>
// // // //                     </Stack>

// // // //                     <Box>
// // // //                       <Stack
// // // //                         direction="row"
// // // //                         justifyContent="space-between"
// // // //                         alignItems="center"
// // // //                       >
// // // //                         <Typography
// // // //                           sx={{
// // // //                             fontSize: "14px",
// // // //                             fontWeight: 600,
// // // //                             color: "text.primary",
// // // //                           }}
// // // //                         >
// // // //                           AI Match Score
// // // //                         </Typography>
// // // //                         <Typography
// // // //                           sx={{
// // // //                             fontSize: "14px",
// // // //                             fontWeight: "bold",
// // // //                             color: "success.main",
// // // //                           }}
// // // //                         >
// // // //                           {rec.match}%
// // // //                         </Typography>
// // // //                       </Stack>
// // // //                       <LinearProgress
// // // //                         variant="determinate"
// // // //                         value={rec.match}
// // // //                         sx={{
// // // //                           mt: 0.5,
// // // //                           height: 6,
// // // //                           borderRadius: 3,
// // // //                           bgcolor: "divider",
// // // //                           "& .MuiLinearProgress-bar": {
// // // //                             bgcolor: "success.main",
// // // //                           },
// // // //                         }}
// // // //                       />
// // // //                     </Box>
// // // //                     <Box sx={{ minHeight: "68px" }}>
// // // //                       <Typography
// // // //                         sx={{
// // // //                           fontSize: "14px",
// // // //                           color: "text.secondary",
// // // //                           mb: 1,
// // // //                         }}
// // // //                       >
// // // //                         Required Skills
// // // //                       </Typography>
// // // //                       <Stack
// // // //                         direction="row"
// // // //                         useFlexGap
// // // //                         flexWrap="wrap"
// // // //                         spacing={1}
// // // //                       >
// // // //                         {displaySkills.map((skill, index) => (
// // // //                           <Chip
// // // //                             key={`${skill}-${index}`}
// // // //                             label={skill}
// // // //                             variant="outlined"
// // // //                             size="small"
// // // //                           />
// // // //                         ))}
// // // //                         {remainingSkills > 0 && (
// // // //                           <Chip
// // // //                             label={`+${remainingSkills}`}
// // // //                             size="small"
// // // //                             sx={{
// // // //                               bgcolor: "primary.light",
// // // //                               color: "primary.main",
// // // //                               borderRadius: "50%",
// // // //                               fontWeight: "bold",
// // // //                             }}
// // // //                           />
// // // //                         )}
// // // //                       </Stack>
// // // //                     </Box>
// // // //                     <Stack
// // // //                       direction="row"
// // // //                       spacing={1.5}
// // // //                       sx={{ mt: "auto", pt: 2 }}
// // // //                     >
// // // //                       <Button
// // // //                         fullWidth
// // // //                         variant="outlined"
// // // //                         color="primary"
// // // //                         onClick={() => handleViewDetails(rec.details)}
// // // //                         sx={{
// // // //                           borderRadius: "30px",
// // // //                           textTransform: "none",
// // // //                           fontWeight: 600,
// // // //                         }}
// // // //                       >
// // // //                         View Details
// // // //                       </Button>
// // // //                       <Button
// // // //                         fullWidth
// // // //                         variant="contained"
// // // //                         color="primary"
// // // //                         onClick={() => handleQuickApply(rec.id)}
// // // //                         disabled={isApplying || isAlreadyApplied}
// // // //                         sx={{
// // // //                           borderRadius: "30px",
// // // //                           boxShadow: "none",
// // // //                           textTransform: "none",
// // // //                           fontWeight: 600,
// // // //                         }}
// // // //                       >
// // // //                         {isApplying ? (
// // // //                           <CircularProgress size={24} color="inherit" />
// // // //                         ) : isAlreadyApplied ? (
// // // //                           "Applied"
// // // //                         ) : (
// // // //                           "Quick Apply"
// // // //                         )}
// // // //                       </Button>
// // // //                     </Stack>
// // // //                   </Card>
// // // //                 );
// // // //               })}
// // // //             </Stack>
// // // //             <Box sx={{ textAlign: "center", pt: 3, mt: "auto" }}>
// // // //               <Button
// // // //                 endIcon={<ArrowForward />}
// // // //                 color="primary"
// // // //                 variant="contained"
// // // //                 onClick={() => navigate("/gatep/talent/jobs")}
// // // //                 sx={{
// // // //                   borderRadius: "30px",
// // // //                   textTransform: "none",
// // // //                   fontWeight: "bold",
// // // //                   fontSize: "14px",
// // // //                   height: "40px",
// // // //                   px: 4,
// // // //                   width: "100%",
// // // //                   maxWidth: "350px",
// // // //                   mx: "auto",
// // // //                 }}
// // // //               >
// // // //                 View All AI JOB Recomendation
// // // //               </Button>
// // // //             </Box>
// // // //           </Card>
// // // //         </Stack>
// // // //         <JobDetailsModal
// // // //           open={isDetailsModalOpen}
// // // //           onClose={handleCloseDetailsModal}
// // // //           job={selectedJobDetails}
// // // //         />
// // // //       </Container>
// // // //     </Layout>
// // // //   );
// // // // };

// // // // export default TalentDashboard;

// // // "use client";

// // // import { useState, useEffect, useRef } from "react"; // 1. Import useRef
// // // import {
// // //   Grid,
// // //   Card,
// // //   Typography,
// // //   Button,
// // //   Box,
// // //   Chip,
// // //   LinearProgress,
// // //   List,
// // //   ListItem,
// // //   ListItemText,
// // //   ListItemIcon,
// // //   Avatar,
// // //   Stack,
// // //   Skeleton,
// // //   alpha,
// // //   Container,
// // //   CardContent,
// // //   CircularProgress,
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   IconButton,
// // //   darken,
// // // } from "@mui/material";
// // // import {
// // //   TrendingUp,
// // //   LocationOn,
// // //   ArrowForward,
// // //   CheckCircle,
// // //   Close as CloseIcon,
// // //   AttachMoney,
// // //   Event,
// // //   Beenhere,
// // //   WorkOutline,
// // //   BookmarkBorder,
// // //   AccessTime,
// // // } from "@mui/icons-material";
// // // import Layout from "../components/common/Layout";
// // // import { useNavigate } from "react-router-dom";
// // // import { useTheme } from "@mui/material/styles";
// // // import apiClient from "../context/apiClient";

// // // const JobDetailsModal = ({ open, onClose, job }) => {
// // //   const theme = useTheme();
// // //   if (!job) return null;
// // //   return (
// // //     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
// // //       <DialogTitle sx={{ m: 0, p: 2, pr: 8, bgcolor: "#F1FFFA" }}>
// // //         <Stack direction="row" spacing={2} alignItems="center">
// // //           <Avatar
// // //             src={job.company_details?.logo}
// // //             variant="rounded"
// // //             sx={{ width: 56, height: 56 }}
// // //           />
// // //           <Box>
// // //             <Typography variant="h5" component="div" fontWeight={700}>
// // //               {job.title}
// // //             </Typography>
// // //             <Typography variant="body1" color="text.secondary">
// // //               {job.company_details?.company_name}
// // //             </Typography>
// // //           </Box>
// // //         </Stack>
// // //         <IconButton
// // //           aria-label="close"
// // //           onClick={onClose}
// // //           sx={{
// // //             position: "absolute",
// // //             right: 8,
// // //             top: 8,
// // //             color: "text.secondary",
// // //           }}
// // //         >
// // //           <CloseIcon />
// // //         </IconButton>
// // //       </DialogTitle>
// // //       <DialogContent dividers sx={{ bgcolor: "#F1FFFA" }}>
// // //         <Stack
// // //           direction="row"
// // //           spacing={1}
// // //           useFlexGap
// // //           flexWrap="wrap"
// // //           sx={{ mb: 3 }}
// // //         >
// // //           <Chip icon={<LocationOn />} label={job.location} variant="outlined" />
// // //           <Chip
// // //             icon={<WorkOutline />}
// // //             label={job.job_type_display}
// // //             variant="outlined"
// // //           />
// // //           <Chip
// // //             icon={<TrendingUp />}
// // //             label={job.experience_level_display}
// // //             variant="outlined"
// // //           />
// // //           {job.remote_work && (
// // //             <Chip label="Remote Available" color="success" variant="outlined" />
// // //           )}
// // //           {job.visa_sponsorship && (
// // //             <Chip
// // //               label="Visa Sponsorship"
// // //               sx={{
// // //                 backgroundColor: "primary.main",
// // //                 color: "primary.contrastText",
// // //                 fontWeight: 500,
// // //               }}
// // //             />
// // //           )}
// // //         </Stack>
// // //         {job.salary_min && job.salary_max && (
// // //           <Box
// // //             display="flex"
// // //             alignItems="center"
// // //             mb={3}
// // //             p={2}
// // //             bgcolor={alpha(theme.palette.success.main, 0.1)}
// // //             borderRadius={2}
// // //           >
// // //             <AttachMoney sx={{ mr: 1, color: "success.main" }} />
// // //             <Typography
// // //               variant="h6"
// // //               component="p"
// // //               fontWeight={600}
// // //               color="success.dark"
// // //             >
// // //               {`${new Intl.NumberFormat("en-US", {
// // //                 style: "currency",
// // //                 currency: job.salary_currency || "USD",
// // //               }).format(job.salary_min)} - ${new Intl.NumberFormat("en-US", {
// // //                 style: "currency",
// // //                 currency: job.salary_currency || "USD",
// // //               }).format(job.salary_max)}`}
// // //             </Typography>
// // //           </Box>
// // //         )}
// // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // //           Job Description
// // //         </Typography>
// // //         <Typography
// // //           variant="body2"
// // //           sx={{
// // //             whiteSpace: "pre-wrap",
// // //             mb: 3,
// // //             color: "text.secondary",
// // //             lineHeight: 1.7,
// // //           }}
// // //         >
// // //           {job.description}
// // //         </Typography>
// // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // //           Responsibilities
// // //         </Typography>
// // //         <Typography
// // //           variant="body2"
// // //           sx={{
// // //             whiteSpace: "pre-wrap",
// // //             mb: 3,
// // //             color: "text.secondary",
// // //             lineHeight: 1.7,
// // //           }}
// // //         >
// // //           {job.responsibilities}
// // //         </Typography>
// // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // //           Requirements
// // //         </Typography>
// // //         <List dense sx={{ mb: 2 }}>
// // //           {job.requirements?.map((req, i) => (
// // //             <ListItem key={i} disableGutters>
// // //               <ListItemIcon sx={{ minWidth: 32 }}>
// // //                 <CheckCircle color="primary" fontSize="small" />
// // //               </ListItemIcon>
// // //               <ListItemText primary={req} />
// // //             </ListItem>
// // //           ))}
// // //         </List>
// // //         <Typography variant="h6" gutterBottom fontWeight={700}>
// // //           Required Skills
// // //         </Typography>
// // //         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
// // //           {job.required_skills?.map((skill, i) => (
// // //             <Chip key={i} label={skill} variant="outlined" />
// // //           ))}
// // //         </Box>
// // //         {job.benefits?.length > 0 && (
// // //           <>
// // //             <Typography variant="h6" gutterBottom fontWeight={700}>
// // //               Benefits
// // //             </Typography>
// // //             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
// // //               {job.benefits.map((benefit, i) => (
// // //                 <Chip
// // //                   key={i}
// // //                   icon={<Beenhere />}
// // //                   label={benefit}
// // //                   variant="outlined"
// // //                   color="success"
// // //                 />
// // //               ))}
// // //             </Box>
// // //           </>
// // //         )}
// // //         {job.application_deadline && (
// // //           <Box
// // //             display="flex"
// // //             alignItems="center"
// // //             mt={2}
// // //             p={1.5}
// // //             bgcolor={alpha(theme.palette.warning.main, 0.1)}
// // //             borderRadius={2}
// // //           >
// // //             <Event sx={{ mr: 1, color: "warning.main" }} />
// // //             <Typography
// // //               variant="body2"
// // //               component="p"
// // //               fontWeight={600}
// // //               color="warning.dark"
// // //             >
// // //               Application Deadline:{" "}
// // //               {new Date(job.application_deadline).toLocaleDateString()}
// // //             </Typography>
// // //           </Box>
// // //         )}
// // //       </DialogContent>
// // //       <DialogActions sx={{ p: { xs: 2, sm: 3 }, bgcolor: "#F1FFFA" }}>
// // //         <Button onClick={onClose} color="inherit">
// // //           Close
// // //         </Button>
// // //       </DialogActions>
// // //     </Dialog>
// // //   );
// // // };

// // // const WelcomeCardSkeleton = () => (
// // //   <Card
// // //     elevation={0}
// // //     sx={{
// // //       p: { xs: 2, md: 3 },
// // //       borderRadius: "16px",
// // //       bgcolor: "mint.main",
// // //       boxShadow: "none",
// // //     }}
// // //   >
// // //     <Stack
// // //       direction={{ xs: "column", sm: "row" }}
// // //       spacing={2}
// // //       alignItems="center"
// // //     >
// // //       <Skeleton variant="circular" width={60} height={60} />
// // //       <Box flexGrow={1} sx={{ width: "100%" }}>
// // //         <Skeleton variant="text" width="40%" height={32} />
// // //         <Skeleton variant="text" width="60%" height={24} />
// // //         <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 1 }}>
// // //           <Skeleton
// // //             variant="rectangular"
// // //             height={8}
// // //             sx={{ flexGrow: 1, borderRadius: "4px" }}
// // //           />
// // //           <Skeleton variant="text" width="25%" height={24} />
// // //         </Stack>
// // //       </Box>
// // //       <Skeleton
// // //         variant="rectangular"
// // //         height={44}
// // //         width={180}
// // //         sx={{ borderRadius: "20px" }}
// // //       />
// // //     </Stack>
// // //   </Card>
// // // );

// // // const StatCardSkeleton = () => (
// // //   <Skeleton
// // //     variant="rectangular"
// // //     height={{ xs: 100, sm: 120 }}
// // //     sx={{ borderRadius: "14px", flex: 1, minWidth: 0 }}
// // //   />
// // // );

// // // const SectionSkeleton = ({
// // //   titleWidth = 200,
// // //   items = 3,
// // //   CardSkeletonComponent,
// // // }) => (
// // //   <Card
// // //     elevation={0}
// // //     sx={{
// // //       p: { xs: 2, md: 4 },
// // //       borderRadius: "20px",
// // //       bgcolor: "mint.main",
// // //       height: "100%",
// // //     }}
// // //   >
// // //     <Skeleton variant="text" width={titleWidth} height={40} sx={{ mb: 3 }} />
// // //     <Grid container spacing={2.5}>
// // //       {[...Array(items)].map((_, index) =>
// // //         CardSkeletonComponent ? <CardSkeletonComponent key={index} /> : null
// // //       )}
// // //     </Grid>
// // //     <Box sx={{ textAlign: "center", pt: 3 }}>
// // //       <Skeleton
// // //         variant="rectangular"
// // //         width={250}
// // //         height={40}
// // //         sx={{ borderRadius: "30px", mx: "auto" }}
// // //       />
// // //     </Box>
// // //   </Card>
// // // );

// // // const RecentApplicationSkeletonCard = () => (
// // //   <Grid item xs={12}>
// // //     <Card
// // //       elevation={0}
// // //       sx={{
// // //         p: 2,
// // //         borderRadius: "20px",
// // //         bgcolor: "#F1FFFA",
// // //         border: (theme) => `1px solid ${theme.palette.divider}`,
// // //       }}
// // //     >
// // //       <Stack spacing={2} justifyContent="space-between" height="100%">
// // //         <Stack direction="row" spacing={1.5} alignItems="center">
// // //           <Skeleton variant="circular" width={48} height={48} />
// // //           <Box>
// // //             <Skeleton variant="text" width={120} height={28} />
// // //             <Skeleton variant="text" width={100} height={20} />
// // //           </Box>
// // //         </Stack>
// // //         <Skeleton
// // //           variant="rectangular"
// // //           width={100}
// // //           height={32}
// // //           sx={{ borderRadius: "16px", alignSelf: "flex-end" }}
// // //         />
// // //       </Stack>
// // //     </Card>
// // //   </Grid>
// // // );

// // // const JobRecommendationSkeletonCard = () => (
// // //   <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
// // //     <Card
// // //       elevation={0}
// // //       sx={{
// // //         p: 3,
// // //         borderRadius: "20px",
// // //         border: (theme) => `1px solid ${theme.palette.divider}`,
// // //         bgcolor: "background.paper",
// // //         height: "100%",
// // //         width: "100%",
// // //         display: "flex",
// // //         flexDirection: "column",
// // //         gap: 1.5,
// // //       }}
// // //     >
// // //       <Stack
// // //         direction="row"
// // //         justifyContent="space-between"
// // //         alignItems="flex-start"
// // //       >
// // //         <Box>
// // //           <Skeleton variant="text" width={150} height={28} />
// // //           <Skeleton variant="text" width={100} height={20} />
// // //         </Box>
// // //         <Skeleton variant="circular" width={24} height={24} />
// // //       </Stack>
// // //       <Stack spacing={0.5}>
// // //         <Skeleton variant="text" width="50%" />
// // //         <Skeleton variant="text" width="70%" />
// // //         <Skeleton variant="text" width="40%" />
// // //       </Stack>
// // //       <Box>
// // //         <Stack
// // //           direction="row"
// // //           justifyContent="space-between"
// // //           alignItems="center"
// // //         >
// // //           <Skeleton variant="text" width="30%" />
// // //           <Skeleton variant="text" width="20%" />
// // //         </Stack>
// // //         <Skeleton
// // //           variant="rectangular"
// // //           height={6}
// // //           sx={{ mt: 1, borderRadius: 3 }}
// // //         />
// // //       </Box>
// // //       <Box>
// // //         <Skeleton variant="text" width="40%" sx={{ mb: 1 }} />
// // //         <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1}>
// // //           <Skeleton
// // //             variant="rectangular"
// // //             width={80}
// // //             height={24}
// // //             sx={{ borderRadius: "16px" }}
// // //           />
// // //           <Skeleton
// // //             variant="rectangular"
// // //             width={90}
// // //             height={24}
// // //             sx={{ borderRadius: "16px" }}
// // //           />
// // //         </Stack>
// // //       </Box>
// // //       <Stack direction="row" spacing={1.5} sx={{ mt: "auto", pt: 2 }}>
// // //         <Skeleton
// // //           variant="rectangular"
// // //           width="100%"
// // //           height={40}
// // //           sx={{ borderRadius: "30px" }}
// // //         />
// // //         <Skeleton
// // //           variant="rectangular"
// // //           width="100%"
// // //           height={40}
// // //           sx={{ borderRadius: "30px" }}
// // //         />
// // //       </Stack>
// // //     </Card>
// // //   </Grid>
// // // );

// // // const SkillsAndLanguagesSkeleton = () => (
// // //   <Grid container spacing={3}>
// // //     <Grid item xs={12} md={8}>
// // //       <Card
// // //         elevation={0}
// // //         sx={{
// // //           p: 3,
// // //           borderRadius: "12px",
// // //           bgcolor: "mint.main",
// // //           boxShadow: (theme) =>
// // //             `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// // //           height: "100%",
// // //         }}
// // //       >
// // //         <Skeleton variant="text" width="40%" height={32} />
// // //         <Skeleton
// // //           variant="text"
// // //           width="30%"
// // //           height={24}
// // //           sx={{ mt: 1, mb: 2 }}
// // //         />
// // //         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 3 }}>
// // //           {[...Array(8)].map((_, i) => (
// // //             <Skeleton
// // //               key={i}
// // //               variant="rectangular"
// // //               width={100}
// // //               height={36}
// // //               sx={{ borderRadius: "20px" }}
// // //             />
// // //           ))}
// // //         </Box>
// // //       </Card>
// // //     </Grid>
// // //     <Grid item xs={12} md={4}>
// // //       <Card
// // //         elevation={0}
// // //         sx={{
// // //           p: 3,
// // //           borderRadius: "12px",
// // //           bgcolor: "mint.main",
// // //           boxShadow: (theme) =>
// // //             `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// // //           height: "100%",
// // //         }}
// // //       >
// // //         <Skeleton variant="text" width="50%" height={32} sx={{ mb: 3 }} />
// // //         <Grid container spacing={1.5} sx={{ mb: 3 }}>
// // //           {[...Array(6)].map((_, i) => (
// // //             <Grid item xs={6} key={i}>
// // //               <Skeleton
// // //                 variant="rectangular"
// // //                 width="100%"
// // //                 height={36}
// // //                 sx={{ borderRadius: "20px" }}
// // //               />
// // //             </Grid>
// // //           ))}
// // //         </Grid>
// // //       </Card>
// // //     </Grid>
// // //   </Grid>
// // // );

// // // const mapApplicationStatus = (apiStatus) => {
// // //   switch (apiStatus) {
// // //     case "SCHEDULED":
// // //       return "Interview Scheduled";
// // //     case "UNDER_REVIEW":
// // //     case "REVIEW":
// // //       return "Under Review";
// // //     case "APPLIED":
// // //       return "Applied";
// // //     case "SHORTLISTED":
// // //       return "Shortlisted";
// // //     default:
// // //       return apiStatus;
// // //   }
// // // };
// // // const StatCard = ({ value, label, blobColor }) => {
// // //   const theme = useTheme();
// // //   // Use the provided blobColor or default to the theme's accent color
// // //   const primaryBlobColor = blobColor || theme.palette.accent.main;
// // //   // Create a slightly darker version for the background blob
// // //   const darkerBlobColor = darken(primaryBlobColor, 0.1);

// // //   return (
// // //     <Card
// // //       elevation={0}
// // //       sx={{
// // //         backgroundColor: theme.palette.primary.main,
// // //         borderRadius: "20px",
// // //         boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
// // //         p: { xs: 1.5, sm: 2.5 },
// // //         position: "relative",
// // //         overflow: "hidden",
// // //         color: theme.palette.primary.contrastText,
// // //         display: "flex",
// // //         flexDirection: "column",
// // //         justifyContent: "center",
// // //         flex: 1, // Essential for responsive row
// // //         minWidth: 0, // Essential for responsive row
// // //         height: { xs: 100, sm: 120 },
// // //       }}
// // //     >
// // //       <Box
// // //         sx={{
// // //           position: "absolute",
// // //           top: 0,
// // //           right: 0,
// // //           bottom: 0,
// // //           width: "60%",
// // //           zIndex: 0, // SVG is in the back
// // //         }}
// // //       >
// // //         <svg
// // //           width="100%"
// // //           height="100%"
// // //           viewBox="0 0 80 120"
// // //           preserveAspectRatio="none"
// // //           style={{
// // //             filter: `drop-shadow(-4px 4px 8px ${alpha(
// // //               theme.palette.common.black,
// // //               0.2
// // //             )})`,
// // //           }}
// // //         >
// // //           <path
// // //             d="M 40,0 C 80,30 0,90 20,120 L 80,120 L 80,0 Z"
// // //             fill={darkerBlobColor}
// // //           />
// // //           <path
// // //             d="M 50,0 C 90,30 10,90 30,120 L 80,120 L 80,0 Z"
// // //             fill={primaryBlobColor}
// // //           />
// // //         </svg>
// // //       </Box>
// // //       <Stack sx={{ position: "relative", zIndex: 1 }}>
// // //         <Typography
// // //           sx={{
// // //             textTransform: "uppercase",
// // //             fontSize: { xs: "11px", sm: "13px" },
// // //             fontWeight: 500,
// // //             color: alpha(theme.palette.primary.contrastText, 0.7),
// // //             mb: 0.5,
// // //           }}
// // //         >
// // //           {label}
// // //         </Typography>
// // //         <Typography
// // //           sx={{
// // //             fontSize: { xs: "28px", sm: "34px" },
// // //             fontWeight: 700,
// // //             color: "primary.contrastText",
// // //             lineHeight: 1.1,
// // //           }}
// // //         >
// // //           {value}
// // //         </Typography>
// // //       </Stack>
// // //     </Card>
// // //   );
// // // };

// // // const TalentDashboard = () => {
// // //   const navigate = useNavigate();
// // //   const theme = useTheme();
// // //   const [applications, setApplications] = useState([]);
// // //   const [recommendations, setRecommendations] = useState([]);
// // //   const [technicalSkills, setTechnicalSkills] = useState([]);
// // //   const [languages, setLanguages] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [applyingJobId, setApplyingJobId] = useState(null);
// // //   const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
// // //   const [selectedJobDetails, setSelectedJobDetails] = useState(null);
// // //   const [profileProgress, setProfileProgress] = useState({
// // //     progress_percentage: 0,
// // //     message: "Loading your profile progress...",
// // //     // missing_sections: [],
// // //   });

// // //   // 2. Add a useRef to track if the effect has already run
// // //   const effectRan = useRef(false);

// // //   useEffect(() => {
// // //     // 3. Prevent the effect from running twice in development due to StrictMode
// // //     if (effectRan.current === true) {
// // //       return;
// // //     }

// // //     const fetchDashboardData = async () => {
// // //       setLoading(true);
// // //       const token = localStorage.getItem("access_token");
// // //       if (!token) {
// // //         setLoading(false);
// // //         navigate("/gatep/login");
// // //         return;
// // //       }
// // //       try {
// // //         const [
// // //           applicationsResponse,
// // //           aiScoresResponse,
// // //           resumeResponse,
// // //           progressResponse,
// // //         ] = await Promise.all([
// // //           apiClient.get("/applications/"),
// // //           apiClient.get("/job-postings/ai-score/"),
// // //           apiClient.get("/resume-builder/"),
// // //           apiClient.get("/resume-progress/"),
// // //         ]);

// // //         if (
// // //           applicationsResponse.data &&
// // //           Array.isArray(applicationsResponse.data)
// // //         ) {
// // //           const mappedApplications = applicationsResponse.data.map((app) => ({
// // //             id: app.id,
// // //             job_posting: app.job_posting,
// // //             company:
// // //               app.job_posting_details?.company_details?.company_name || "N/A",
// // //             position: app.job_posting_details?.title || "N/A",
// // //             location: app.job_posting_details?.location || "N/A",
// // //             status: mapApplicationStatus(app.status),
// // //           }));
// // //           setApplications(mappedApplications);
// // //         }

// // //         const aiScoresData = aiScoresResponse.data;
// // //         if (
// // //           aiScoresData &&
// // //           Array.isArray(aiScoresData) &&
// // //           aiScoresData.length > 0
// // //         ) {
// // //           const recommendationDetailPromises = aiScoresData.map((scoreItem) =>
// // //             apiClient.get(`/job-postings/${scoreItem.id}/`)
// // //           );
// // //           const recommendationDetailResponses = await Promise.all(
// // //             recommendationDetailPromises
// // //           );
// // //           const jobDetailsList = recommendationDetailResponses.map(
// // //             (res) => res.data
// // //           );
// // //           const mappedRecommendations = aiScoresData
// // //             .map((scoreItem) => {
// // //               const jobDetail = jobDetailsList.find(
// // //                 (detail) => detail.id === scoreItem.id
// // //               );
// // //               if (!jobDetail) return null;
// // //               return {
// // //                 id: jobDetail.id,
// // //                 company: jobDetail.company_details?.company_name || "N/A",
// // //                 position: jobDetail.title || "N/A",
// // //                 match: scoreItem.matching_percentage || 0,
// // //                 location: jobDetail.location || "N/A",
// // //                 salary_min: jobDetail.salary_min,
// // //                 salary_max: jobDetail.salary_max,
// // //                 salary_currency: jobDetail.salary_currency,
// // //                 posted_at: jobDetail.posted_at,
// // //                 application_deadline: jobDetail.application_deadline,
// // //                 visa_sponsorship: jobDetail.visa_sponsorship,
// // //                 required_skills: jobDetail.required_skills || [],
// // //                 urgent: jobDetail.urgent || false,
// // //                 details: jobDetail,
// // //               };
// // //             })
// // //             .filter((item) => item !== null)
// // //             .sort((a, b) => b.match - a.match);
// // //           setRecommendations(mappedRecommendations);
// // //         } else {
// // //           setRecommendations([]);
// // //         }

// // //         if (resumeResponse.data) {
// // //           const resumeData = Array.isArray(resumeResponse.data)
// // //             ? resumeResponse.data[0]
// // //             : resumeResponse.data;
// // //           if (resumeData) {
// // //             if (resumeData.skills && Array.isArray(resumeData.skills)) {
// // //               setTechnicalSkills(resumeData.skills);
// // //             }
// // //             if (
// // //               resumeData.languages &&
// // //               typeof resumeData.languages === "object" &&
// // //               !Array.isArray(resumeData.languages)
// // //             ) {
// // //               const formattedLangs = Object.entries(resumeData.languages).map(
// // //                 ([name, proficiency]) => ({
// // //                   name,
// // //                   proficiency,
// // //                 })
// // //               );
// // //               setLanguages(formattedLangs);
// // //             }
// // //           }
// // //         }

// // //         if (progressResponse.data) {
// // //           setProfileProgress(progressResponse.data);
// // //         }
// // //       } catch (error) {
// // //         console.error("Failed to fetch dashboard data:", error);
// // //       } finally {
// // //         setTimeout(() => setLoading(false), 1200);
// // //       }
// // //     };

// // //     fetchDashboardData();

// // //     // 4. Add a cleanup function to set the flag after the first run
// // //     return () => {
// // //       effectRan.current = true;
// // //     };
// // //   }, []); // 5. Use an empty dependency array for a true "run-once" effect

// // //   const handleViewDetails = (jobDetails) => {
// // //     setSelectedJobDetails(jobDetails);
// // //     setIsDetailsModalOpen(true);
// // //   };

// // //   const handleCloseDetailsModal = () => {
// // //     setIsDetailsModalOpen(false);
// // //     setSelectedJobDetails(null);
// // //   };

// // //   const handleQuickApply = async (jobId) => {
// // //     setApplyingJobId(jobId);
// // //     try {
// // //       const response = await apiClient.post("/applications/", {
// // //         job_posting: jobId,
// // //       });
// // //       const newApplication = response.data;
// // //       const mappedNewApplication = {
// // //         id: newApplication.id,
// // //         job_posting: newApplication.job_posting,
// // //         company:
// // //           newApplication.job_posting_details?.company_details?.company_name ||
// // //           "N/A",
// // //         position: newApplication.job_posting_details?.title || "N/A",
// // //         location: newApplication.job_posting_details?.location || "N/A",
// // //         status: mapApplicationStatus(newApplication.status),
// // //       };
// // //       setApplications((prev) => [mappedNewApplication, ...prev]);
// // //     } catch (error) {
// // //       console.error("Failed to quick apply:", error);
// // //     } finally {
// // //       setApplyingJobId(null);
// // //     }
// // //   };

// // //   const statsData = [
// // //     {
// // //       label: "Active Applications",
// // //       value: applications.length,
// // //       blobColor: theme.palette.warning.light,
// // //     },
// // //     {
// // //       label: "Job Matches",
// // //       value: recommendations.length,
// // //       blobColor: theme.palette.error.light,
// // //     },
// // //     {
// // //       label: "Job Notification",
// // //       value: 120,
// // //       blobColor: theme.palette.info.light,
// // //     },
// // //   ];

// // //   if (loading) {
// // //     return (
// // //       <Layout title="Talent Dashboard">
// // //         <Container maxWidth={false} sx={{ py: { xs: 2, md: 4 } }}>
// // //           <Stack spacing={{ xs: 3, md: 4 }}>
// // //             <WelcomeCardSkeleton />
// // //             <Grid container spacing={2.5}>
// // //               {[...Array(3)].map((_, index) => (
// // //                 <Grid item xs={12} sm={4} key={index}>
// // //                   <StatCardSkeleton />
// // //                 </Grid>
// // //               ))}
// // //             </Grid>
// // //             {/* Skeletons re-ordered to match new layout */}
// // //             <SectionSkeleton
// // //               titleWidth={250}
// // //               items={4}
// // //               CardSkeletonComponent={RecentApplicationSkeletonCard}
// // //             />
// // //             <SectionSkeleton
// // //               titleWidth={280}
// // //               items={4}
// // //               CardSkeletonComponent={JobRecommendationSkeletonCard}
// // //             />
// // //             <SkillsAndLanguagesSkeleton />
// // //           </Stack>
// // //         </Container>
// // //       </Layout>
// // //     );
// // //   }

// // //   return (
// // //     <Layout title="Talent Dashboard">
// // //       <Container
// // //         maxWidth={false}
// // //         sx={{ py: { xs: 2, md: 4 }, fontFamily: "'Poppins', sans-serif" }}
// // //       >
// // //         <Stack spacing={{ xs: 3, md: 4 }}>
// // //           <Card
// // //             elevation={0}
// // //             sx={{
// // //               p: { xs: 2, md: 3 },
// // //               borderRadius: "16px",
// // //               bgcolor: "mint.main",
// // //               boxShadow: "none",
// // //             }}
// // //           >
// // //             <Stack
// // //               direction={{ xs: "column", sm: "row" }}
// // //               spacing={2}
// // //               alignItems="center"
// // //             >
// // //               <Avatar
// // //                 src="/placeholder.svg?height=60&width=60"
// // //                 sx={{ width: 60, height: 60 }}
// // //               />
// // //               {profileProgress.progress_percentage === 100 ? (
// // //                 <>
// // //                   <Box
// // //                     flexGrow={1}
// // //                     sx={{
// // //                       width: "100%",
// // //                       textAlign: { xs: "center", sm: "left" },
// // //                     }}
// // //                   >
// // //                     <Typography
// // //                       variant="h5"
// // //                       sx={{ fontWeight: "bold", color: "text.primary" }}
// // //                     >
// // //                       Your Profile is Complete! What's Next ..?
// // //                     </Typography>
// // //                     <Typography
// // //                       sx={{
// // //                         color: "text.primary",
// // //                         fontSize: "1.2rem",
// // //                         mt: 0.5,
// // //                       }}
// // //                     >
// // //                       Take a mock interview to verify your skills and earn your
// // //                       official Skillspassport.
// // //                     </Typography>
// // //                   </Box>
// // //                   <Button
// // //                     variant="contained"
// // //                     color="primary"
// // //                     onClick={() => navigate("/gatep/talent/exam-intro")}
// // //                     sx={{
// // //                       borderRadius: "20px",
// // //                       textTransform: "none",
// // //                       fontWeight: 600,
// // //                       px: 3,
// // //                       py: 1,
// // //                       flexShrink: 0, // Prevents button from shrinking
// // //                     }}
// // //                   >
// // //                     Start Mock Interview
// // //                   </Button>
// // //                 </>
// // //               ) : (
// // //                 <>
// // //                   <Box
// // //                     flexGrow={1}
// // //                     sx={{
// // //                       width: "100%",
// // //                       textAlign: { xs: "center", sm: "left" },
// // //                     }}
// // //                   >
// // //                     <Typography
// // //                       variant="h5"
// // //                       sx={{ fontWeight: "bold", color: "text.primary" }}
// // //                     >
// // //                       Welcome Back!
// // //                     </Typography>
// // //                     <Typography
// // //                       sx={{ color: "text.primary", fontSize: "0.9rem" }}
// // //                     >
// // //                       {profileProgress.message}
// // //                     </Typography>
// // //                     <Stack
// // //                       direction="row"
// // //                       spacing={2}
// // //                       alignItems="center"
// // //                       sx={{ mt: 1 }}
// // //                     >
// // //                       <LinearProgress
// // //                         variant="determinate"
// // //                         value={profileProgress.progress_percentage || 0}
// // //                         sx={{
// // //                           flexGrow: 1,
// // //                           height: 8,
// // //                           borderRadius: "4px",
// // //                           bgcolor: alpha(theme.palette.primary.main, 0.2),
// // //                           "& .MuiLinearProgress-bar": {
// // //                             bgcolor: "primary.main",
// // //                           },
// // //                         }}
// // //                       />
// // //                       <Typography
// // //                         sx={{
// // //                           fontWeight: "bold",
// // //                           color: "primary.main",
// // //                           fontSize: "0.9rem",
// // //                         }}
// // //                       >
// // //                         {profileProgress.progress_percentage || 0}% Profile
// // //                         Completed
// // //                       </Typography>
// // //                     </Stack>
// // //                   </Box>
// // //                   <Button
// // //                     variant="contained"
// // //                     color="primary"
// // //                     onClick={() => navigate("/gatep/talent/profile")}
// // //                     sx={{
// // //                       borderRadius: "20px",
// // //                       textTransform: "none",
// // //                       fontWeight: 600,
// // //                       px: 3,
// // //                       py: 1,
// // //                     }}
// // //                   >
// // //                     Complete Profile
// // //                   </Button>
// // //                 </>
// // //               )}
// // //             </Stack>
// // //           </Card>

// // //           <Box
// // //             sx={{
// // //               display: "flex",
// // //               flexDirection: "row",
// // //               gap: { xs: 1.5, sm: 2, md: 3 }, // Responsive gap between cards
// // //             }}
// // //           >
// // //             {statsData.map((stat, index) => (
// // //               <StatCard key={index} {...stat} />
// // //             ))}
// // //           </Box>

// // //           {/* Section: Recent Applications (Horizontal Row) */}
// // //           <Card
// // //             elevation={0}
// // //             sx={{
// // //               p: { xs: 2, md: 3 },
// // //               borderRadius: "20px",
// // //               bgcolor: "mint.main",
// // //               boxShadow: (theme) =>
// // //                 `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// // //             }}
// // //           >
// // //             <Typography
// // //               variant="h5"
// // //               sx={{
// // //                 fontWeight: "bold",
// // //                 color: "text.primary",
// // //                 mb: 2,
// // //               }}
// // //             >
// // //               Recent Application
// // //             </Typography>
// // //             <Stack
// // //               direction="row"
// // //               spacing={2.5}
// // //               sx={{
// // //                 overflowX: "auto",
// // //                 pb: 1,
// // //                 "&::-webkit-scrollbar": {
// // //                   display: "none",
// // //                 },
// // //                 "-ms-overflow-style": "none",
// // //                 "scrollbar-width": "none",
// // //               }}
// // //             >
// // //               {applications.slice(0, 8).map((app) => (
// // //                 <Card
// // //                   key={app.id}
// // //                   elevation={0}
// // //                   sx={{
// // //                     p: 2,
// // //                     borderRadius: "20px",
// // //                     bgcolor: "background.paper",
// // //                     border: (theme) => `1px solid ${theme.palette.divider}`,
// // //                     position: "relative",
// // //                     overflow: "hidden",
// // //                     minWidth: { xs: 280, sm: 320 },
// // //                     flexShrink: 0,
// // //                   }}
// // //                 >
// // //                   <Box
// // //                     sx={{
// // //                       position: "absolute",
// // //                       width: 90,
// // //                       height: 90,
// // //                       borderRadius: "50%",
// // //                       bgcolor: alpha(theme.palette.warning.main, 0.1),
// // //                       top: -25,
// // //                       right: 25,
// // //                       zIndex: 0,
// // //                     }}
// // //                   />
// // //                   <Box
// // //                     sx={{
// // //                       position: "absolute",
// // //                       width: 70,
// // //                       height: 70,
// // //                       borderRadius: "50%",
// // //                       bgcolor: alpha(theme.palette.warning.main, 0.1),
// // //                       top: 15,
// // //                       right: -25,
// // //                       zIndex: 0,
// // //                     }}
// // //                   />
// // //                   <Stack
// // //                     spacing={2}
// // //                     justifyContent="space-between"
// // //                     sx={{ position: "relative", zIndex: 1 }}
// // //                   >
// // //                     <Stack direction="row" spacing={1.5} alignItems="center">
// // //                       <Avatar
// // //                         sx={{ bgcolor: "warning.light", width: 48, height: 48 }}
// // //                       >
// // //                         <WorkOutline sx={{ color: "primary.main" }} />
// // //                       </Avatar>
// // //                       <Box>
// // //                         <Typography
// // //                           sx={{
// // //                             fontWeight: "bold",
// // //                             fontSize: "18px",
// // //                             color: "text.primary",
// // //                             lineHeight: 1.2,
// // //                           }}
// // //                         >
// // //                           {app.position}
// // //                         </Typography>
// // //                         <Typography
// // //                           sx={{
// // //                             fontSize: "14px",
// // //                             color: "text.secondary",
// // //                             display: "flex",
// // //                             alignItems: "center",
// // //                             mt: 0.5,
// // //                           }}
// // //                         >
// // //                           <LocationOn sx={{ fontSize: "16px", mr: 0.5 }} />
// // //                           {app.company}
// // //                         </Typography>
// // //                       </Box>
// // //                     </Stack>
// // //                     <Box sx={{ alignSelf: "flex-end" }}>
// // //                       <Chip
// // //                         label={app.status}
// // //                         sx={{
// // //                           bgcolor:
// // //                             app.status === "Applied"
// // //                               ? "success.main"
// // //                               : "primary.main",
// // //                           color: "primary.contrastText",
// // //                           borderRadius: "16px",
// // //                           fontWeight: 500,
// // //                           fontSize: "13px",
// // //                           height: "32px",
// // //                           ".MuiChip-label": { px: 2 },
// // //                         }}
// // //                       />
// // //                     </Box>
// // //                   </Stack>
// // //                 </Card>
// // //               ))}
// // //             </Stack>
// // //             <Box sx={{ textAlign: "center", pt: 3 }}>
// // //               <Button
// // //                 endIcon={<ArrowForward />}
// // //                 color="primary"
// // //                 variant="contained"
// // //                 onClick={() => navigate("/gatep/talent/jobs")}
// // //                 sx={{
// // //                   borderRadius: "30px",
// // //                   textTransform: "none",
// // //                   fontWeight: "bold",
// // //                   fontSize: "14px",
// // //                   height: "40px",
// // //                   px: 4,
// // //                   width: "100%",
// // //                   maxWidth: "350px",
// // //                   mx: "auto",
// // //                 }}
// // //               >
// // //                 View All Recent Application
// // //               </Button>
// // //             </Box>
// // //           </Card>

// // //           {/* Section: AI Job Recommendations */}
// // //           <Card
// // //             elevation={0}
// // //             sx={{
// // //               p: { xs: 2, md: 3 },
// // //               borderRadius: "20px",
// // //               bgcolor: "mint.main",
// // //               boxShadow: (theme) =>
// // //                 `0px 4px 12px ${alpha(theme.palette.common.black, 0.05)}`,
// // //               display: "flex",
// // //               flexDirection: "column",
// // //               height: "100%",
// // //             }}
// // //           >
// // //             <Typography
// // //               variant="h5"
// // //               sx={{ fontWeight: "bold", color: "text.primary", mb: 3 }}
// // //             >
// // //               AI Job Recommendations
// // //             </Typography>
// // //             <Stack
// // //               direction="row"
// // //               spacing={2.5}
// // //               sx={{
// // //                 overflowX: "auto",
// // //                 pb: 2,
// // //                 "&::-webkit-scrollbar": {
// // //                   display: "none",
// // //                 },
// // //                 "-ms-overflow-style": "none",
// // //                 "scrollbar-width": "none",
// // //               }}
// // //             >
// // //               {recommendations.slice(0, 6).map((rec) => {
// // //                 const isApplying = applyingJobId === rec.id;
// // //                 const isAlreadyApplied = applications.some(
// // //                   (app) => String(app.job_posting) === String(rec.id)
// // //                 );
// // //                 const displaySkills = rec.required_skills.slice(0, 3);
// // //                 const remainingSkills =
// // //                   rec.required_skills.length - displaySkills.length;
// // //                 return (
// // //                   <Card
// // //                     key={rec.id}
// // //                     elevation={0}
// // //                     sx={{
// // //                       p: 2.5,
// // //                       borderRadius: "20px",
// // //                       border: (theme) => `1px solid ${theme.palette.divider}`,
// // //                       bgcolor: "background.paper",
// // //                       display: "flex",
// // //                       flexDirection: "column",
// // //                       gap: 1.5,
// // //                       width: { xs: 300, sm: 360 },
// // //                       flexShrink: 0,
// // //                     }}
// // //                   >
// // //                     <Stack
// // //                       direction="row"
// // //                       justifyContent="space-between"
// // //                       alignItems="flex-start"
// // //                     >
// // //                       <Stack direction="row" spacing={1.5} alignItems="center">
// // //                         <Avatar
// // //                           variant="circular"
// // //                           sx={{
// // //                             bgcolor: "warning.light",
// // //                             width: 48,
// // //                             height: 48,
// // //                           }}
// // //                         >
// // //                           <WorkOutline sx={{ color: "primary.main" }} />
// // //                         </Avatar>
// // //                         <Box sx={{ minHeight: "54px" }}>
// // //                           <Typography
// // //                             sx={{
// // //                               fontWeight: "bold",
// // //                               fontSize: "18px",
// // //                               color: "text.primary",
// // //                               overflow: "hidden",
// // //                               textOverflow: "ellipsis",
// // //                               display: "-webkit-box",
// // //                               WebkitLineClamp: "2",
// // //                               WebkitBoxOrient: "vertical",
// // //                             }}
// // //                           >
// // //                             {rec.position}
// // //                           </Typography>
// // //                           <Typography
// // //                             sx={{
// // //                               fontSize: "14px",
// // //                               color: "text.secondary",
// // //                             }}
// // //                           >
// // //                             {rec.company}
// // //                           </Typography>
// // //                         </Box>
// // //                       </Stack>
// // //                       <Stack alignItems="flex-end" spacing={1}>
// // //                         {rec.urgent && (
// // //                           <Chip
// // //                             label="Urgent Hiring"
// // //                             size="small"
// // //                             sx={{
// // //                               bgcolor: alpha(theme.palette.warning.main, 0.2),
// // //                               color: "warning.dark",
// // //                               fontWeight: 500,
// // //                               borderRadius: "16px",
// // //                               height: "auto",
// // //                               ".MuiChip-label": { py: "2px", px: "8px" },
// // //                             }}
// // //                           />
// // //                         )}
// // //                         <IconButton size="small">
// // //                           <BookmarkBorder />
// // //                         </IconButton>
// // //                       </Stack>
// // //                     </Stack>
// // //                     <Stack spacing={0.5}>
// // //                       <Stack direction="row" spacing={1}>
// // //                         <LocationOn
// // //                           sx={{
// // //                             fontSize: "16px",
// // //                             color: "text.secondary",
// // //                             mt: "2px",
// // //                           }}
// // //                         />
// // //                         <Typography
// // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // //                         >
// // //                           {rec.location}
// // //                         </Typography>
// // //                         {rec.visa_sponsorship && (
// // //                           <Chip
// // //                             label="Visa Sponsored"
// // //                             size="small"
// // //                             sx={{
// // //                               bgcolor: alpha(theme.palette.primary.main, 0.15),
// // //                               color: "primary.main",
// // //                               fontWeight: 500,
// // //                               borderRadius: "8px",
// // //                               height: "auto",
// // //                               ".MuiChip-label": { py: "1px" },
// // //                             }}
// // //                           />
// // //                         )}
// // //                       </Stack>
// // //                       <Stack direction="row" spacing={1}>
// // //                         <AttachMoney
// // //                           sx={{
// // //                             fontSize: "16px",
// // //                             color: "text.secondary",
// // //                             mt: "2px",
// // //                           }}
// // //                         />
// // //                         <Typography
// // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // //                         >{`$${(rec.salary_min / 1000).toFixed(0)}k-$${(
// // //                           rec.salary_max / 1000
// // //                         ).toFixed(0)}k`}</Typography>
// // //                         <WorkOutline
// // //                           sx={{
// // //                             fontSize: "16px",
// // //                             color: "text.secondary",
// // //                             mt: "2px",
// // //                             ml: 1,
// // //                           }}
// // //                         />
// // //                         <Typography
// // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // //                         >
// // //                           {rec.details.job_type_display}
// // //                         </Typography>
// // //                       </Stack>
// // //                       <Stack direction="row" spacing={1}>
// // //                         <AccessTime
// // //                           sx={{
// // //                             fontSize: "16px",
// // //                             color: "text.secondary",
// // //                             mt: "2px",
// // //                           }}
// // //                         />
// // //                         <Typography
// // //                           sx={{ fontSize: "14px", color: "text.secondary" }}
// // //                         >
// // //                           {new Date(
// // //                             rec.application_deadline || rec.posted_at
// // //                           ).toLocaleDateString()}
// // //                         </Typography>
// // //                       </Stack>
// // //                     </Stack>

// // //                     <Box>
// // //                       <Stack
// // //                         direction="row"
// // //                         justifyContent="space-between"
// // //                         alignItems="center"
// // //                       >
// // //                         <Typography
// // //                           sx={{
// // //                             fontSize: "14px",
// // //                             fontWeight: 600,
// // //                             color: "text.primary",
// // //                           }}
// // //                         >
// // //                           AI Match Score
// // //                         </Typography>
// // //                         <Typography
// // //                           sx={{
// // //                             fontSize: "14px",
// // //                             fontWeight: "bold",
// // //                             color: "success.main",
// // //                           }}
// // //                         >
// // //                           {rec.match}%
// // //                         </Typography>
// // //                       </Stack>
// // //                       <LinearProgress
// // //                         variant="determinate"
// // //                         value={rec.match}
// // //                         sx={{
// // //                           mt: 0.5,
// // //                           height: 6,
// // //                           borderRadius: 3,
// // //                           bgcolor: "divider",
// // //                           "& .MuiLinearProgress-bar": {
// // //                             bgcolor: "success.main",
// // //                           },
// // //                         }}
// // //                       />
// // //                     </Box>
// // //                     <Box sx={{ minHeight: "68px" }}>
// // //                       <Typography
// // //                         sx={{
// // //                           fontSize: "14px",
// // //                           color: "text.secondary",
// // //                           mb: 1,
// // //                         }}
// // //                       >
// // //                         Required Skills
// // //                       </Typography>
// // //                       <Stack
// // //                         direction="row"
// // //                         useFlexGap
// // //                         flexWrap="wrap"
// // //                         spacing={1}
// // //                       >
// // //                         {displaySkills.map((skill, index) => (
// // //                           <Chip
// // //                             key={`${skill}-${index}`}
// // //                             label={skill}
// // //                             variant="outlined"
// // //                             size="small"
// // //                           />
// // //                         ))}
// // //                         {remainingSkills > 0 && (
// // //                           <Chip
// // //                             label={`+${remainingSkills}`}
// // //                             size="small"
// // //                             sx={{
// // //                               bgcolor: "primary.light",
// // //                               color: "primary.main",
// // //                               borderRadius: "50%",
// // //                               fontWeight: "bold",
// // //                             }}
// // //                           />
// // //                         )}
// // //                       </Stack>
// // //                     </Box>
// // //                     <Stack
// // //                       direction="row"
// // //                       spacing={1.5}
// // //                       sx={{ mt: "auto", pt: 2 }}
// // //                     >
// // //                       <Button
// // //                         fullWidth
// // //                         variant="outlined"
// // //                         color="primary"
// // //                         onClick={() => handleViewDetails(rec.details)}
// // //                         sx={{
// // //                           borderRadius: "30px",
// // //                           textTransform: "none",
// // //                           fontWeight: 600,
// // //                         }}
// // //                       >
// // //                         View Details
// // //                       </Button>
// // //                       <Button
// // //                         fullWidth
// // //                         variant="contained"
// // //                         color="primary"
// // //                         onClick={() => handleQuickApply(rec.id)}
// // //                         disabled={isApplying || isAlreadyApplied}
// // //                         sx={{
// // //                           borderRadius: "30px",
// // //                           boxShadow: "none",
// // //                           textTransform: "none",
// // //                           fontWeight: 600,
// // //                         }}
// // //                       >
// // //                         {isApplying ? (
// // //                           <CircularProgress size={24} color="inherit" />
// // //                         ) : isAlreadyApplied ? (
// // //                           "Applied"
// // //                         ) : (
// // //                           "Quick Apply"
// // //                         )}
// // //                       </Button>
// // //                     </Stack>
// // //                   </Card>
// // //                 );
// // //               })}
// // //             </Stack>
// // //             <Box sx={{ textAlign: "center", pt: 3, mt: "auto" }}>
// // //               <Button
// // //                 endIcon={<ArrowForward />}
// // //                 color="primary"
// // //                 variant="contained"
// // //                 onClick={() => navigate("/gatep/talent/jobs")}
// // //                 sx={{
// // //                   borderRadius: "30px",
// // //                   textTransform: "none",
// // //                   fontWeight: "bold",
// // //                   fontSize: "14px",
// // //                   height: "40px",
// // //                   px: 4,
// // //                   width: "100%",
// // //                   maxWidth: "350px",
// // //                   mx: "auto",
// // //                 }}
// // //               >
// // //                 View All AI JOB Recomendation
// // //               </Button>
// // //             </Box>
// // //           </Card>
// // //         </Stack>
// // //         <JobDetailsModal
// // //           open={isDetailsModalOpen}
// // //           onClose={handleCloseDetailsModal}
// // //           job={selectedJobDetails}
// // //         />
// // //       </Container>
// // //     </Layout>
// // //   );
// // // };

// // // export default TalentDashboard;

// // "use client";

// // import { useState, useEffect, useRef } from "react"; // 1. Import useRef
// // import {
// //   Grid,
// //   Card,
// //   Typography,
// //   Button,
// //   Box,
// //   Chip,
// //   LinearProgress,
// //   List,
// //   ListItem,
// //   ListItemText,
// //   ListItemIcon,
// //   Avatar,
// //   Stack,
// //   Skeleton,
// //   alpha,
// //   Container,
// //   CardContent,
// //   CircularProgress,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   IconButton,
// //   darken,
// // } from "@mui/material";
// // import {
// //   TrendingUp,
// //   LocationOn,
// //   ArrowForward,
// //   CheckCircle,
// //   Close as CloseIcon,
// //   AttachMoney,
// //   Event,
// //   Beenhere,
// //   WorkOutline,
// //   BookmarkBorder,
// //   AccessTime,
// // } from "@mui/icons-material";
// // import Layout from "../components/common/Layout";
// // import { useNavigate } from "react-router-dom";
// // import { useTheme } from "@mui/material/styles";
// // import apiClient from "../context/apiClient";

// // const JobDetailsModal = ({ open, onClose, job }) => {
// //   const theme = useTheme();
// //   if (!job) return null;
// //   return (
// //     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
// //       <DialogTitle sx={{ m: 0, p: 2, pr: 8, bgcolor: "#F1FFFA" }}>
// //         <Stack direction="row" spacing={2} alignItems="center">
// //           <Avatar
// //             src={job.company_details?.logo}
// //             variant="rounded"
// //             sx={{ width: 56, height: 56 }}
// //           />
// //           <Box>
// //             <Typography variant="h5" component="div" fontWeight={700}>
// //               {job.title}
// //             </Typography>
// //             <Typography variant="body1" color="text.secondary">
// //               {job.company_details?.company_name}
// //             </Typography>
// //           </Box>
// //         </Stack>
// //         <IconButton
// //           aria-label="close"
// //           onClick={onClose}
// //           sx={{
// //             position: "absolute",
// //             right: 8,
// //             top: 8,
// //             color: "text.secondary",
// //           }}
// //         >
// //           <CloseIcon />
// //         </IconButton>
// //       </DialogTitle>
// //       <DialogContent dividers sx={{ bgcolor: "#F1FFFA" }}>
// //         <Stack
// //           direction="row"
// //           spacing={1}
// //           useFlexGap
// //           flexWrap="wrap"
// //           sx={{ mb: 3 }}
// //         >
// //           <Chip icon={<LocationOn />} label={job.location} variant="outlined" />
// //           <Chip
// //             icon={<WorkOutline />}
// //             label={job.job_type_display}
// //             variant="outlined"
// //           />
// //           <Chip
// //             icon={<TrendingUp />}
// //             label={job.experience_level_display}
// //             variant="outlined"
// //           />
// //           {job.remote_work && (
// //             <Chip label="Remote Available" color="success" variant="outlined" />
// //           )}
// //           {job.visa_sponsorship && (
// //             <Chip
// //               label="Visa Sponsorship"
// //               sx={{
// //                 backgroundColor: "primary.main",
// //                 color: "primary.contrastText",
// //                 fontWeight: 500,
// //               }}
// //             />
// //           )}
// //         </Stack>
// //         {job.salary_min && job.salary_max && (
// //           <Box
// //             display="flex"
// //             alignItems="center"
// //             mb={3}
// //             p={2}
// //             bgcolor={alpha(theme.palette.success.main, 0.1)}
// //             borderRadius={2}
// //           >
// //             <AttachMoney sx={{ mr: 1, color: "success.main" }} />
// //             <Typography
// //               variant="h6"
// //               component="p"
// //               fontWeight={600}
// //               color="success.dark"
// //             >
// //               {`${new Intl.NumberFormat("en-US", {
// //                 style: "currency",
// //                 currency: job.salary_currency || "USD",
// //               }).format(job.salary_min)} - ${new Intl.NumberFormat("en-US", {
// //                 style: "currency",
// //                 currency: job.salary_currency || "USD",
// //               }).format(job.salary_max)}`}
// //             </Typography>
// //           </Box>
// //         )}
// //         <Typography variant="h6" gutterBottom fontWeight={700}>
// //           Job Description
// //         </Typography>
// //         <Typography
// //           variant="body2"
// //           sx={{
// //             whiteSpace: "pre-wrap",
// //             mb: 3,
// //             color: "text.secondary",
// //             lineHeight: 1.7,
// //           }}
// //         >
// //           {job.description}
// //         </Typography>
// //         <Typography variant="h6" gutterBottom fontWeight={700}>
// //           Responsibilities
// //         </Typography>
// //         <Typography
// //           variant="body2"
// //           sx={{
// //             whiteSpace: "pre-wrap",
// //             mb: 3,
// //             color: "text.secondary",
// //             lineHeight: 1.7,
// //           }}
// //         >
// //           {job.responsibilities}
// //         </Typography>
// //         <Typography variant="h6" gutterBottom fontWeight={700}>
// //           Requirements
// //         </Typography>
// //         <List dense sx={{ mb: 2 }}>
// //           {job.requirements?.map((req, i) => (
// //             <ListItem key={i} disableGutters>
// //               <ListItemIcon sx={{ minWidth: 32 }}>
// //                 <CheckCircle color="primary" fontSize="small" />
// //               </ListItemIcon>
// //               <ListItemText primary={req} />
// //             </ListItem>
// //           ))}
// //         </List>
// //         <Typography variant="h6" gutterBottom fontWeight={700}>
// //           Required Skills
// //         </Typography>
// //         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
// //           {job.required_skills?.map((skill, i) => (
// //             <Chip key={i} label={skill} variant="outlined" />
// //           ))}
// //         </Box>
// //         {job.benefits?.length > 0 && (
// //           <>
// //             <Typography variant="h6" gutterBottom fontWeight={700}>
// //               Benefits
// //             </Typography>
// //             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
// //               {job.benefits.map((benefit, i) => (
// //                 <Chip
// //                   key={i}
// //                   icon={<Beenhere />}
// //                   label={benefit}
// //                   variant="outlined"
// //                   color="success"
// //                 />
// //               ))}
// //             </Box>
// //           </>
// //         )}
// //         {job.application_deadline && (
// //           <Box
// //             display="flex"
// //             alignItems="center"
// //             mt={2}
// //             p={1.5}
// //             bgcolor={alpha(theme.palette.warning.main, 0.1)}
// //             borderRadius={2}
// //           >
// //             <Event sx={{ mr: 1, color: "warning.main" }} />
// //             <Typography
// //               variant="body2"
// //               component="p"
// //               fontWeight={600}
// //               color="warning.dark"
// //             >
// //               Application Deadline:{" "}
// //               {new Date(job.application_deadline).toLocaleDateString()}
// //             </Typography>
// //           </Box>
// //         )}
// //       </DialogContent>
// //       <DialogActions sx={{ p: { xs: 2, sm: 3 }, bgcolor: "#F1FFFA" }}>
// //         <Button onClick={onClose} color="inherit">
// //           Close
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // const WelcomeCardSkeleton = () => (
// //   <Card
// //     elevation={0}
// //     sx={{
// //       p: { xs: 2, md: 3 },
// //       borderRadius: "16px",
// //       bgcolor: "mint.main",
// //       boxShadow: "none",
// //     }}
// //   >
// //     <Stack
// //       direction={{ xs: "column", sm: "row" }}
// //       spacing={2}
// //       alignItems="center"
// //     >
// //       <Skeleton variant="circular" width={60} height={60} />
// //       <Box flexGrow={1} sx={{ width: "100%" }}>
// //         <Skeleton variant="text" width="40%" height={32} />
// //         <Skeleton variant="text" width="60%" height={24} />
// //         <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 1 }}>
// //           <Skeleton
// //             variant="rectangular"
// //             height={8}
// //             sx={{ flexGrow: 1, borderRadius: "4px" }}
// //           />
// //           <Skeleton variant="text" width="25%" height={24} />
// //         </Stack>
// //       </Box>
// //       <Skeleton
// //         variant="rectangular"
// //         height={44}
// //         width={180}
// //         sx={{ borderRadius: "20px" }}
// //       />
// //     </Stack>
// //   </Card>
// // );

// // const StatCardSkeleton = () => (
// //   <Skeleton
// //     variant="rectangular"
// //     height={{ xs: 100, sm: 120 }}
// //     sx={{ borderRadius: "14px", flex: 1, minWidth: 0 }}
// //   />
// // );

// // const SectionSkeleton = ({
// //   titleWidth = 200,
// //   items = 3,
// //   CardSkeletonComponent,
// // }) => (
// //   <Card
// //     elevation={0}
// //     sx={{
// //       p: { xs: 2, md: 4 },
// //       borderRadius: "20px",
// //       bgcolor: "mint.main",
// //       height: "100%",
// //     }}
// //   >
// //     <Skeleton variant="text" width={titleWidth} height={40} sx={{ mb: 3 }} />
// //     <Grid container spacing={2.5}>
// //       {[...Array(items)].map((_, index) =>
// //         CardSkeletonComponent ? <CardSkeletonComponent key={index} /> : null
// //       )}
// //     </Grid>
// //     <Box sx={{ textAlign: "center", pt: 3 }}>
// //       <Skeleton
// //         variant="rectangular"
// //         width={250}
// //         height={40}
// //         sx={{ borderRadius: "30px", mx: "auto" }}
// //       />
// //     </Box>
// //   </Card>
// // );

// // const RecentApplicationSkeletonCard = () => (
// //   <Grid item xs={12}>
// //     <Card
// //       elevation={0}
// //       sx={{
// //         p: 2,
// //         borderRadius: "20px",
// //         bgcolor: "#F1FFFA",
// //         border: (theme) => `1px solid ${theme.palette.divider}`,
// //       }}
// //     >
// //       <Stack spacing={2} justifyContent="space-between" height="100%">
// //         <Stack direction="row" spacing={1.5} alignItems="center">
// //           <Skeleton variant="circular" width={48} height={48} />
// //           <Box>
// //             <Skeleton variant="text" width={120} height={28} />
// //             <Skeleton variant="text" width={100} height={20} />
// //           </Box>
// //         </Stack>
// //         <Skeleton
// //           variant="rectangular"
// //           width={100}
// //           height={32}
// //           sx={{ borderRadius: "16px", alignSelf: "flex-end" }}
// //         />
// //       </Stack>
// //     </Card>
// //   </Grid>
// // );

// // const JobRecommendationSkeletonCard = () => (
// //   <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
// //     <Card
// //       elevation={0}
// //       sx={{
// //         p: 3,
// //         borderRadius: "20px",
// //         border: (theme) => `1px solid ${theme.palette.divider}`,
// //         bgcolor: "background.paper",
// //         height: "100%",
// //         width: "100%",
// //         display: "flex",
// //         flexDirection: "column",
// //         gap: 1.5,
// //       }}
// //     >
// //       <Stack
// //         direction="row"
// //         justifyContent="space-between"
// //         alignItems="flex-start"
// //       >
// //         <Box>
// //           <Skeleton variant="text" width={150} height={28} />
// //           <Skeleton variant="text" width={100} height={20} />
// //         </Box>
// //         <Skeleton variant="circular" width={24} height={24} />
// //       </Stack>
// //       <Stack spacing={0.5}>
// //         <Skeleton variant="text" width="50%" />
// //         <Skeleton variant="text" width="70%" />
// //         <Skeleton variant="text" width="40%" />
// //       </Stack>
// //       <Box>
// //         <Stack
// //           direction="row"
// //           justifyContent="space-between"
// //           alignItems="center"
// //         >
// //           <Skeleton variant="text" width="30%" />
// //           <Skeleton variant="text" width="20%" />
// //         </Stack>
// //         <Skeleton
// //           variant="rectangular"
// //           height={6}
// //           sx={{ mt: 1, borderRadius: 3 }}
// //         />
// //       </Box>
// //       <Box>
// //         <Skeleton variant="text" width="40%" sx={{ mb: 1 }} />
// //         <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1}>
// //           <Skeleton
// //             variant="rectangular"
// //             width={80}
// //             height={24}
// //             sx={{ borderRadius: "16px" }}
// //           />
// //           <Skeleton
// //             variant="rectangular"
// //             width={90}
// //             height={24}
// //             sx={{ borderRadius: "16px" }}
// //           />
// //         </Stack>
// //       </Box>
// //       <Stack direction="row" spacing={1.5} sx={{ mt: "auto", pt: 2 }}>
// //         <Skeleton
// //           variant="rectangular"
// //           width="100%"
// //           height={40}
// //           sx={{ borderRadius: "30px" }}
// //         />
// //         <Skeleton
// //           variant="rectangular"
// //           width="100%"
// //           height={40}
// //           sx={{ borderRadius: "30px" }}
// //         />
// //       </Stack>
// //     </Card>
// //   </Grid>
// // );

// // const SkillsAndLanguagesSkeleton = () => (
// //   <Grid container spacing={3}>
// //     <Grid item xs={12} md={8}>
// //       <Card
// //         elevation={0}
// //         sx={{
// //           p: 3,
// //           borderRadius: "12px",
// //           bgcolor: "mint.main",
// //           boxShadow: (theme) =>
// //             `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// //           height: "100%",
// //         }}
// //       >
// //         <Skeleton variant="text" width="40%" height={32} />
// //         <Skeleton
// //           variant="text"
// //           width="30%"
// //           height={24}
// //           sx={{ mt: 1, mb: 2 }}
// //         />
// //         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 3 }}>
// //           {[...Array(8)].map((_, i) => (
// //             <Skeleton
// //               key={i}
// //               variant="rectangular"
// //               width={100}
// //               height={36}
// //               sx={{ borderRadius: "20px" }}
// //             />
// //           ))}
// //         </Box>
// //       </Card>
// //     </Grid>
// //     <Grid item xs={12} md={4}>
// //       <Card
// //         elevation={0}
// //         sx={{
// //           p: 3,
// //           borderRadius: "12px",
// //           bgcolor: "mint.main",
// //           boxShadow: (theme) =>
// //             `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// //           height: "100%",
// //         }}
// //       >
// //         <Skeleton variant="text" width="50%" height={32} sx={{ mb: 3 }} />
// //         <Grid container spacing={1.5} sx={{ mb: 3 }}>
// //           {[...Array(6)].map((_, i) => (
// //             <Grid item xs={6} key={i}>
// //               <Skeleton
// //                 variant="rectangular"
// //                 width="100%"
// //                 height={36}
// //                 sx={{ borderRadius: "20px" }}
// //               />
// //             </Grid>
// //           ))}
// //         </Grid>
// //       </Card>
// //     </Grid>
// //   </Grid>
// // );

// // const mapApplicationStatus = (apiStatus) => {
// //   switch (apiStatus) {
// //     case "SCHEDULED":
// //       return "Interview Scheduled";
// //     case "UNDER_REVIEW":
// //     case "REVIEW":
// //       return "Under Review";
// //     case "APPLIED":
// //       return "Applied";
// //     case "SHORTLISTED":
// //       return "Shortlisted";
// //     default:
// //       return apiStatus;
// //   }
// // };
// // const StatCard = ({ value, label, blobColor }) => {
// //   const theme = useTheme();
// //   // Use the provided blobColor or default to the theme's accent color
// //   const primaryBlobColor = blobColor || theme.palette.accent.main;
// //   // Create a slightly darker version for the background blob
// //   const darkerBlobColor = darken(primaryBlobColor, 0.1);

// //   return (
// //     <Card
// //       elevation={0}
// //       sx={{
// //         backgroundColor: theme.palette.primary.main,
// //         borderRadius: "20px",
// //         boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
// //         p: { xs: 1.5, sm: 2.5 },
// //         position: "relative",
// //         overflow: "hidden",
// //         color: theme.palette.primary.contrastText,
// //         display: "flex",
// //         flexDirection: "column",
// //         justifyContent: "center",
// //         flex: 1, // Essential for responsive row
// //         minWidth: 0, // Essential for responsive row
// //         height: { xs: 100, sm: 120 },
// //       }}
// //     >
// //       <Box
// //         sx={{
// //           position: "absolute",
// //           top: 0,
// //           right: 0,
// //           bottom: 0,
// //           width: "60%",
// //           zIndex: 0, // SVG is in the back
// //         }}
// //       >
// //         <svg
// //           width="100%"
// //           height="100%"
// //           viewBox="0 0 80 120"
// //           preserveAspectRatio="none"
// //           style={{
// //             filter: `drop-shadow(-4px 4px 8px ${alpha(
// //               theme.palette.common.black,
// //               0.2
// //             )})`,
// //           }}
// //         >
// //           <path
// //             d="M 40,0 C 80,30 0,90 20,120 L 80,120 L 80,0 Z"
// //             fill={darkerBlobColor}
// //           />
// //           <path
// //             d="M 50,0 C 90,30 10,90 30,120 L 80,120 L 80,0 Z"
// //             fill={primaryBlobColor}
// //           />
// //         </svg>
// //       </Box>
// //       <Stack sx={{ position: "relative", zIndex: 1 }}>
// //         <Typography
// //           sx={{
// //             textTransform: "uppercase",
// //             fontSize: { xs: "11px", sm: "13px" },
// //             fontWeight: 500,
// //             color: alpha(theme.palette.primary.contrastText, 0.7),
// //             mb: 0.5,
// //           }}
// //         >
// //           {label}
// //         </Typography>
// //         <Typography
// //           sx={{
// //             fontSize: { xs: "28px", sm: "34px" },
// //             fontWeight: 700,
// //             color: "primary.contrastText",
// //             lineHeight: 1.1,
// //           }}
// //         >
// //           {value}
// //         </Typography>
// //       </Stack>
// //     </Card>
// //   );
// // };

// // const TalentDashboard = () => {
// //   const navigate = useNavigate();
// //   const theme = useTheme();
// //   const [applications, setApplications] = useState([]);
// //   const [recommendations, setRecommendations] = useState([]);
// //   const [technicalSkills, setTechnicalSkills] = useState([]);
// //   const [languages, setLanguages] = useState([]);
// //   // --- STATE CHANGE: Separated loading states ---
// //   const [mainDataLoading, setMainDataLoading] = useState(true);
// //   const [profileProgressLoading, setProfileProgressLoading] = useState(true);
// //   const [applyingJobId, setApplyingJobId] = useState(null);
// //   const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
// //   const [selectedJobDetails, setSelectedJobDetails] = useState(null);
// //   const [profileProgress, setProfileProgress] = useState({
// //     progress_percentage: 0,
// //     message: "Loading your profile progress...",
// //   });

// //   const effectRan = useRef(false);

// //   // --- LOGIC CHANGE: Split useEffect into two independent fetching functions ---
// //   useEffect(() => {
// //     if (effectRan.current === true) {
// //       return;
// //     }

// //     const token = localStorage.getItem("access_token");
// //     if (!token) {
// //       setMainDataLoading(false);
// //       setProfileProgressLoading(false);
// //       navigate("/gatep/login");
// //       return;
// //     }

// //     const fetchMainData = async () => {
// //       setMainDataLoading(true);
// //       try {
// //         const [applicationsResponse, aiScoresResponse, resumeResponse] =
// //           await Promise.all([
// //             apiClient.get("/applications/"),
// //             apiClient.get("/job-postings/ai-score/"),
// //             apiClient.get("/resume-builder/"),
// //           ]);

// //         if (
// //           applicationsResponse.data &&
// //           Array.isArray(applicationsResponse.data)
// //         ) {
// //           const mappedApplications = applicationsResponse.data.map((app) => ({
// //             id: app.id,
// //             job_posting: app.job_posting,
// //             company:
// //               app.job_posting_details?.company_details?.company_name || "N/A",
// //             position: app.job_posting_details?.title || "N/A",
// //             location: app.job_posting_details?.location || "N/A",
// //             status: mapApplicationStatus(app.status),
// //           }));
// //           setApplications(mappedApplications);
// //         }

// //         const aiScoresData = aiScoresResponse.data;
// //         if (
// //           aiScoresData &&
// //           Array.isArray(aiScoresData) &&
// //           aiScoresData.length > 0
// //         ) {
// //           const recommendationDetailPromises = aiScoresData.map((scoreItem) =>
// //             apiClient.get(`/job-postings/${scoreItem.id}/`)
// //           );
// //           const recommendationDetailResponses = await Promise.all(
// //             recommendationDetailPromises
// //           );
// //           const jobDetailsList = recommendationDetailResponses.map(
// //             (res) => res.data
// //           );
// //           const mappedRecommendations = aiScoresData
// //             .map((scoreItem) => {
// //               const jobDetail = jobDetailsList.find(
// //                 (detail) => detail.id === scoreItem.id
// //               );
// //               if (!jobDetail) return null;
// //               return {
// //                 id: jobDetail.id,
// //                 company: jobDetail.company_details?.company_name || "N/A",
// //                 position: jobDetail.title || "N/A",
// //                 match: scoreItem.matching_percentage || 0,
// //                 location: jobDetail.location || "N/A",
// //                 salary_min: jobDetail.salary_min,
// //                 salary_max: jobDetail.salary_max,
// //                 salary_currency: jobDetail.salary_currency,
// //                 posted_at: jobDetail.posted_at,
// //                 application_deadline: jobDetail.application_deadline,
// //                 visa_sponsorship: jobDetail.visa_sponsorship,
// //                 required_skills: jobDetail.required_skills || [],
// //                 urgent: jobDetail.urgent || false,
// //                 details: jobDetail,
// //               };
// //             })
// //             .filter((item) => item !== null)
// //             .sort((a, b) => b.match - a.match);
// //           setRecommendations(mappedRecommendations);
// //         } else {
// //           setRecommendations([]);
// //         }

// //         if (resumeResponse.data) {
// //           const resumeData = Array.isArray(resumeResponse.data)
// //             ? resumeResponse.data[0]
// //             : resumeResponse.data;
// //           if (resumeData) {
// //             if (resumeData.skills && Array.isArray(resumeData.skills)) {
// //               setTechnicalSkills(resumeData.skills);
// //             }
// //             if (
// //               resumeData.languages &&
// //               typeof resumeData.languages === "object" &&
// //               !Array.isArray(resumeData.languages)
// //             ) {
// //               const formattedLangs = Object.entries(resumeData.languages).map(
// //                 ([name, proficiency]) => ({
// //                   name,
// //                   proficiency,
// //                 })
// //               );
// //               setLanguages(formattedLangs);
// //             }
// //           }
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch main dashboard data:", error);
// //       } finally {
// //         setTimeout(() => setMainDataLoading(false), 1200);
// //       }
// //     };

// //     const fetchProfileProgress = async () => {
// //       setProfileProgressLoading(true);
// //       try {
// //         const progressResponse = await apiClient.get("/resume-progress/");
// //         if (progressResponse.data) {
// //           setProfileProgress(progressResponse.data);
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch profile progress data:", error);
// //       } finally {
// //         setProfileProgressLoading(false);
// //       }
// //     };

// //     fetchMainData();
// //     fetchProfileProgress();

// //     return () => {
// //       effectRan.current = true;
// //     };
// //   }, []);

// //   const handleViewDetails = (jobDetails) => {
// //     setSelectedJobDetails(jobDetails);
// //     setIsDetailsModalOpen(true);
// //   };

// //   const handleCloseDetailsModal = () => {
// //     setIsDetailsModalOpen(false);
// //     setSelectedJobDetails(null);
// //   };

// //   const handleQuickApply = async (jobId) => {
// //     setApplyingJobId(jobId);
// //     try {
// //       const response = await apiClient.post("/applications/", {
// //         job_posting: jobId,
// //       });
// //       const newApplication = response.data;
// //       const mappedNewApplication = {
// //         id: newApplication.id,
// //         job_posting: newApplication.job_posting,
// //         company:
// //           newApplication.job_posting_details?.company_details?.company_name ||
// //           "N/A",
// //         position: newApplication.job_posting_details?.title || "N/A",
// //         location: newApplication.job_posting_details?.location || "N/A",
// //         status: mapApplicationStatus(newApplication.status),
// //       };
// //       setApplications((prev) => [mappedNewApplication, ...prev]);
// //     } catch (error) {
// //       console.error("Failed to quick apply:", error);
// //     } finally {
// //       setApplyingJobId(null);
// //     }
// //   };

// //   const statsData = [
// //     {
// //       label: "Active Applications",
// //       value: applications.length,
// //       blobColor: theme.palette.warning.light,
// //     },
// //     {
// //       label: "Job Matches",
// //       value: recommendations.length,
// //       blobColor: theme.palette.error.light,
// //     },
// //     {
// //       label: "Job Notification",
// //       value: 120,
// //       blobColor: theme.palette.info.light,
// //     },
// //   ];

// //   // --- RENDER CHANGE: Removed single loading block, added per-section conditional rendering ---
// //   return (
// //     <Layout title="Talent Dashboard">
// //       <Container
// //         maxWidth={false}
// //         sx={{ py: { xs: 2, md: 4 }, fontFamily: "'Poppins', sans-serif" }}
// //       >
// //         <Stack spacing={{ xs: 3, md: 4 }}>
// //           {/* Welcome Card: Uses its own loading state */}
// //           {profileProgressLoading ? (
// //             <WelcomeCardSkeleton />
// //           ) : (
// //             <Card
// //               elevation={0}
// //               sx={{
// //                 p: { xs: 2, md: 3 },
// //                 borderRadius: "16px",
// //                 bgcolor: "mint.main",
// //                 boxShadow: "none",
// //               }}
// //             >
// //               <Stack
// //                 direction={{ xs: "column", sm: "row" }}
// //                 spacing={2}
// //                 alignItems="center"
// //               >
// //                 <Avatar
// //                   src="/placeholder.svg?height=60&width=60"
// //                   sx={{ width: 60, height: 60 }}
// //                 />
// //                 {profileProgress.progress_percentage === 100 ? (
// //                   <>
// //                     <Box
// //                       flexGrow={1}
// //                       sx={{
// //                         width: "100%",
// //                         textAlign: { xs: "center", sm: "left" },
// //                       }}
// //                     >
// //                       <Typography
// //                         variant="h5"
// //                         sx={{ fontWeight: "bold", color: "text.primary" }}
// //                       >
// //                         Your Profile is Complete! What's Next ..?
// //                       </Typography>
// //                       <Typography
// //                         sx={{
// //                           color: "text.primary",
// //                           fontSize: "1.2rem",
// //                           mt: 0.5,
// //                         }}
// //                       >
// //                         Take a mock interview to verify your skills and earn
// //                         your official Skillspassport.
// //                       </Typography>
// //                     </Box>
// //                     <Button
// //                       variant="contained"
// //                       color="primary"
// //                       onClick={() => navigate("/gatep/talent/exam-intro")}
// //                       sx={{
// //                         borderRadius: "20px",
// //                         textTransform: "none",
// //                         fontWeight: 600,
// //                         px: 3,
// //                         py: 1,
// //                         flexShrink: 0, // Prevents button from shrinking
// //                       }}
// //                     >
// //                       Start Mock Interview
// //                     </Button>
// //                   </>
// //                 ) : (
// //                   <>
// //                     <Box
// //                       flexGrow={1}
// //                       sx={{
// //                         width: "100%",
// //                         textAlign: { xs: "center", sm: "left" },
// //                       }}
// //                     >
// //                       <Typography
// //                         variant="h5"
// //                         sx={{ fontWeight: "bold", color: "text.primary" }}
// //                       >
// //                         Welcome Back!
// //                       </Typography>
// //                       <Typography
// //                         sx={{ color: "text.primary", fontSize: "0.9rem" }}
// //                       >
// //                         {profileProgress.message}
// //                       </Typography>
// //                       <Stack
// //                         direction="row"
// //                         spacing={2}
// //                         alignItems="center"
// //                         sx={{ mt: 1 }}
// //                       >
// //                         <LinearProgress
// //                           variant="determinate"
// //                           value={profileProgress.progress_percentage || 0}
// //                           sx={{
// //                             flexGrow: 1,
// //                             height: 8,
// //                             borderRadius: "4px",
// //                             bgcolor: alpha(theme.palette.primary.main, 0.2),
// //                             "& .MuiLinearProgress-bar": {
// //                               bgcolor: "primary.main",
// //                             },
// //                           }}
// //                         />
// //                         <Typography
// //                           sx={{
// //                             fontWeight: "bold",
// //                             color: "primary.main",
// //                             fontSize: "0.9rem",
// //                           }}
// //                         >
// //                           {profileProgress.progress_percentage || 0}% Profile
// //                           Completed
// //                         </Typography>
// //                       </Stack>
// //                     </Box>
// //                     <Button
// //                       variant="contained"
// //                       color="primary"
// //                       onClick={() => navigate("/gatep/talent/profile")}
// //                       sx={{
// //                         borderRadius: "20px",
// //                         textTransform: "none",
// //                         fontWeight: 600,
// //                         px: 3,
// //                         py: 1,
// //                       }}
// //                     >
// //                       Complete Profile
// //                     </Button>
// //                   </>
// //                 )}
// //               </Stack>
// //             </Card>
// //           )}

// //           {/* Stats Cards: Uses the main data loading state */}
// //           {mainDataLoading ? (
// //             <Grid container spacing={2.5}>
// //               {[...Array(3)].map((_, index) => (
// //                 <Grid item xs={12} sm={4} key={index}>
// //                   <StatCardSkeleton />
// //                 </Grid>
// //               ))}
// //             </Grid>
// //           ) : (
// //             <Box
// //               sx={{
// //                 display: "flex",
// //                 flexDirection: "row",
// //                 gap: { xs: 1.5, sm: 2, md: 3 },
// //               }}
// //             >
// //               {statsData.map((stat, index) => (
// //                 <StatCard key={index} {...stat} />
// //               ))}
// //             </Box>
// //           )}

// //           {/* Recent Applications: Uses the main data loading state */}
// //           {mainDataLoading ? (
// //             <SectionSkeleton
// //               titleWidth={250}
// //               items={4}
// //               CardSkeletonComponent={RecentApplicationSkeletonCard}
// //             />
// //           ) : (
// //             <Card
// //               elevation={0}
// //               sx={{
// //                 p: { xs: 2, md: 3 },
// //                 borderRadius: "20px",
// //                 bgcolor: "mint.main",
// //                 boxShadow: (theme) =>
// //                   `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
// //               }}
// //             >
// //               <Typography
// //                 variant="h5"
// //                 sx={{
// //                   fontWeight: "bold",
// //                   color: "text.primary",
// //                   mb: 2,
// //                 }}
// //               >
// //                 Recent Application
// //               </Typography>
// //               <Stack
// //                 direction="row"
// //                 spacing={2.5}
// //                 sx={{
// //                   overflowX: "auto",
// //                   pb: 1,
// //                   "&::-webkit-scrollbar": {
// //                     display: "none",
// //                   },
// //                   "-ms-overflow-style": "none",
// //                   "scrollbar-width": "none",
// //                 }}
// //               >
// //                 {applications.slice(0, 8).map((app) => (
// //                   <Card
// //                     key={app.id}
// //                     elevation={0}
// //                     sx={{
// //                       p: 2,
// //                       borderRadius: "20px",
// //                       bgcolor: "background.paper",
// //                       border: (theme) => `1px solid ${theme.palette.divider}`,
// //                       position: "relative",
// //                       overflow: "hidden",
// //                       minWidth: { xs: 280, sm: 320 },
// //                       flexShrink: 0,
// //                     }}
// //                   >
// //                     <Box
// //                       sx={{
// //                         position: "absolute",
// //                         width: 90,
// //                         height: 90,
// //                         borderRadius: "50%",
// //                         bgcolor: alpha(theme.palette.warning.main, 0.1),
// //                         top: -25,
// //                         right: 25,
// //                         zIndex: 0,
// //                       }}
// //                     />
// //                     <Box
// //                       sx={{
// //                         position: "absolute",
// //                         width: 70,
// //                         height: 70,
// //                         borderRadius: "50%",
// //                         bgcolor: alpha(theme.palette.warning.main, 0.1),
// //                         top: 15,
// //                         right: -25,
// //                         zIndex: 0,
// //                       }}
// //                     />
// //                     <Stack
// //                       spacing={2}
// //                       justifyContent="space-between"
// //                       sx={{ position: "relative", zIndex: 1 }}
// //                     >
// //                       <Stack direction="row" spacing={1.5} alignItems="center">
// //                         <Avatar
// //                           sx={{
// //                             bgcolor: "warning.light",
// //                             width: 48,
// //                             height: 48,
// //                           }}
// //                         >
// //                           <WorkOutline sx={{ color: "primary.main" }} />
// //                         </Avatar>
// //                         <Box>
// //                           <Typography
// //                             sx={{
// //                               fontWeight: "bold",
// //                               fontSize: "18px",
// //                               color: "text.primary",
// //                               lineHeight: 1.2,
// //                             }}
// //                           >
// //                             {app.position}
// //                           </Typography>
// //                           <Typography
// //                             sx={{
// //                               fontSize: "14px",
// //                               color: "text.secondary",
// //                               display: "flex",
// //                               alignItems: "center",
// //                               mt: 0.5,
// //                             }}
// //                           >
// //                             <LocationOn sx={{ fontSize: "16px", mr: 0.5 }} />
// //                             {app.company}
// //                           </Typography>
// //                         </Box>
// //                       </Stack>
// //                       <Box sx={{ alignSelf: "flex-end" }}>
// //                         <Chip
// //                           label={app.status}
// //                           sx={{
// //                             bgcolor:
// //                               app.status === "Applied"
// //                                 ? "success.main"
// //                                 : "primary.main",
// //                             color: "primary.contrastText",
// //                             borderRadius: "16px",
// //                             fontWeight: 500,
// //                             fontSize: "13px",
// //                             height: "32px",
// //                             ".MuiChip-label": { px: 2 },
// //                           }}
// //                         />
// //                       </Box>
// //                     </Stack>
// //                   </Card>
// //                 ))}
// //               </Stack>
// //               <Box sx={{ textAlign: "center", pt: 3 }}>
// //                 <Button
// //                   endIcon={<ArrowForward />}
// //                   color="primary"
// //                   variant="contained"
// //                   onClick={() => navigate("/gatep/talent/jobs")}
// //                   sx={{
// //                     borderRadius: "30px",
// //                     textTransform: "none",
// //                     fontWeight: "bold",
// //                     fontSize: "14px",
// //                     height: "40px",
// //                     px: 4,
// //                     width: "100%",
// //                     maxWidth: "350px",
// //                     mx: "auto",
// //                   }}
// //                 >
// //                   View All Recent Application
// //                 </Button>
// //               </Box>
// //             </Card>
// //           )}

// //           {/* AI Recommendations: Uses the main data loading state */}
// //           {mainDataLoading ? (
// //             <SectionSkeleton
// //               titleWidth={280}
// //               items={4}
// //               CardSkeletonComponent={JobRecommendationSkeletonCard}
// //             />
// //           ) : (
// //             <Card
// //               elevation={0}
// //               sx={{
// //                 p: { xs: 2, md: 3 },
// //                 borderRadius: "20px",
// //                 bgcolor: "mint.main",
// //                 boxShadow: (theme) =>
// //                   `0px 4px 12px ${alpha(theme.palette.common.black, 0.05)}`,
// //                 display: "flex",
// //                 flexDirection: "column",
// //                 height: "100%",
// //               }}
// //             >
// //               <Typography
// //                 variant="h5"
// //                 sx={{ fontWeight: "bold", color: "text.primary", mb: 3 }}
// //               >
// //                 AI Job Recommendations
// //               </Typography>
// //               <Stack
// //                 direction="row"
// //                 spacing={2.5}
// //                 sx={{
// //                   overflowX: "auto",
// //                   pb: 2,
// //                   "&::-webkit-scrollbar": {
// //                     display: "none",
// //                   },
// //                   "-ms-overflow-style": "none",
// //                   "scrollbar-width": "none",
// //                 }}
// //               >
// //                 {recommendations.slice(0, 6).map((rec) => {
// //                   const isApplying = applyingJobId === rec.id;
// //                   const isAlreadyApplied = applications.some(
// //                     (app) => String(app.job_posting) === String(rec.id)
// //                   );
// //                   const displaySkills = rec.required_skills.slice(0, 3);
// //                   const remainingSkills =
// //                     rec.required_skills.length - displaySkills.length;
// //                   return (
// //                     <Card
// //                       key={rec.id}
// //                       elevation={0}
// //                       sx={{
// //                         p: 2.5,
// //                         borderRadius: "20px",
// //                         border: (theme) => `1px solid ${theme.palette.divider}`,
// //                         bgcolor: "background.paper",
// //                         display: "flex",
// //                         flexDirection: "column",
// //                         gap: 1.5,
// //                         width: { xs: 300, sm: 360 },
// //                         flexShrink: 0,
// //                       }}
// //                     >
// //                       <Stack
// //                         direction="row"
// //                         justifyContent="space-between"
// //                         alignItems="flex-start"
// //                       >
// //                         <Stack
// //                           direction="row"
// //                           spacing={1.5}
// //                           alignItems="center"
// //                         >
// //                           <Avatar
// //                             variant="circular"
// //                             sx={{
// //                               bgcolor: "warning.light",
// //                               width: 48,
// //                               height: 48,
// //                             }}
// //                           >
// //                             <WorkOutline sx={{ color: "primary.main" }} />
// //                           </Avatar>
// //                           <Box sx={{ minHeight: "54px" }}>
// //                             <Typography
// //                               sx={{
// //                                 fontWeight: "bold",
// //                                 fontSize: "18px",
// //                                 color: "text.primary",
// //                                 overflow: "hidden",
// //                                 textOverflow: "ellipsis",
// //                                 display: "-webkit-box",
// //                                 WebkitLineClamp: "2",
// //                                 WebkitBoxOrient: "vertical",
// //                               }}
// //                             >
// //                               {rec.position}
// //                             </Typography>
// //                             <Typography
// //                               sx={{
// //                                 fontSize: "14px",
// //                                 color: "text.secondary",
// //                               }}
// //                             >
// //                               {rec.company}
// //                             </Typography>
// //                           </Box>
// //                         </Stack>
// //                         <Stack alignItems="flex-end" spacing={1}>
// //                           {rec.urgent && (
// //                             <Chip
// //                               label="Urgent Hiring"
// //                               size="small"
// //                               sx={{
// //                                 bgcolor: alpha(theme.palette.warning.main, 0.2),
// //                                 color: "warning.dark",
// //                                 fontWeight: 500,
// //                                 borderRadius: "16px",
// //                                 height: "auto",
// //                                 ".MuiChip-label": { py: "2px", px: "8px" },
// //                               }}
// //                             />
// //                           )}
// //                           <IconButton size="small">
// //                             <BookmarkBorder />
// //                           </IconButton>
// //                         </Stack>
// //                       </Stack>
// //                       <Stack spacing={0.5}>
// //                         <Stack direction="row" spacing={1}>
// //                           <LocationOn
// //                             sx={{
// //                               fontSize: "16px",
// //                               color: "text.secondary",
// //                               mt: "2px",
// //                             }}
// //                           />
// //                           <Typography
// //                             sx={{ fontSize: "14px", color: "text.secondary" }}
// //                           >
// //                             {rec.location}
// //                           </Typography>
// //                           {rec.visa_sponsorship && (
// //                             <Chip
// //                               label="Visa Sponsored"
// //                               size="small"
// //                               sx={{
// //                                 bgcolor: alpha(
// //                                   theme.palette.primary.main,
// //                                   0.15
// //                                 ),
// //                                 color: "primary.main",
// //                                 fontWeight: 500,
// //                                 borderRadius: "8px",
// //                                 height: "auto",
// //                                 ".MuiChip-label": { py: "1px" },
// //                               }}
// //                             />
// //                           )}
// //                         </Stack>
// //                         <Stack direction="row" spacing={1}>
// //                           <AttachMoney
// //                             sx={{
// //                               fontSize: "16px",
// //                               color: "text.secondary",
// //                               mt: "2px",
// //                             }}
// //                           />
// //                           <Typography
// //                             sx={{ fontSize: "14px", color: "text.secondary" }}
// //                           >{`$${(rec.salary_min / 1000).toFixed(0)}k-$${(
// //                             rec.salary_max / 1000
// //                           ).toFixed(0)}k`}</Typography>
// //                           <WorkOutline
// //                             sx={{
// //                               fontSize: "16px",
// //                               color: "text.secondary",
// //                               mt: "2px",
// //                               ml: 1,
// //                             }}
// //                           />
// //                           <Typography
// //                             sx={{ fontSize: "14px", color: "text.secondary" }}
// //                           >
// //                             {rec.details.job_type_display}
// //                           </Typography>
// //                         </Stack>
// //                         <Stack direction="row" spacing={1}>
// //                           <AccessTime
// //                             sx={{
// //                               fontSize: "16px",
// //                               color: "text.secondary",
// //                               mt: "2px",
// //                             }}
// //                           />
// //                           <Typography
// //                             sx={{ fontSize: "14px", color: "text.secondary" }}
// //                           >
// //                             {new Date(
// //                               rec.application_deadline || rec.posted_at
// //                             ).toLocaleDateString()}
// //                           </Typography>
// //                         </Stack>
// //                       </Stack>

// //                       <Box>
// //                         <Stack
// //                           direction="row"
// //                           justifyContent="space-between"
// //                           alignItems="center"
// //                         >
// //                           <Typography
// //                             sx={{
// //                               fontSize: "14px",
// //                               fontWeight: 600,
// //                               color: "text.primary",
// //                             }}
// //                           >
// //                             AI Match Score
// //                           </Typography>
// //                           <Typography
// //                             sx={{
// //                               fontSize: "14px",
// //                               fontWeight: "bold",
// //                               color: "success.main",
// //                             }}
// //                           >
// //                             {rec.match}%
// //                           </Typography>
// //                         </Stack>
// //                         <LinearProgress
// //                           variant="determinate"
// //                           value={rec.match}
// //                           sx={{
// //                             mt: 0.5,
// //                             height: 6,
// //                             borderRadius: 3,
// //                             bgcolor: "divider",
// //                             "& .MuiLinearProgress-bar": {
// //                               bgcolor: "success.main",
// //                             },
// //                           }}
// //                         />
// //                       </Box>
// //                       <Box sx={{ minHeight: "68px" }}>
// //                         <Typography
// //                           sx={{
// //                             fontSize: "14px",
// //                             color: "text.secondary",
// //                             mb: 1,
// //                           }}
// //                         >
// //                           Required Skills
// //                         </Typography>
// //                         <Stack
// //                           direction="row"
// //                           useFlexGap
// //                           flexWrap="wrap"
// //                           spacing={1}
// //                         >
// //                           {displaySkills.map((skill, index) => (
// //                             <Chip
// //                               key={`${skill}-${index}`}
// //                               label={skill}
// //                               variant="outlined"
// //                               size="small"
// //                             />
// //                           ))}
// //                           {remainingSkills > 0 && (
// //                             <Chip
// //                               label={`+${remainingSkills}`}
// //                               size="small"
// //                               sx={{
// //                                 bgcolor: "primary.light",
// //                                 color: "primary.main",
// //                                 borderRadius: "50%",
// //                                 fontWeight: "bold",
// //                               }}
// //                             />
// //                           )}
// //                         </Stack>
// //                       </Box>
// //                       <Stack
// //                         direction="row"
// //                         spacing={1.5}
// //                         sx={{ mt: "auto", pt: 2 }}
// //                       >
// //                         <Button
// //                           fullWidth
// //                           variant="outlined"
// //                           color="primary"
// //                           onClick={() => handleViewDetails(rec.details)}
// //                           sx={{
// //                             borderRadius: "30px",
// //                             textTransform: "none",
// //                             fontWeight: 600,
// //                           }}
// //                         >
// //                           View Details
// //                         </Button>
// //                         <Button
// //                           fullWidth
// //                           variant="contained"
// //                           color="primary"
// //                           onClick={() => handleQuickApply(rec.id)}
// //                           disabled={isApplying || isAlreadyApplied}
// //                           sx={{
// //                             borderRadius: "30px",
// //                             boxShadow: "none",
// //                             textTransform: "none",
// //                             fontWeight: 600,
// //                           }}
// //                         >
// //                           {isApplying ? (
// //                             <CircularProgress size={24} color="inherit" />
// //                           ) : isAlreadyApplied ? (
// //                             "Applied"
// //                           ) : (
// //                             "Quick Apply"
// //                           )}
// //                         </Button>
// //                       </Stack>
// //                     </Card>
// //                   );
// //                 })}
// //               </Stack>
// //               <Box sx={{ textAlign: "center", pt: 3, mt: "auto" }}>
// //                 <Button
// //                   endIcon={<ArrowForward />}
// //                   color="primary"
// //                   variant="contained"
// //                   onClick={() => navigate("/gatep/talent/jobs")}
// //                   sx={{
// //                     borderRadius: "30px",
// //                     textTransform: "none",
// //                     fontWeight: "bold",
// //                     fontSize: "14px",
// //                     height: "40px",
// //                     px: 4,
// //                     width: "100%",
// //                     maxWidth: "350px",
// //                     mx: "auto",
// //                   }}
// //                 >
// //                   View All AI JOB Recomendation
// //                 </Button>
// //               </Box>
// //             </Card>
// //           )}

// //           {/* This skeleton was in the original loading block but had no corresponding real component. */}
// //           {/* We show it conditionally to match the original loading experience. */}
// //           {mainDataLoading && <SkillsAndLanguagesSkeleton />}
// //         </Stack>
// //         <JobDetailsModal
// //           open={isDetailsModalOpen}
// //           onClose={handleCloseDetailsModal}
// //           job={selectedJobDetails}
// //         />
// //       </Container>
// //     </Layout>
// //   );
// // };

// // export default TalentDashboard;
// "use client";

// import { useState, useEffect, useRef } from "react";
// import {
//   Grid,
//   Card,
//   Typography,
//   Button,
//   Box,
//   Chip,
//   LinearProgress,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemIcon,
//   Avatar,
//   Stack,
//   Skeleton,
//   alpha,
//   Container,
//   CardContent,
//   CircularProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   darken,
// } from "@mui/material";
// import {
//   TrendingUp,
//   LocationOn,
//   ArrowForward,
//   CheckCircle,
//   Close as CloseIcon,
//   AttachMoney,
//   Event,
//   Beenhere,
//   WorkOutline,
//   BookmarkBorder,
//   AccessTime,
// } from "@mui/icons-material";
// import Layout from "../components/common/Layout";
// import { useNavigate } from "react-router-dom";
// import { useTheme } from "@mui/material/styles";
// import apiClient from "../context/apiClient";

// const JobDetailsModal = ({ open, onClose, job }) => {
//   const theme = useTheme();
//   // Show a loading spinner if the job data is being fetched
//   if (!job) {
//     return (
//       <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//         <DialogTitle>Loading Job Details...</DialogTitle>
//         <DialogContent sx={{ textAlign: "center", p: 4 }}>
//           <CircularProgress />
//         </DialogContent>
//       </Dialog>
//     );
//   }
//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//       <DialogTitle sx={{ m: 0, p: 2, pr: 8, bgcolor: "#F1FFFA" }}>
//         <Stack direction="row" spacing={2} alignItems="center">
//           <Avatar
//             src={job.company_details?.logo}
//             variant="rounded"
//             sx={{ width: 56, height: 56 }}
//           />
//           <Box>
//             <Typography variant="h5" component="div" fontWeight={700}>
//               {job.title}
//             </Typography>
//             <Typography variant="body1" color="text.secondary">
//               {job.company_details?.company_name}
//             </Typography>
//           </Box>
//         </Stack>
//         <IconButton
//           aria-label="close"
//           onClick={onClose}
//           sx={{
//             position: "absolute",
//             right: 8,
//             top: 8,
//             color: "text.secondary",
//           }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>
//       <DialogContent dividers sx={{ bgcolor: "#F1FFFA" }}>
//         <Stack
//           direction="row"
//           spacing={1}
//           useFlexGap
//           flexWrap="wrap"
//           sx={{ mb: 3 }}
//         >
//           <Chip icon={<LocationOn />} label={job.location} variant="outlined" />
//           <Chip
//             icon={<WorkOutline />}
//             label={job.job_type_display}
//             variant="outlined"
//           />
//           <Chip
//             icon={<TrendingUp />}
//             label={job.experience_level_display}
//             variant="outlined"
//           />
//           {job.remote_work && (
//             <Chip label="Remote Available" color="success" variant="outlined" />
//           )}
//           {job.visa_sponsorship && (
//             <Chip
//               label="Visa Sponsorship"
//               sx={{
//                 backgroundColor: "primary.main",
//                 color: "primary.contrastText",
//                 fontWeight: 500,
//               }}
//             />
//           )}
//         </Stack>
//         {job.salary_min && job.salary_max && (
//           <Box
//             display="flex"
//             alignItems="center"
//             mb={3}
//             p={2}
//             bgcolor={alpha(theme.palette.success.main, 0.1)}
//             borderRadius={2}
//           >
//             <AttachMoney sx={{ mr: 1, color: "success.main" }} />
//             <Typography
//               variant="h6"
//               component="p"
//               fontWeight={600}
//               color="success.dark"
//             >
//               {`${new Intl.NumberFormat("en-US", {
//                 style: "currency",
//                 currency: job.salary_currency || "USD",
//               }).format(job.salary_min)} - ${new Intl.NumberFormat("en-US", {
//                 style: "currency",
//                 currency: job.salary_currency || "USD",
//               }).format(job.salary_max)}`}
//             </Typography>
//           </Box>
//         )}
//         <Typography variant="h6" gutterBottom fontWeight={700}>
//           Job Description
//         </Typography>
//         <Typography
//           variant="body2"
//           sx={{
//             whiteSpace: "pre-wrap",
//             mb: 3,
//             color: "text.secondary",
//             lineHeight: 1.7,
//           }}
//         >
//           {job.description}
//         </Typography>
//         <Typography variant="h6" gutterBottom fontWeight={700}>
//           Responsibilities
//         </Typography>
//         <Typography
//           variant="body2"
//           sx={{
//             whiteSpace: "pre-wrap",
//             mb: 3,
//             color: "text.secondary",
//             lineHeight: 1.7,
//           }}
//         >
//           {job.responsibilities}
//         </Typography>
//         <Typography variant="h6" gutterBottom fontWeight={700}>
//           Requirements
//         </Typography>
//         <List dense sx={{ mb: 2 }}>
//           {job.requirements?.map((req, i) => (
//             <ListItem key={i} disableGutters>
//               <ListItemIcon sx={{ minWidth: 32 }}>
//                 <CheckCircle color="primary" fontSize="small" />
//               </ListItemIcon>
//               <ListItemText primary={req} />
//             </ListItem>
//           ))}
//         </List>
//         <Typography variant="h6" gutterBottom fontWeight={700}>
//           Required Skills
//         </Typography>
//         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
//           {job.required_skills?.map((skill, i) => (
//             <Chip key={i} label={skill} variant="outlined" />
//           ))}
//         </Box>
//         {job.benefits?.length > 0 && (
//           <>
//             <Typography variant="h6" gutterBottom fontWeight={700}>
//               Benefits
//             </Typography>
//             <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
//               {job.benefits.map((benefit, i) => (
//                 <Chip
//                   key={i}
//                   icon={<Beenhere />}
//                   label={benefit}
//                   variant="outlined"
//                   color="success"
//                 />
//               ))}
//             </Box>
//           </>
//         )}
//         {job.application_deadline && (
//           <Box
//             display="flex"
//             alignItems="center"
//             mt={2}
//             p={1.5}
//             bgcolor={alpha(theme.palette.warning.main, 0.1)}
//             borderRadius={2}
//           >
//             <Event sx={{ mr: 1, color: "warning.main" }} />
//             <Typography
//               variant="body2"
//               component="p"
//               fontWeight={600}
//               color="warning.dark"
//             >
//               Application Deadline:{" "}
//               {new Date(job.application_deadline).toLocaleDateString()}
//             </Typography>
//           </Box>
//         )}
//       </DialogContent>
//       <DialogActions sx={{ p: { xs: 2, sm: 3 }, bgcolor: "#F1FFFA" }}>
//         <Button onClick={onClose} color="inherit">
//           Close
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// const WelcomeCardSkeleton = () => (
//   <Card
//     elevation={0}
//     sx={{
//       p: { xs: 2, md: 3 },
//       borderRadius: "16px",
//       bgcolor: "mint.main",
//       boxShadow: "none",
//     }}
//   >
//     <Stack
//       direction={{ xs: "column", sm: "row" }}
//       spacing={2}
//       alignItems="center"
//     >
//       <Skeleton variant="circular" width={60} height={60} />
//       <Box flexGrow={1} sx={{ width: "100%" }}>
//         <Skeleton variant="text" width="40%" height={32} />
//         <Skeleton variant="text" width="60%" height={24} />
//         <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 1 }}>
//           <Skeleton
//             variant="rectangular"
//             height={8}
//             sx={{ flexGrow: 1, borderRadius: "4px" }}
//           />
//           <Skeleton variant="text" width="25%" height={24} />
//         </Stack>
//       </Box>
//       <Skeleton
//         variant="rectangular"
//         height={44}
//         width={180}
//         sx={{ borderRadius: "20px" }}
//       />
//     </Stack>
//   </Card>
// );

// const StatCardSkeleton = () => (
//   <Skeleton
//     variant="rectangular"
//     height={{ xs: 100, sm: 120 }}
//     sx={{ borderRadius: "14px", flex: 1, minWidth: 0 }}
//   />
// );

// const SectionSkeleton = ({
//   titleWidth = 200,
//   items = 3,
//   CardSkeletonComponent,
// }) => (
//   <Card
//     elevation={0}
//     sx={{
//       p: { xs: 2, md: 4 },
//       borderRadius: "20px",
//       bgcolor: "mint.main",
//       height: "100%",
//     }}
//   >
//     <Skeleton variant="text" width={titleWidth} height={40} sx={{ mb: 3 }} />
//     <Grid container spacing={2.5}>
//       {[...Array(items)].map((_, index) =>
//         CardSkeletonComponent ? <CardSkeletonComponent key={index} /> : null
//       )}
//     </Grid>
//     <Box sx={{ textAlign: "center", pt: 3 }}>
//       <Skeleton
//         variant="rectangular"
//         width={250}
//         height={40}
//         sx={{ borderRadius: "30px", mx: "auto" }}
//       />
//     </Box>
//   </Card>
// );

// const RecentApplicationSkeletonCard = () => (
//   <Grid item xs={12}>
//     <Card
//       elevation={0}
//       sx={{
//         p: 2,
//         borderRadius: "20px",
//         bgcolor: "#F1FFFA",
//         border: (theme) => `1px solid ${theme.palette.divider}`,
//       }}
//     >
//       <Stack spacing={2} justifyContent="space-between" height="100%">
//         <Stack direction="row" spacing={1.5} alignItems="center">
//           <Skeleton variant="circular" width={48} height={48} />
//           <Box>
//             <Skeleton variant="text" width={120} height={28} />
//             <Skeleton variant="text" width={100} height={20} />
//           </Box>
//         </Stack>
//         <Skeleton
//           variant="rectangular"
//           width={100}
//           height={32}
//           sx={{ borderRadius: "16px", alignSelf: "flex-end" }}
//         />
//       </Stack>
//     </Card>
//   </Grid>
// );

// const JobRecommendationSkeletonCard = () => (
//   <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
//     <Card
//       elevation={0}
//       sx={{
//         p: 3,
//         borderRadius: "20px",
//         border: (theme) => `1px solid ${theme.palette.divider}`,
//         bgcolor: "background.paper",
//         height: "100%",
//         width: "100%",
//         display: "flex",
//         flexDirection: "column",
//         gap: 1.5,
//       }}
//     >
//       <Stack
//         direction="row"
//         justifyContent="space-between"
//         alignItems="flex-start"
//       >
//         <Box>
//           <Skeleton variant="text" width={150} height={28} />
//           <Skeleton variant="text" width={100} height={20} />
//         </Box>
//         <Skeleton variant="circular" width={24} height={24} />
//       </Stack>
//       <Stack spacing={0.5}>
//         <Skeleton variant="text" width="50%" />
//         <Skeleton variant="text" width="70%" />
//         <Skeleton variant="text" width="40%" />
//       </Stack>
//       <Box>
//         <Stack
//           direction="row"
//           justifyContent="space-between"
//           alignItems="center"
//         >
//           <Skeleton variant="text" width="30%" />
//           <Skeleton variant="text" width="20%" />
//         </Stack>
//         <Skeleton
//           variant="rectangular"
//           height={6}
//           sx={{ mt: 1, borderRadius: 3 }}
//         />
//       </Box>
//       <Box>
//         <Skeleton variant="text" width="40%" sx={{ mb: 1 }} />
//         <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1}>
//           <Skeleton
//             variant="rectangular"
//             width={80}
//             height={24}
//             sx={{ borderRadius: "16px" }}
//           />
//           <Skeleton
//             variant="rectangular"
//             width={90}
//             height={24}
//             sx={{ borderRadius: "16px" }}
//           />
//         </Stack>
//       </Box>
//       <Stack direction="row" spacing={1.5} sx={{ mt: "auto", pt: 2 }}>
//         <Skeleton
//           variant="rectangular"
//           width="100%"
//           height={40}
//           sx={{ borderRadius: "30px" }}
//         />
//         <Skeleton
//           variant="rectangular"
//           width="100%"
//           height={40}
//           sx={{ borderRadius: "30px" }}
//         />
//       </Stack>
//     </Card>
//   </Grid>
// );

// // This component is no longer used as its data is not in the new API
// const SkillsAndLanguagesSkeleton = () => null;

// const mapApplicationStatus = (apiStatus) => {
//   switch (apiStatus) {
//     case "SCHEDULED":
//       return "Interview Scheduled";
//     case "UNDER_REVIEW":
//     case "REVIEW":
//       return "Under Review";
//     case "APPLIED":
//       return "Applied";
//     case "SHORTLISTED":
//       return "Shortlisted";
//     default:
//       return apiStatus;
//   }
// };
// const StatCard = ({ value, label, blobColor }) => {
//   const theme = useTheme();
//   // Use the provided blobColor or default to the theme's accent color
//   const primaryBlobColor = blobColor || theme.palette.accent.main;
//   // Create a slightly darker version for the background blob
//   const darkerBlobColor = darken(primaryBlobColor, 0.1);

//   return (
//     <Card
//       elevation={0}
//       sx={{
//         backgroundColor: theme.palette.primary.main,
//         borderRadius: "20px",
//         boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
//         p: { xs: 1.5, sm: 2.5 },
//         position: "relative",
//         overflow: "hidden",
//         color: theme.palette.primary.contrastText,
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         flex: 1, // Essential for responsive row
//         minWidth: 0, // Essential for responsive row
//         height: { xs: 100, sm: 120 },
//       }}
//     >
//       <Box
//         sx={{
//           position: "absolute",
//           top: 0,
//           right: 0,
//           bottom: 0,
//           width: "60%",
//           zIndex: 0, // SVG is in the back
//         }}
//       >
//         <svg
//           width="100%"
//           height="100%"
//           viewBox="0 0 80 120"
//           preserveAspectRatio="none"
//           style={{
//             filter: `drop-shadow(-4px 4px 8px ${alpha(
//               theme.palette.common.black,
//               0.2
//             )})`,
//           }}
//         >
//           <path
//             d="M 40,0 C 80,30 0,90 20,120 L 80,120 L 80,0 Z"
//             fill={darkerBlobColor}
//           />
//           <path
//             d="M 50,0 C 90,30 10,90 30,120 L 80,120 L 80,0 Z"
//             fill={primaryBlobColor}
//           />
//         </svg>
//       </Box>
//       <Stack sx={{ position: "relative", zIndex: 1 }}>
//         <Typography
//           sx={{
//             textTransform: "uppercase",
//             fontSize: { xs: "11px", sm: "13px" },
//             fontWeight: 500,
//             color: alpha(theme.palette.primary.contrastText, 0.7),
//             mb: 0.5,
//           }}
//         >
//           {label}
//         </Typography>
//         <Typography
//           sx={{
//             fontSize: { xs: "28px", sm: "34px" },
//             fontWeight: 700,
//             color: "primary.contrastText",
//             lineHeight: 1.1,
//           }}
//         >
//           {value}
//         </Typography>
//       </Stack>
//     </Card>
//   );
// };

// const TalentDashboard = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();

//   // --- NEW: State for dashboard counts ---
//   const [dashboardStats, setDashboardStats] = useState(null);
//   const [applications, setApplications] = useState([]);
//   const [recommendations, setRecommendations] = useState([]);

//   // States for loading, modals, and actions
//   const [mainDataLoading, setMainDataLoading] = useState(true);
//   const [profileProgressLoading, setProfileProgressLoading] = useState(true);
//   const [applyingJobId, setApplyingJobId] = useState(null);
//   const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
//   const [selectedJobDetails, setSelectedJobDetails] = useState(null);
//   const [profileProgress, setProfileProgress] = useState({
//     progress_percentage: 0,
//     message: "Loading your profile progress...",
//   });

//   const effectRan = useRef(false);

//   // --- REFACTORED: useEffect now uses the single dashboard API ---
//   useEffect(() => {
//     if (effectRan.current === true) {
//       return;
//     }

//     const token = localStorage.getItem("access_token");
//     if (!token) {
//       setMainDataLoading(false);
//       setProfileProgressLoading(false);
//       navigate("/gatep/login");
//       return;
//     }

//     const fetchDashboardData = async () => {
//       setMainDataLoading(true);
//       try {
//         const response = await apiClient.get("/talent/dashboard/");
//         const {
//           dashboard_counts,
//           recent_applications,
//           ai_job_recommendations,
//         } = response.data;

//         setDashboardStats(dashboard_counts);
//         setApplications(recent_applications || []);
//         setRecommendations(ai_job_recommendations || []);
//       } catch (error) {
//         console.error("Failed to fetch dashboard data:", error);
//         // Set empty states on error to prevent crashes
//         setDashboardStats({
//           active_applications: 0,
//           job_matches: 0,
//           job_notifications: 0,
//         });
//         setApplications([]);
//         setRecommendations([]);
//       } finally {
//         // Added a small delay for a smoother loading transition
//         setTimeout(() => setMainDataLoading(false), 800);
//       }
//     };

//     const fetchProfileProgress = async () => {
//       setProfileProgressLoading(true);
//       try {
//         const progressResponse = await apiClient.get("/resume-progress/");
//         if (progressResponse.data) {
//           setProfileProgress(progressResponse.data);
//         }
//       } catch (error) {
//         console.error("Failed to fetch profile progress data:", error);
//       } finally {
//         setProfileProgressLoading(false);
//       }
//     };

//     fetchDashboardData();
//     fetchProfileProgress();

//     return () => {
//       effectRan.current = true;
//     };
//   }, []); // navigate is stable and doesn't need to be in dependency array

//   // --- MODIFIED: Fetches full job details on-demand ---
//   const handleViewDetails = async (jobId) => {
//     setSelectedJobDetails(null); // Clear previous details
//     setIsDetailsModalOpen(true);
//     try {
//       const response = await apiClient.get(`/job-postings/${jobId}/`);
//       setSelectedJobDetails(response.data);
//     } catch (error) {
//       console.error(`Failed to fetch job details for ID ${jobId}:`, error);
//       // Optionally show an error message to the user
//       handleCloseDetailsModal(); // Close modal on error
//     }
//   };

//   const handleCloseDetailsModal = () => {
//     setIsDetailsModalOpen(false);
//     setSelectedJobDetails(null);
//   };

//   const handleQuickApply = async (jobId) => {
//     setApplyingJobId(jobId);
//     try {
//       const response = await apiClient.post("/applications/", {
//         job_posting: jobId,
//       });
//       // Assuming the apply endpoint response doesn't give full details,
//       // for now, we just update the applied state for the button.
//       // A more robust solution would be to refetch recommendations or applications.
//       // For instant feedback, we'll manually mark it as applied.
//       const appliedJob = recommendations.find((rec) => rec.id === jobId);
//       if (appliedJob) {
//         setApplications((prev) => [
//           {
//             job_title: appliedJob.title,
//             company_name: appliedJob.company_name,
//             status: "Applied",
//           },
//           ...prev,
//         ]);
//         // Also update the dashboard count for immediate feedback
//         if (dashboardStats) {
//           setDashboardStats((prev) => ({
//             ...prev,
//             active_applications: prev.active_applications + 1,
//           }));
//         }
//       }
//     } catch (error) {
//       console.error("Failed to quick apply:", error);
//       // Optionally show an error toast to the user
//     } finally {
//       setApplyingJobId(null);
//     }
//   };

//   // --- MODIFIED: Stats data is now built from API response ---
//   const statsData =
//     mainDataLoading || !dashboardStats
//       ? []
//       : [
//           {
//             label: "Active Applications",
//             value: dashboardStats.active_applications,
//             blobColor: theme.palette.warning.light,
//           },
//           {
//             label: "Job Matches",
//             value: dashboardStats.job_matches,
//             blobColor: theme.palette.error.light,
//           },
//           {
//             label: "Job Notification",
//             value: dashboardStats.job_notifications,
//             blobColor: theme.palette.info.light,
//           },
//         ];

//   return (
//     <Layout title="Talent Dashboard">
//       <Container
//         maxWidth={false}
//         sx={{ py: { xs: 2, md: 4 }, fontFamily: "'Poppins', sans-serif" }}
//       >
//         <Stack spacing={{ xs: 3, md: 4 }}>
//           {/* Welcome Card: Uses its own loading state */}
//           {profileProgressLoading ? (
//             <WelcomeCardSkeleton />
//           ) : (
//             <Card
//               elevation={0}
//               sx={{
//                 p: { xs: 2, md: 3 },
//                 borderRadius: "16px",
//                 bgcolor: "mint.main",
//                 boxShadow: "none",
//               }}
//             >
//               <Stack
//                 direction={{ xs: "column", sm: "row" }}
//                 spacing={2}
//                 alignItems="center"
//               >
//                 <Avatar
//                   src="/placeholder.svg?height=60&width=60"
//                   sx={{ width: 60, height: 60 }}
//                 />
//                 {profileProgress.progress_percentage === 100 ? (
//                   <>
//                     <Box
//                       flexGrow={1}
//                       sx={{
//                         width: "100%",
//                         textAlign: { xs: "center", sm: "left" },
//                       }}
//                     >
//                       <Typography
//                         variant="h5"
//                         sx={{ fontWeight: "bold", color: "text.primary" }}
//                       >
//                         Your Profile is Complete! What's Next ..?
//                       </Typography>
//                       <Typography
//                         sx={{
//                           color: "text.primary",
//                           fontSize: "1.2rem",
//                           mt: 0.5,
//                         }}
//                       >
//                         Take a mock interview to verify your skills and earn
//                         your official Skillspassport.
//                       </Typography>
//                     </Box>
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       onClick={() => navigate("/gatep/talent/exam-intro")}
//                       sx={{
//                         borderRadius: "20px",
//                         textTransform: "none",
//                         fontWeight: 600,
//                         px: 3,
//                         py: 1,
//                         flexShrink: 0, // Prevents button from shrinking
//                       }}
//                     >
//                       Start Mock Interview
//                     </Button>
//                   </>
//                 ) : (
//                   <>
//                     <Box
//                       flexGrow={1}
//                       sx={{
//                         width: "100%",
//                         textAlign: { xs: "center", sm: "left" },
//                       }}
//                     >
//                       <Typography
//                         variant="h5"
//                         sx={{ fontWeight: "bold", color: "text.primary" }}
//                       >
//                         Welcome Back!
//                       </Typography>
//                       <Typography
//                         sx={{ color: "text.primary", fontSize: "0.9rem" }}
//                       >
//                         {profileProgress.message}
//                       </Typography>
//                       <Stack
//                         direction="row"
//                         spacing={2}
//                         alignItems="center"
//                         sx={{ mt: 1 }}
//                       >
//                         <LinearProgress
//                           variant="determinate"
//                           value={profileProgress.progress_percentage || 0}
//                           sx={{
//                             flexGrow: 1,
//                             height: 8,
//                             borderRadius: "4px",
//                             bgcolor: alpha(theme.palette.primary.main, 0.2),
//                             "& .MuiLinearProgress-bar": {
//                               bgcolor: "primary.main",
//                             },
//                           }}
//                         />
//                         <Typography
//                           sx={{
//                             fontWeight: "bold",
//                             color: "primary.main",
//                             fontSize: "0.9rem",
//                           }}
//                         >
//                           {profileProgress.progress_percentage || 0}% Profile
//                           Completed
//                         </Typography>
//                       </Stack>
//                     </Box>
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       onClick={() => navigate("/gatep/talent/profile")}
//                       sx={{
//                         borderRadius: "20px",
//                         textTransform: "none",
//                         fontWeight: 600,
//                         px: 3,
//                         py: 1,
//                       }}
//                     >
//                       Complete Profile
//                     </Button>
//                   </>
//                 )}
//               </Stack>
//             </Card>
//           )}

//           {/* Stats Cards: Uses the main data loading state */}
//           {/* {mainDataLoading ? (
//             <Grid container spacing={2.5}>
//               {[...Array(3)].map((_, index) => (
//                 <Grid item xs={12} sm={4} key={index}>
//                   <StatCardSkeleton />
//                 </Grid>
//               ))}
//             </Grid>
//           ) : (
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "row",
//                 gap: { xs: 1.5, sm: 2, md: 3 },
//               }}
//             >
//               {statsData.map((stat, index) => (
//                 <StatCard key={index} {...stat} />
//               ))}
//             </Box>
//           )} */}
//           {/* Stats Cards: Uses the main data loading state */}
//           {mainDataLoading ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "row",
//                 gap: { xs: 1.5, sm: 2, md: 3 },
//               }}
//             >
//               {[...Array(3)].map((_, index) => (
//                 <StatCardSkeleton key={index} />
//               ))}
//             </Box>
//           ) : (
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "row",
//                 gap: { xs: 1.5, sm: 2, md: 3 },
//               }}
//             >
//               {statsData.map((stat, index) => (
//                 <StatCard key={index} {...stat} />
//               ))}
//             </Box>
//           )}

//           {/* Recent Applications: Uses the main data loading state */}
//           {mainDataLoading ? (
//             <SectionSkeleton
//               titleWidth={250}
//               items={4}
//               CardSkeletonComponent={RecentApplicationSkeletonCard}
//             />
//           ) : (
//             <Card
//               elevation={0}
//               sx={{
//                 p: { xs: 2, md: 3 },
//                 borderRadius: "20px",
//                 bgcolor: "mint.main",
//                 boxShadow: (theme) =>
//                   `0 4px 10px ${alpha(theme.palette.common.black, 0.05)}`,
//               }}
//             >
//               <Typography
//                 variant="h5"
//                 sx={{
//                   fontWeight: "bold",
//                   color: "text.primary",
//                   mb: 2,
//                 }}
//               >
//                 Recent Application
//               </Typography>
//               <Stack
//                 direction="row"
//                 spacing={2.5}
//                 sx={{
//                   overflowX: "auto",
//                   pb: 1,
//                   "&::-webkit-scrollbar": {
//                     display: "none",
//                   },
//                   "-ms-overflow-style": "none",
//                   "scrollbar-width": "none",
//                 }}
//               >
//                 {applications.slice(0, 8).map((app, index) => (
//                   <Card
//                     key={`${app.job_title}-${index}`} // Using index as key since no ID is provided
//                     elevation={0}
//                     sx={{
//                       p: 2,
//                       borderRadius: "20px",
//                       bgcolor: "background.paper",
//                       border: (theme) => `1px solid ${theme.palette.divider}`,
//                       position: "relative",
//                       overflow: "hidden",
//                       minWidth: { xs: 280, sm: 320 },
//                       flexShrink: 0,
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         position: "absolute",
//                         width: 90,
//                         height: 90,
//                         borderRadius: "50%",
//                         bgcolor: alpha(theme.palette.warning.main, 0.1),
//                         top: -25,
//                         right: 25,
//                         zIndex: 0,
//                       }}
//                     />
//                     <Box
//                       sx={{
//                         position: "absolute",
//                         width: 70,
//                         height: 70,
//                         borderRadius: "50%",
//                         bgcolor: alpha(theme.palette.warning.main, 0.1),
//                         top: 15,
//                         right: -25,
//                         zIndex: 0,
//                       }}
//                     />
//                     <Stack
//                       spacing={2}
//                       justifyContent="space-between"
//                       sx={{ position: "relative", zIndex: 1 }}
//                     >
//                       <Stack direction="row" spacing={1.5} alignItems="center">
//                         <Avatar
//                           sx={{
//                             bgcolor: "warning.light",
//                             width: 48,
//                             height: 48,
//                           }}
//                         >
//                           <WorkOutline sx={{ color: "primary.main" }} />
//                         </Avatar>
//                         <Box>
//                           <Typography
//                             sx={{
//                               fontWeight: "bold",
//                               fontSize: "18px",
//                               color: "text.primary",
//                               lineHeight: 1.2,
//                             }}
//                           >
//                             {app.job_title}
//                           </Typography>
//                           <Typography
//                             sx={{
//                               fontSize: "14px",
//                               color: "text.secondary",
//                               display: "flex",
//                               alignItems: "center",
//                               mt: 0.5,
//                             }}
//                           >
//                             <LocationOn sx={{ fontSize: "16px", mr: 0.5 }} />
//                             {app.company_name}
//                           </Typography>
//                         </Box>
//                       </Stack>
//                       <Box sx={{ alignSelf: "flex-end" }}>
//                         <Chip
//                           label={app.status}
//                           sx={{
//                             bgcolor:
//                               app.status === "Applied"
//                                 ? "success.main"
//                                 : "primary.main",
//                             color: "primary.contrastText",
//                             borderRadius: "16px",
//                             fontWeight: 500,
//                             fontSize: "13px",
//                             height: "32px",
//                             ".MuiChip-label": { px: 2 },
//                           }}
//                         />
//                       </Box>
//                     </Stack>
//                   </Card>
//                 ))}
//               </Stack>
//               <Box sx={{ textAlign: "center", pt: 3 }}>
//                 <Button
//                   endIcon={<ArrowForward />}
//                   color="primary"
//                   variant="contained"
//                   onClick={() => navigate("/gatep/talent/jobs")}
//                   sx={{
//                     borderRadius: "30px",
//                     textTransform: "none",
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                     height: "40px",
//                     px: 4,
//                     width: "100%",
//                     maxWidth: "350px",
//                     mx: "auto",
//                   }}
//                 >
//                   View All Recent Application
//                 </Button>
//               </Box>
//             </Card>
//           )}

//           {/* AI Recommendations: Uses the main data loading state */}
//           {mainDataLoading ? (
//             <SectionSkeleton
//               titleWidth={280}
//               items={4}
//               CardSkeletonComponent={JobRecommendationSkeletonCard}
//             />
//           ) : (
//             <Card
//               elevation={0}
//               sx={{
//                 p: { xs: 2, md: 3 },
//                 borderRadius: "20px",
//                 bgcolor: "mint.main",
//                 boxShadow: (theme) =>
//                   `0px 4px 12px ${alpha(theme.palette.common.black, 0.05)}`,
//                 display: "flex",
//                 flexDirection: "column",
//                 height: "100%",
//               }}
//             >
//               <Typography
//                 variant="h5"
//                 sx={{ fontWeight: "bold", color: "text.primary", mb: 3 }}
//               >
//                 AI Job Recommendations
//               </Typography>
//               <Stack
//                 direction="row"
//                 spacing={2.5}
//                 sx={{
//                   overflowX: "auto",
//                   pb: 2,
//                   "&::-webkit-scrollbar": {
//                     display: "none",
//                   },
//                   "-ms-overflow-style": "none",
//                   "scrollbar-width": "none",
//                 }}
//               >
//                 {recommendations.slice(0, 6).map((rec) => {
//                   const isApplying = applyingJobId === rec.id;
//                   // Check if a job with the same title and company has been applied to
//                   const isAlreadyApplied = applications.some(
//                     (app) =>
//                       app.job_title === rec.title &&
//                       app.company_name === rec.company_name
//                   );
//                   const displaySkills = rec.required_skills.slice(0, 3);
//                   const remainingSkills =
//                     rec.required_skills.length - displaySkills.length;
//                   return (
//                     <Card
//                       key={rec.id}
//                       elevation={0}
//                       sx={{
//                         p: 2.5,
//                         borderRadius: "20px",
//                         border: (theme) => `1px solid ${theme.palette.divider}`,
//                         bgcolor: "background.paper",
//                         display: "flex",
//                         flexDirection: "column",
//                         gap: 1.5,
//                         width: { xs: 300, sm: 360 },
//                         flexShrink: 0,
//                       }}
//                     >
//                       <Stack
//                         direction="row"
//                         justifyContent="space-between"
//                         alignItems="flex-start"
//                       >
//                         <Stack
//                           direction="row"
//                           spacing={1.5}
//                           alignItems="center"
//                         >
//                           <Avatar
//                             variant="circular"
//                             sx={{
//                               bgcolor: "warning.light",
//                               width: 48,
//                               height: 48,
//                             }}
//                           >
//                             <WorkOutline sx={{ color: "primary.main" }} />
//                           </Avatar>
//                           <Box sx={{ minHeight: "54px" }}>
//                             <Typography
//                               sx={{
//                                 fontWeight: "bold",
//                                 fontSize: "18px",
//                                 color: "text.primary",
//                                 overflow: "hidden",
//                                 textOverflow: "ellipsis",
//                                 display: "-webkit-box",
//                                 WebkitLineClamp: "2",
//                                 WebkitBoxOrient: "vertical",
//                               }}
//                             >
//                               {rec.title}
//                             </Typography>
//                             <Typography
//                               sx={{
//                                 fontSize: "14px",
//                                 color: "text.secondary",
//                               }}
//                             >
//                               {rec.company_name}
//                             </Typography>
//                           </Box>
//                         </Stack>
//                         <Stack alignItems="flex-end" spacing={1}>
//                           {rec.urgent && (
//                             <Chip
//                               label="Urgent Hiring"
//                               size="small"
//                               sx={{
//                                 bgcolor: alpha(theme.palette.warning.main, 0.2),
//                                 color: "warning.dark",
//                                 fontWeight: 500,
//                                 borderRadius: "16px",
//                                 height: "auto",
//                                 ".MuiChip-label": { py: "2px", px: "8px" },
//                               }}
//                             />
//                           )}
//                           <IconButton size="small">
//                             <BookmarkBorder />
//                           </IconButton>
//                         </Stack>
//                       </Stack>
//                       <Stack spacing={0.5}>
//                         <Stack direction="row" spacing={1}>
//                           <LocationOn
//                             sx={{
//                               fontSize: "16px",
//                               color: "text.secondary",
//                               mt: "2px",
//                             }}
//                           />
//                           <Typography
//                             sx={{ fontSize: "14px", color: "text.secondary" }}
//                           >
//                             {rec.location}
//                           </Typography>
//                           {rec.visa_sponsorship && (
//                             <Chip
//                               label="Visa Sponsored"
//                               size="small"
//                               sx={{
//                                 bgcolor: alpha(
//                                   theme.palette.primary.main,
//                                   0.15
//                                 ),
//                                 color: "primary.main",
//                                 fontWeight: 500,
//                                 borderRadius: "8px",
//                                 height: "auto",
//                                 ".MuiChip-label": { py: "1px" },
//                               }}
//                             />
//                           )}
//                         </Stack>
//                         <Stack direction="row" spacing={1}>
//                           <AttachMoney
//                             sx={{
//                               fontSize: "16px",
//                               color: "text.secondary",
//                               mt: "2px",
//                             }}
//                           />
//                           <Typography
//                             sx={{ fontSize: "14px", color: "text.secondary" }}
//                           >{`$${(rec.salary_min / 1000).toFixed(0)}k-$${(
//                             rec.salary_max / 1000
//                           ).toFixed(0)}k`}</Typography>
//                           <WorkOutline
//                             sx={{
//                               fontSize: "16px",
//                               color: "text.secondary",
//                               mt: "2px",
//                               ml: 1,
//                             }}
//                           />
//                           <Typography
//                             sx={{ fontSize: "14px", color: "text.secondary" }}
//                           >
//                             {rec.job_type}
//                           </Typography>
//                         </Stack>
//                         <Stack direction="row" spacing={1}>
//                           <AccessTime
//                             sx={{
//                               fontSize: "16px",
//                               color: "text.secondary",
//                               mt: "2px",
//                             }}
//                           />
//                           <Typography
//                             sx={{ fontSize: "14px", color: "text.secondary" }}
//                           >
//                             {new Date(
//                               rec.application_deadline
//                             ).toLocaleDateString()}
//                           </Typography>
//                         </Stack>
//                       </Stack>

//                       <Box>
//                         <Stack
//                           direction="row"
//                           justifyContent="space-between"
//                           alignItems="center"
//                         >
//                           <Typography
//                             sx={{
//                               fontSize: "14px",
//                               fontWeight: 600,
//                               color: "text.primary",
//                             }}
//                           >
//                             AI Match Score
//                           </Typography>
//                           <Typography
//                             sx={{
//                               fontSize: "14px",
//                               fontWeight: "bold",
//                               color: "success.main",
//                             }}
//                           >
//                             {rec.matching_percentage}%
//                           </Typography>
//                         </Stack>
//                         <LinearProgress
//                           variant="determinate"
//                           value={rec.matching_percentage}
//                           sx={{
//                             mt: 0.5,
//                             height: 6,
//                             borderRadius: 3,
//                             bgcolor: "divider",
//                             "& .MuiLinearProgress-bar": {
//                               bgcolor: "success.main",
//                             },
//                           }}
//                         />
//                       </Box>
//                       <Box sx={{ minHeight: "68px" }}>
//                         <Typography
//                           sx={{
//                             fontSize: "14px",
//                             color: "text.secondary",
//                             mb: 1,
//                           }}
//                         >
//                           Required Skills
//                         </Typography>
//                         <Stack
//                           direction="row"
//                           useFlexGap
//                           flexWrap="wrap"
//                           spacing={1}
//                         >
//                           {displaySkills.map((skill, index) => (
//                             <Chip
//                               key={`${skill}-${index}`}
//                               label={skill}
//                               variant="outlined"
//                               size="small"
//                             />
//                           ))}
//                           {remainingSkills > 0 && (
//                             <Chip
//                               label={`+${remainingSkills}`}
//                               size="small"
//                               sx={{
//                                 bgcolor: "primary.light",
//                                 color: "primary.main",
//                                 borderRadius: "50%",
//                                 fontWeight: "bold",
//                               }}
//                             />
//                           )}
//                         </Stack>
//                       </Box>
//                       <Stack
//                         direction="row"
//                         spacing={1.5}
//                         sx={{ mt: "auto", pt: 2 }}
//                       >
//                         <Button
//                           fullWidth
//                           variant="outlined"
//                           color="primary"
//                           onClick={() => handleViewDetails(rec.id)}
//                           sx={{
//                             borderRadius: "30px",
//                             textTransform: "none",
//                             fontWeight: 600,
//                           }}
//                         >
//                           View Details
//                         </Button>
//                         <Button
//                           fullWidth
//                           variant="contained"
//                           color="primary"
//                           onClick={() => handleQuickApply(rec.id)}
//                           disabled={isApplying || isAlreadyApplied}
//                           sx={{
//                             borderRadius: "30px",
//                             boxShadow: "none",
//                             textTransform: "none",
//                             fontWeight: 600,
//                           }}
//                         >
//                           {isApplying ? (
//                             <CircularProgress size={24} color="inherit" />
//                           ) : isAlreadyApplied ? (
//                             "Applied"
//                           ) : (
//                             "Quick Apply"
//                           )}
//                         </Button>
//                       </Stack>
//                     </Card>
//                   );
//                 })}
//               </Stack>
//               <Box sx={{ textAlign: "center", pt: 3, mt: "auto" }}>
//                 <Button
//                   endIcon={<ArrowForward />}
//                   color="primary"
//                   variant="contained"
//                   onClick={() => navigate("/gatep/talent/jobs")}
//                   sx={{
//                     borderRadius: "30px",
//                     textTransform: "none",
//                     fontWeight: "bold",
//                     fontSize: "14px",
//                     height: "40px",
//                     px: 4,
//                     width: "100%",
//                     maxWidth: "350px",
//                     mx: "auto",
//                   }}
//                 >
//                   View All AI JOB Recomendation
//                 </Button>
//               </Box>
//             </Card>
//           )}
//         </Stack>
//         <JobDetailsModal
//           open={isDetailsModalOpen}
//           onClose={handleCloseDetailsModal}
//           job={selectedJobDetails}
//         />
//       </Container>
//     </Layout>
//   );
// };

// export default TalentDashboard;
"use client";

import { useState, useEffect, useRef } from "react";
import {
  Grid,
  Card,
  Typography,
  Button,
  Box,
  Chip,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Avatar,
  Stack,
  Skeleton,
  alpha,
  Container,
  CardContent,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  darken,
} from "@mui/material";
import {
  TrendingUp,
  LocationOn,
  ArrowForward,
  CheckCircle,
  Close as CloseIcon,
  AttachMoney,
  Event,
  Beenhere,
  WorkOutline,
  BookmarkBorder,
  AccessTime,
  FindInPage, // New icon for empty state
} from "@mui/icons-material";
import Layout from "../components/common/Layout";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import apiClient from "../context/apiClient";

const JobDetailsModal = ({ open, onClose, job }) => {
  const theme = useTheme();
  if (!job) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
        PaperProps={{ sx: { borderRadius: "20px", bgcolor: "background.paper", border: `1px solid ${alpha(theme.palette.primary.main, 0.15)}` } }}
      >
        <DialogTitle sx={{ fontWeight: 700 }}>Loading Job Details...</DialogTitle>
        <DialogContent sx={{ textAlign: "center", p: 4 }}>
          <CircularProgress color="primary" />
        </DialogContent>
      </Dialog>
    );
  }
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
      PaperProps={{ sx: { borderRadius: "20px", bgcolor: "background.paper", border: `1px solid ${alpha(theme.palette.primary.main, 0.15)}`, backdropFilter: "blur(12px)" } }}
    >
      <DialogTitle sx={{ m: 0, p: 3, borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.1)}` }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar
            src={job.company_details?.logo}
            variant="rounded"
            sx={{ width: 52, height: 52, border: `2px solid ${alpha(theme.palette.primary.main, 0.3)}`, bgcolor: alpha(theme.palette.primary.main, 0.1) }}
          />
          <Box>
            <Typography variant="h6" fontWeight={800}>{job.title}</Typography>
            <Typography variant="body2" color="text.secondary">{job.company_details?.company_name}</Typography>
          </Box>
        </Stack>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 12, top: 12, color: "text.secondary", "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.1), color: "primary.main" } }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mb: 3, mt: 1 }}>
          <Chip icon={<LocationOn />} label={job.location} size="small"
            sx={{ bgcolor: alpha(theme.palette.primary.main, 0.08), color: "primary.main", borderRadius: "8px", fontWeight: 600, border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}` }}
          />
          <Chip icon={<WorkOutline />} label={job.job_type_display} size="small"
            sx={{ bgcolor: alpha(theme.palette.primary.main, 0.06), color: "text.secondary", borderRadius: "8px", border: `1px solid ${alpha(theme.palette.divider, 0.3)}` }}
          />
          <Chip icon={<TrendingUp />} label={job.experience_level_display} size="small"
            sx={{ bgcolor: alpha(theme.palette.primary.main, 0.06), color: "text.secondary", borderRadius: "8px", border: `1px solid ${alpha(theme.palette.divider, 0.3)}` }}
          />
          {job.remote_work && (
            <Chip label="Remote Available" size="small"
              sx={{ bgcolor: alpha(theme.palette.success.main, 0.1), color: "success.light", borderRadius: "8px", border: `1px solid ${alpha(theme.palette.success.main, 0.25)}`, fontWeight: 700 }}
            />
          )}
          {job.visa_sponsorship && (
            <Chip label="Visa Sponsorship" size="small"
              sx={{ bgcolor: alpha(theme.palette.primary.main, 0.12), color: "primary.main", borderRadius: "8px", border: `1px solid ${alpha(theme.palette.primary.main, 0.25)}`, fontWeight: 700 }}
            />
          )}
        </Stack>
        {job.salary_min && job.salary_max && (
          <Box display="flex" alignItems="center" mb={3} p={2} sx={{ bgcolor: alpha(theme.palette.success.main, 0.07), border: `1px solid ${alpha(theme.palette.success.main, 0.18)}`, borderRadius: "12px" }}>
            <AttachMoney sx={{ mr: 1, color: "success.main" }} />
            <Typography variant="h6" component="p" fontWeight={700} color="success.light">
              {`${new Intl.NumberFormat("en-US", { style: "currency", currency: job.salary_currency || "USD" }).format(job.salary_min)} - ${new Intl.NumberFormat("en-US", { style: "currency", currency: job.salary_currency || "USD" }).format(job.salary_max)}`}
            </Typography>
          </Box>
        )}
        <Typography variant="subtitle2" fontWeight={800} gutterBottom sx={{ color: "primary.main", letterSpacing: "0.06em", textTransform: "uppercase", fontSize: "0.72rem" }}>Job Description</Typography>
        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", mb: 3, color: "text.secondary", lineHeight: 1.8 }}>{job.description}</Typography>
        <Typography variant="subtitle2" fontWeight={800} gutterBottom sx={{ color: "primary.main", letterSpacing: "0.06em", textTransform: "uppercase", fontSize: "0.72rem" }}>Responsibilities</Typography>
        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", mb: 3, color: "text.secondary", lineHeight: 1.8 }}>{job.responsibilities}</Typography>
        <Typography variant="subtitle2" fontWeight={800} gutterBottom sx={{ color: "primary.main", letterSpacing: "0.06em", textTransform: "uppercase", fontSize: "0.72rem" }}>Requirements</Typography>
        <List dense sx={{ mb: 2 }}>
          {job.requirements?.map((req, i) => (
            <ListItem key={i} disableGutters>
              <ListItemIcon sx={{ minWidth: 32 }}><CheckCircle sx={{ color: "primary.main", fontSize: 18 }} /></ListItemIcon>
              <ListItemText primary={req} primaryTypographyProps={{ variant: "body2", color: "text.secondary" }} />
            </ListItem>
          ))}
        </List>
        <Typography variant="subtitle2" fontWeight={800} gutterBottom sx={{ color: "primary.main", letterSpacing: "0.06em", textTransform: "uppercase", fontSize: "0.72rem" }}>Required Skills</Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
          {job.required_skills?.map((skill, i) => (
            <Chip key={i} label={skill} size="small"
              sx={{ bgcolor: alpha(theme.palette.primary.main, 0.08), color: "primary.main", borderRadius: "8px", border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`, fontWeight: 600 }}
            />
          ))}
        </Box>
        {job.benefits?.length > 0 && (
          <>
            <Typography variant="subtitle2" fontWeight={800} gutterBottom sx={{ color: "primary.main", letterSpacing: "0.06em", textTransform: "uppercase", fontSize: "0.72rem" }}>Benefits</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
              {job.benefits.map((benefit, i) => (
                <Chip key={i} icon={<Beenhere sx={{ color: "success.main !important" }} />} label={benefit} size="small"
                  sx={{ bgcolor: alpha(theme.palette.success.main, 0.08), color: "success.light", borderRadius: "8px", border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`, fontWeight: 600 }}
                />
              ))}
            </Box>
          </>
        )}
        {job.application_deadline && (
          <Box display="flex" alignItems="center" mt={2} p={1.5} sx={{ bgcolor: alpha(theme.palette.warning.main, 0.07), border: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`, borderRadius: "12px" }}>
            <Event sx={{ mr: 1, color: "warning.main" }} />
            <Typography variant="body2" component="p" fontWeight={600} color="warning.light">
              Application Deadline: {new Date(job.application_deadline).toLocaleDateString()}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 3, borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.1)}` }}>
        <Button onClick={onClose} variant="outlined"
          sx={{ borderRadius: "12px", textTransform: "none", fontWeight: 700, borderColor: alpha(theme.palette.primary.main, 0.3), color: "primary.main", "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.08) } }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const WelcomeCardSkeleton = () => (
  <Card
    elevation={0}
    sx={{
      p: { xs: 2, md: 3 },
      borderRadius: "24px",
      background: theme => theme.palette.mode === 'dark' 
        ? `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.15)} 0%, ${alpha(theme.palette.background.paper, 0.8)} 100%)`
        : `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${theme.palette.background.paper} 100%)`,
      border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
      boxShadow: "none",
    }}
  >

    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      alignItems="center"
    >
      <Skeleton variant="circular" width={60} height={60} />
      <Box flexGrow={1} sx={{ width: "100%" }}>
        <Skeleton variant="text" width="40%" height={32} />
        <Skeleton variant="text" width="60%" height={24} />
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 1 }}>
          <Skeleton
            variant="rectangular"
            height={8}
            sx={{ flexGrow: 1, borderRadius: "4px" }}
          />
          <Skeleton variant="text" width="25%" height={24} />
        </Stack>
      </Box>
      <Skeleton
        variant="rectangular"
        height={44}
        width={180}
        sx={{ borderRadius: "20px" }}
      />
    </Stack>
  </Card>
);

const StatCardSkeleton = () => (
  <Skeleton
    variant="rectangular"
    height={{ xs: 100, sm: 120 }}
    sx={{ borderRadius: "14px", flex: 1, minWidth: 0 }}
  />
);

const SectionSkeleton = ({
  titleWidth = 200,
  items = 3,
  CardSkeletonComponent,
}) => (
  <Card
    elevation={0}
    sx={{
      p: { xs: 2, md: 4 },
      borderRadius: "24px",
      bgcolor: "background.paper",
      border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
      height: "100%",
    }}
  >

    <Skeleton variant="text" width={titleWidth} height={40} sx={{ mb: 3 }} />
    <Grid container spacing={2.5}>
      {[...Array(items)].map((_, index) =>
        CardSkeletonComponent ? <CardSkeletonComponent key={index} /> : null
      )}
    </Grid>
    <Box sx={{ textAlign: "center", pt: 3 }}>
      <Skeleton
        variant="rectangular"
        width={250}
        height={40}
        sx={{ borderRadius: "30px", mx: "auto" }}
      />
    </Box>
  </Card>
);

const RecentApplicationSkeletonCard = () => (
  <Grid item xs={12}>
    <Card
      elevation={0}
      sx={{
        p: 2,
        borderRadius: "20px",
        bgcolor: "background.paper",
        border: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >

      <Stack spacing={2} justifyContent="space-between" height="100%">
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Skeleton variant="circular" width={48} height={48} />
          <Box>
            <Skeleton variant="text" width={120} height={28} />
            <Skeleton variant="text" width={100} height={20} />
          </Box>
        </Stack>
        <Skeleton
          variant="rectangular"
          width={100}
          height={32}
          sx={{ borderRadius: "16px", alignSelf: "flex-end" }}
        />
      </Stack>
    </Card>
  </Grid>
);

const JobRecommendationSkeletonCard = () => (
  <Grid item xs={12} sm={6} sx={{ display: "flex" }}>
    <Card
      elevation={0}
      sx={{
        p: 3,
        borderRadius: "20px",
        border: (theme) => `1px solid ${theme.palette.divider}`,
        bgcolor: "background.paper",
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box>
          <Skeleton variant="text" width={150} height={28} />
          <Skeleton variant="text" width={100} height={20} />
        </Box>
        <Skeleton variant="circular" width={24} height={24} />
      </Stack>
      <Stack spacing={0.5}>
        <Skeleton variant="text" width="50%" />
        <Skeleton variant="text" width="70%" />
        <Skeleton variant="text" width="40%" />
      </Stack>
      <Box>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Skeleton variant="text" width="30%" />
          <Skeleton variant="text" width="20%" />
        </Stack>
        <Skeleton
          variant="rectangular"
          height={6}
          sx={{ mt: 1, borderRadius: 3 }}
        />
      </Box>
      <Box>
        <Skeleton variant="text" width="40%" sx={{ mb: 1 }} />
        <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1}>
          <Skeleton
            variant="rectangular"
            width={80}
            height={24}
            sx={{ borderRadius: "16px" }}
          />
          <Skeleton
            variant="rectangular"
            width={90}
            height={24}
            sx={{ borderRadius: "16px" }}
          />
        </Stack>
      </Box>
      <Stack direction="row" spacing={1.5} sx={{ mt: "auto", pt: 2 }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={40}
          sx={{ borderRadius: "30px" }}
        />
        <Skeleton
          variant="rectangular"
          width="100%"
          height={40}
          sx={{ borderRadius: "30px" }}
        />
      </Stack>
    </Card>
  </Grid>
);

// This component is no longer used as its data is not in the new API
const SkillsAndLanguagesSkeleton = () => null;

// --- Empty State Component (Gold) ---
const EmptyState = ({ icon, title, description, action }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      p: 5,
      minHeight: 220,
      width: "100%",
      borderRadius: "16px",
      border: (theme) => `1px dashed ${alpha(theme.palette.primary.main, 0.25)}`,
      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.03),
    }}
  >
    <Avatar
      sx={{
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
        width: 60,
        height: 60,
        mb: 2,
        border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.25)}`,
      }}
    >
      {icon}
    </Avatar>
    <Typography variant="h6" fontWeight={800} gutterBottom>{title}</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 380, mb: action ? 3 : 0 }}>
      {description}
    </Typography>
    {action}
  </Box>
);

const mapApplicationStatus = (apiStatus) => {
  switch (apiStatus) {
    case "SCHEDULED":
      return "Interview Scheduled";
    case "UNDER_REVIEW":
    case "REVIEW":
      return "Under Review";
    case "APPLIED":
      return "Applied";
    case "SHORTLISTED":
      return "Shortlisted";
    default:
      return apiStatus;
  }
};
const StatCard = ({ value, label, blobColor }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const goldMain = theme.palette.primary.main;
  
  return (
    <Card
      elevation={0}
      sx={{
        background: isDark
          ? `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(theme.palette.background.default, 0.9)} 100%)`
          : `linear-gradient(135deg, ${alpha(goldMain, 0.1)} 0%, ${theme.palette.background.paper} 100%)`,
        borderRadius: "24px",
        border: `1px solid ${isDark ? alpha(goldMain, 0.2) : alpha(goldMain, 0.15)}`,
        boxShadow: isDark 
          ? `0 10px 30px ${alpha(theme.palette.common.black, 0.4)}`
          : `0 10px 30px ${alpha(theme.palette.common.black, 0.05)}`,
        p: { xs: 1.5, sm: 2.5 },
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        flex: 1,
        minWidth: 0,
        height: { xs: 120, sm: 140 },
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: isDark
            ? `0 20px 40px ${alpha(theme.palette.common.black, 0.6)}, 0 0 0 1px ${alpha(goldMain, 0.4)}`
            : `0 20px 40px ${alpha(theme.palette.common.black, 0.1)}, 0 0 0 1px ${alpha(goldMain, 0.3)}`,
        }
      }}
    >
      <Box sx={{ 
        position: "absolute", 
        top: -30, 
        right: -30, 
        width: 100, 
        height: 100, 
        borderRadius: "50%",
        background: `radial-gradient(circle, ${alpha(goldMain, isDark ? 0.2 : 0.1)} 0%, transparent 70%)`, 
        zIndex: 0 
      }} />

      <Stack sx={{ position: "relative", zIndex: 1 }}>
        <Typography 
          sx={{ 
            textTransform: "uppercase", 
            fontSize: { xs: "10px", sm: "11px" }, 
            fontWeight: 700,
            letterSpacing: "0.1em", 
            color: isDark ? alpha(goldMain, 0.9) : "#8B8B8B", 
            mb: 0.5 
          }}
        >
          {label}
        </Typography>
        <Typography 
          sx={{ 
            fontSize: { xs: "32px", sm: "42px" }, 
            fontWeight: 800, 
            color: isDark ? "common.white" : "text.primary", 
            lineHeight: 1, 
            letterSpacing: "-1px" 
          }}
        >
          {value}
        </Typography>
      </Stack>
    </Card>
  );
};

const TalentDashboard = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  // --- NEW: State for dashboard counts ---
  const [dashboardStats, setDashboardStats] = useState(null);
  const [applications, setApplications] = useState([]);
  const [recommendations, setRecommendations] = useState([]);

  // States for loading, modals, and actions
  const [mainDataLoading, setMainDataLoading] = useState(true);
  const [profileProgressLoading, setProfileProgressLoading] = useState(true);
  const [applyingJobId, setApplyingJobId] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedJobDetails, setSelectedJobDetails] = useState(null);
  const [profileProgress, setProfileProgress] = useState({
    progress_percentage: 0,
    message: "Loading your profile progress...",
  });

  const effectRan = useRef(false);

  // --- REFACTORED: useEffect now uses the single dashboard API ---
  useEffect(() => {
    if (effectRan.current === true) {
      return;
    }

    const token = localStorage.getItem("access_token");
    if (!token) {
      setMainDataLoading(false);
      setProfileProgressLoading(false);
      navigate("/db-shiksha/gatep/login");
      return;
    }

    const fetchDashboardData = async () => {
      setMainDataLoading(true);
      try {
        const response = await apiClient.get("/talent/dashboard/");
        const {
          dashboard_counts,
          recent_applications,
          ai_job_recommendations,
        } = response.data;

        setDashboardStats(dashboard_counts);
        setApplications(recent_applications || []);
        setRecommendations(ai_job_recommendations || []);
      } catch (error) {
        console.error("Failed to fetch dashboard data:", error);
        // Set empty states on error to prevent crashes
        setDashboardStats({
          active_applications: 0,
          job_matches: 0,
          job_notifications: 0,
        });
        setApplications([]);
        setRecommendations([]);
      } finally {
        // Added a small delay for a smoother loading transition
        setTimeout(() => setMainDataLoading(false), 800);
      }
    };

    const fetchProfileProgress = async () => {
      setProfileProgressLoading(true);
      try {
        const progressResponse = await apiClient.get("/resume-progress/");
        if (progressResponse.data) {
          setProfileProgress(progressResponse.data);
        }
      } catch (error) {
        console.error("Failed to fetch profile progress data:", error);
      } finally {
        setProfileProgressLoading(false);
      }
    };

    fetchDashboardData();
    fetchProfileProgress();

    return () => {
      effectRan.current = true;
    };
  }, [navigate]); // navigate is stable but good practice to include

  // --- MODIFIED: Fetches full job details on-demand ---
  const handleViewDetails = async (jobId) => {
    setSelectedJobDetails(null); // Clear previous details
    setIsDetailsModalOpen(true);
    try {
      const response = await apiClient.get(`/job-postings/${jobId}/`);
      setSelectedJobDetails(response.data);
    } catch (error) {
      console.error(`Failed to fetch job details for ID ${jobId}:`, error);
      // Optionally show an error message to the user
      handleCloseDetailsModal(); // Close modal on error
    }
  };

  const handleCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
    setSelectedJobDetails(null);
  };

  const handleQuickApply = async (jobId) => {
    setApplyingJobId(jobId);
    try {
      const response = await apiClient.post("/applications/", {
        job_posting: jobId,
      });
      // Assuming the apply endpoint response doesn't give full details,
      // for now, we just update the applied state for the button.
      // A more robust solution would be to refetch recommendations or applications.
      // For instant feedback, we'll manually mark it as applied.
      const appliedJob = recommendations.find((rec) => rec.id === jobId);
      if (appliedJob) {
        setApplications((prev) => [
          {
            job_title: appliedJob.title,
            company_name: appliedJob.company_name,
            status: "Applied",
          },
          ...prev,
        ]);
        // Also update the dashboard count for immediate feedback
        if (dashboardStats) {
          setDashboardStats((prev) => ({
            ...prev,
            active_applications: prev.active_applications + 1,
          }));
        }
      }
    } catch (error) {
      console.error("Failed to quick apply:", error);
      // Optionally show an error toast to the user
    } finally {
      setApplyingJobId(null);
    }
  };

  // --- MODIFIED: Stats data is now built from API response ---
  const statsData =
    mainDataLoading || !dashboardStats
      ? []
      : [
          {
            label: "Active Applications",
            value: dashboardStats.active_applications,
            blobColor: theme.palette.warning.light,
          },
          {
            label: "Job Matches",
            value: dashboardStats.job_matches,
            blobColor: theme.palette.error.light,
          },
          {
            label: "Job Notification",
            value: dashboardStats.job_notifications,
            blobColor: theme.palette.info.light,
          },
        ];

  return (
    <Layout title="Talent Dashboard">
      <Container
        maxWidth={false}
        sx={{ py: { xs: 2, md: 4 }, fontFamily: "'Poppins', sans-serif" }}
      >
        <Stack spacing={{ xs: 3, md: 4 }}>
          {/* Welcome Card: Uses its own loading state */}
          {profileProgressLoading ? (
            <WelcomeCardSkeleton />
          ) : (
            <Card
              elevation={0}
              sx={{
                p: { xs: 2, md: 3 },
                borderRadius: "24px",
                background: theme => theme.palette.mode === 'dark' 
                  ? `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.2)} 0%, ${alpha(theme.palette.background.paper, 0.9)} 100%)`
                  : `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${theme.palette.background.paper} 100%)`,
                border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                boxShadow: (theme) => `0 4px 20px ${alpha(theme.palette.common.black, 0.1)}`,
              }}
            >

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                alignItems="center"
              >
                <Avatar
                  src="/placeholder.svg?height=60&width=60"
                  sx={{ width: 60, height: 60 }}
                />
                {profileProgress.progress_percentage === 100 ? (
                  <>
                    <Box
                      flexGrow={1}
                      sx={{
                        width: "100%",
                        textAlign: { xs: "center", sm: "left" },
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{ fontWeight: "bold", color: "text.primary" }}
                      >
                        Your Profile is Complete! What's Next ..?
                      </Typography>
                      <Typography
                        sx={{
                          color: "text.primary",
                          fontSize: "1.2rem",
                          mt: 0.5,
                        }}
                      >
                        Take a mock interview to verify your skills and earn
                        your official Skillspassport.
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => navigate("/db-shiksha/gatep/talent/exam-intro")}
                      sx={{
                        borderRadius: "20px",
                        textTransform: "none",
                        fontWeight: 600,
                        px: 3,
                        py: 1,
                        flexShrink: 0, // Prevents button from shrinking
                      }}
                    >
                      Start Mock Interview
                    </Button>
                  </>
                ) : profileProgress.message === "Resume not found." ? (
                  <>
                    <Box
                      flexGrow={1}
                      sx={{
                        width: "100%",
                        textAlign: { xs: "center", sm: "left" },
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{ fontWeight: "bold", color: "text.primary" }}
                      >
                        Let's Build Your Profile!
                      </Typography>
                      <Typography
                        sx={{
                          color: "text.primary",
                          fontSize: "1.1rem",
                          mt: 0.5,
                        }}
                      >
                        Upload your resume to get started and unlock
                        personalized job matches.
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => navigate("/db-shiksha/gatep/talent/profile")}
                      sx={{
                        borderRadius: "20px",
                        textTransform: "none",
                        fontWeight: 600,
                        px: 3,
                        py: 1,
                      }}
                    >
                      Create Profile
                    </Button>
                  </>
                ) : (
                  <>
                    <Box
                      flexGrow={1}
                      sx={{
                        width: "100%",
                        textAlign: { xs: "center", sm: "left" },
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{ fontWeight: "bold", color: "text.primary" }}
                      >
                        Welcome Back!
                      </Typography>
                      <Typography
                        sx={{ color: "text.primary", fontSize: "0.9rem" }}
                      >
                        {profileProgress.message}
                      </Typography>
                      <Stack
                        direction="row"
                        spacing={2}
                        alignItems="center"
                        sx={{ mt: 1 }}
                      >
                        <LinearProgress
                          variant="determinate"
                          value={profileProgress.progress_percentage || 0}
                          sx={{
                            flexGrow: 1,
                            height: 10,
                            borderRadius: "5px",
                            bgcolor: alpha(theme.palette.primary.main, 0.1),
                            "& .MuiLinearProgress-bar": {
                              background: `linear-gradient(90deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
                              borderRadius: "5px",
                            },
                          }}
                        />

                        <Typography
                          sx={{
                            fontWeight: "bold",
                            color: "primary.main",
                            fontSize: "0.9rem",
                          }}
                        >
                          {profileProgress.progress_percentage || 0}% Profile
                          Completed
                        </Typography>
                      </Stack>
                    </Box>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => navigate("/db-shiksha/gatep/talent/profile")}
                      sx={{
                        borderRadius: "20px",
                        textTransform: "none",
                        fontWeight: 600,
                        px: 3,
                        py: 1,
                      }}
                    >
                      Complete Profile
                    </Button>
                  </>
                )}
              </Stack>
            </Card>
          )}

          {/* Stats Cards: Uses the main data loading state */}
          {mainDataLoading ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: { xs: 1.5, sm: 2, md: 3 },
              }}
            >
              {[...Array(3)].map((_, index) => (
                <StatCardSkeleton key={index} />
              ))}
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: { xs: 1.5, sm: 2, md: 3 },
              }}
            >
              {statsData.map((stat, index) => (
                <StatCard key={index} {...stat} />
              ))}
            </Box>
          )}

          {/* Recent Applications: Uses the main data loading state */}
          {mainDataLoading ? (
            <SectionSkeleton
              titleWidth={250}
              items={4}
              CardSkeletonComponent={RecentApplicationSkeletonCard}
            />
          ) : (
            <Card
              elevation={0}
              sx={{
                p: { xs: 2, md: 3 },
                borderRadius: "24px",
                bgcolor: "background.paper",
                border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                boxShadow: (theme) =>
                  `0 8px 32px ${alpha(theme.palette.common.black, 0.08)}`,
              }}
            >

              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  color: "text.primary",
                  mb: 2,
                }}
              >
                Recent Application
              </Typography>
              {applications.length > 0 ? (
                <Stack
                  direction="row"
                  spacing={2.5}
                  sx={{
                    overflowX: "auto",
                    pb: 1,
                    "&::-webkit-scrollbar": { display: "none" },
                    "-ms-overflow-style": "none",
                    "scrollbar-width": "none",
                  }}
                >
                  {applications.slice(0, 8).map((app, index) => (
                    <Card
                      key={`${app.job_title}-${index}`}
                      elevation={0}
                      sx={{
                        p: 2.5,
                        borderRadius: "20px",
                        bgcolor: "background.paper",
                        border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
                        position: "relative",
                        overflow: "hidden",
                        minWidth: { xs: 280, sm: 320 },
                        flexShrink: 0,
                        transition: "all 0.25s ease",
                        "&:hover": { transform: "translateY(-3px)", border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.35)}` },
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          width: 120,
                          height: 120,
                          borderRadius: "50%",
                          background: `radial-gradient(circle, ${alpha(theme.palette.primary.main, 0.1)} 0%, transparent 70%)`,
                          top: -40,
                          right: -20,
                          zIndex: 0,
                        }}
                      />

                      <Stack
                        spacing={2}
                        justifyContent="space-between"
                        sx={{ position: "relative", zIndex: 1 }}
                      >
                        <Stack
                          direction="row"
                          spacing={1.5}
                          alignItems="center"
                        >
                          <Avatar
                            sx={{
                              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
                              border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                              width: 44,
                              height: 44,
                            }}
                          >
                            <WorkOutline sx={{ color: "primary.main", fontSize: 22 }} />
                          </Avatar>
                          <Box>
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                fontSize: "18px",
                                color: "text.primary",
                                lineHeight: 1.2,
                              }}
                            >
                              {app.job_title}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "14px",
                                color: "text.secondary",
                                display: "flex",
                                alignItems: "center",
                                mt: 0.5,
                              }}
                            >
                              <LocationOn sx={{ fontSize: "16px", mr: 0.5 }} />
                              {app.company_name}
                            </Typography>
                          </Box>
                        </Stack>
                        <Box sx={{ alignSelf: "flex-end" }}>
                          <Chip
                            label={app.status}
                            size="small"
                            sx={{
                              bgcolor:
                                app.status === "Applied"
                                  ? (theme) => alpha(theme.palette.success.main, 0.15)
                                  : (theme) => alpha(theme.palette.primary.main, 0.12),
                              color:
                                app.status === "Applied" ? "success.light" : "primary.main",
                              borderRadius: "10px",
                              fontWeight: 700,
                              fontSize: "0.72rem",
                              border: (theme) =>
                                app.status === "Applied"
                                  ? `1px solid ${alpha(theme.palette.success.main, 0.3)}`
                                  : `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                            }}
                          />
                        </Box>
                      </Stack>
                    </Card>
                  ))}
                </Stack>
              ) : (
                <EmptyState
                  icon={<FindInPage sx={{ color: "primary.main" }} />}
                  title="No Recent Applications"
                  description="When you apply for jobs, they will appear here for you to track."
                />
              )}
              <Box sx={{ textAlign: "center", pt: 3 }}>
                <Button
                  endIcon={<ArrowForward />}
                  color="primary"
                  variant="contained"
                  onClick={() => navigate("/db-shiksha/gatep/talent/jobs")}
                  sx={{
                    borderRadius: "30px",
                    textTransform: "none",
                    fontWeight: "bold",
                    fontSize: "14px",
                    height: "40px",
                    px: 4,
                    width: "100%",
                    maxWidth: "350px",
                    mx: "auto",
                  }}
                >
                  View All Recent Application
                </Button>
              </Box>
            </Card>
          )}

          {/* AI Recommendations: Uses the main data loading state */}
          {mainDataLoading ? (
            <SectionSkeleton
              titleWidth={280}
              items={4}
              CardSkeletonComponent={JobRecommendationSkeletonCard}
            />
          ) : (
            <Card
              elevation={0}
              sx={{
                p: { xs: 2, md: 3 },
                borderRadius: "24px",
                bgcolor: "background.paper",
                border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                boxShadow: (theme) =>
                  `0 8px 32px ${alpha(theme.palette.common.black, 0.08)}`,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >

              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", color: "text.primary", mb: 3 }}
              >
                AI Job Recommendations
              </Typography>
              {recommendations.length > 0 ? (
                <Stack
                  direction="row"
                  spacing={2.5}
                  sx={{
                    overflowX: "auto",
                    pb: 2,
                    "&::-webkit-scrollbar": { display: "none" },
                    "-ms-overflow-style": "none",
                    "scrollbar-width": "none",
                  }}
                >
                  {recommendations.slice(0, 6).map((rec) => {
                    const isApplying = applyingJobId === rec.id;
                    const isAlreadyApplied = applications.some(
                      (app) =>
                        app.job_title === rec.title &&
                        app.company_name === rec.company_name
                    );
                    const displaySkills = rec.required_skills.slice(0, 3);
                    const remainingSkills =
                      rec.required_skills.length - displaySkills.length;
                    return (
                      <Card
                        key={rec.id}
                        elevation={0}
                        sx={{
                          p: 2.5,
                          borderRadius: "20px",
                          border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
                          bgcolor: "background.paper",
                          display: "flex",
                          flexDirection: "column",
                          gap: 1.5,
                          width: { xs: 300, sm: 360 },
                          flexShrink: 0,
                          transition: "all 0.25s ease",
                          "&:hover": { transform: "translateY(-3px)", border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.35)}` },
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="flex-start"
                        >
                          <Stack
                            direction="row"
                            spacing={1.5}
                            alignItems="center"
                          >
                            <Avatar
                              variant="circular"
                              sx={{
                                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
                                border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                                width: 44,
                                height: 44,
                              }}
                            >
                              <WorkOutline sx={{ color: "primary.main", fontSize: 22 }} />
                            </Avatar>
                            <Box sx={{ minHeight: "54px" }}>
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                  color: "text.primary",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "-webkit-box",
                                  WebkitLineClamp: "2",
                                  WebkitBoxOrient: "vertical",
                                }}
                              >
                                {rec.title}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  color: "text.secondary",
                                }}
                              >
                                {rec.company_name}
                              </Typography>
                            </Box>
                          </Stack>
                          <Stack alignItems="flex-end" spacing={1}>
                            {rec.urgent && (
                              <Chip
                                label="Urgent Hiring"
                                size="small"
                                sx={{
                                  bgcolor: alpha(
                                    theme.palette.warning.main,
                                    0.2
                                  ),
                                  color: "warning.dark",
                                  fontWeight: 500,
                                  borderRadius: "16px",
                                  height: "auto",
                                  ".MuiChip-label": { py: "2px", px: "8px" },
                                }}
                              />
                            )}
                            <IconButton size="small">
                              <BookmarkBorder />
                            </IconButton>
                          </Stack>
                        </Stack>
                        <Stack spacing={0.5}>
                          <Stack direction="row" spacing={1}>
                            <LocationOn
                              sx={{
                                fontSize: "16px",
                                color: "text.secondary",
                                mt: "2px",
                              }}
                            />
                            <Typography
                              sx={{
                                fontSize: "14px",
                                color: "text.secondary",
                              }}
                            >
                              {rec.location}
                            </Typography>
                            {rec.visa_sponsorship && (
                              <Chip
                                label="Visa Sponsored"
                                size="small"
                                sx={{
                                  bgcolor: alpha(
                                    theme.palette.primary.main,
                                    0.15
                                  ),
                                  color: "primary.main",
                                  fontWeight: 500,
                                  borderRadius: "8px",
                                  height: "auto",
                                  ".MuiChip-label": { py: "1px" },
                                }}
                              />
                            )}
                          </Stack>
                          <Stack direction="row" spacing={1}>
                            <AttachMoney
                              sx={{
                                fontSize: "16px",
                                color: "text.secondary",
                                mt: "2px",
                              }}
                            />
                            <Typography
                              sx={{
                                fontSize: "14px",
                                color: "text.secondary",
                              }}
                            >{`$${(rec.salary_min / 1000).toFixed(0)}k-$${(
                              rec.salary_max / 1000
                            ).toFixed(0)}k`}</Typography>
                            <WorkOutline
                              sx={{
                                fontSize: "16px",
                                color: "text.secondary",
                                mt: "2px",
                                ml: 1,
                              }}
                            />
                            <Typography
                              sx={{
                                fontSize: "14px",
                                color: "text.secondary",
                              }}
                            >
                              {rec.job_type}
                            </Typography>
                          </Stack>
                          <Stack direction="row" spacing={1}>
                            <AccessTime
                              sx={{
                                fontSize: "16px",
                                color: "text.secondary",
                                mt: "2px",
                              }}
                            />
                            <Typography
                              sx={{
                                fontSize: "14px",
                                color: "text.secondary",
                              }}
                            >
                              {new Date(
                                rec.application_deadline
                              ).toLocaleDateString()}
                            </Typography>
                          </Stack>
                        </Stack>
                        <Box>
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: 600,
                                color: "text.primary",
                              }}
                            >
                              AI Match Score
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "success.main",
                              }}
                            >
                              {rec.matching_percentage}%
                            </Typography>
                          </Stack>
                          <LinearProgress
                            variant="determinate"
                            value={rec.matching_percentage}
                            sx={{
                              mt: 0.5,
                              height: 7,
                              borderRadius: 4,
                              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                              "& .MuiLinearProgress-bar": {
                                bgcolor: "primary.main",
                                borderRadius: 4,
                              },
                            }}
                          />
                        </Box>
                        <Box sx={{ minHeight: "68px" }}>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              color: "text.secondary",
                              mb: 1,
                            }}
                          >
                            Required Skills
                          </Typography>
                          <Stack
                            direction="row"
                            useFlexGap
                            flexWrap="wrap"
                            spacing={1}
                          >
                            {displaySkills.map((skill, index) => (
                              <Chip
                                key={`${skill}-${index}`}
                                label={skill}
                                variant="outlined"
                                size="small"
                              />
                            ))}
                            {remainingSkills > 0 && (
                              <Chip
                                label={`+${remainingSkills}`}
                                size="small"
                                sx={{
                                  bgcolor: "primary.light",
                                  color: "primary.main",
                                  borderRadius: "50%",
                                  fontWeight: "bold",
                                }}
                              />
                            )}
                          </Stack>
                        </Box>
                        <Stack
                          direction="row"
                          spacing={1.5}
                          sx={{ mt: "auto", pt: 2 }}
                        >
                          <Button
                            fullWidth
                            variant="outlined"
                            color="primary"
                            onClick={() => handleViewDetails(rec.id)}
                            sx={{
                              borderRadius: "30px",
                              textTransform: "none",
                              fontWeight: 600,
                            }}
                          >
                            View Details
                          </Button>
                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={() => handleQuickApply(rec.id)}
                            disabled={isApplying || isAlreadyApplied}
                            sx={{
                              borderRadius: "30px",
                              boxShadow: "none",
                              textTransform: "none",
                              fontWeight: 600,
                            }}
                          >
                            {isApplying ? (
                              <CircularProgress size={24} color="inherit" />
                            ) : isAlreadyApplied ? (
                              "Applied"
                            ) : (
                              "Quick Apply"
                            )}
                          </Button>
                        </Stack>
                      </Card>
                    );
                  })}
                </Stack>
              ) : (
                <EmptyState
                  icon={<TrendingUp sx={{ color: "primary.main" }} />}
                  title="No Job Recommendations Yet"
                  description="Complete your profile and upload your resume to receive AI-powered job recommendations tailored just for you."
                  action={
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => navigate("/gatep/talent/profile")}
                      sx={{
                        borderRadius: "30px",
                        textTransform: "none",
                        fontWeight: 600,
                      }}
                    >
                      Complete Your Profile
                    </Button>
                  }
                />
              )}
              <Box sx={{ textAlign: "center", pt: 3, mt: "auto" }}>
                <Button
                  endIcon={<ArrowForward />}
                  color="primary"
                  variant="contained"
                  onClick={() => navigate("/gatep/talent/jobs")}
                  sx={{
                    borderRadius: "30px",
                    textTransform: "none",
                    fontWeight: "bold",
                    fontSize: "14px",
                    height: "40px",
                    px: 4,
                    width: "100%",
                    maxWidth: "350px",
                    mx: "auto",
                  }}
                >
                  View All AI JOB Recomendation
                </Button>
              </Box>
            </Card>
          )}
        </Stack>
        <JobDetailsModal
          open={isDetailsModalOpen}
          onClose={handleCloseDetailsModal}
          job={selectedJobDetails}
        />
      </Container>
    </Layout>
  );
};

export default TalentDashboard;
